var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { j as jsxRuntimeExports, c as cn, C as CloseIcon, T as TickIcon, L as Link, u as useUrlWithUtmQuery, M as Modal$1, a as ModalContent, b as LoadingSkeleton, d as useEmblaCarousel, B as Button$1, e as Collapsible, f as CollapsibleTrigger, g as CollapsibleContent, h as useCollapsibleController, i as CrossIcon, P as Popover$1, k as PopoverTrigger, l as PopoverContent, m as composeRefs, n as createContextScope, o as useComposedRefs, p as useDirection, q as Presence, r as composeEventHandlers, s as useCallbackRef, t as useLayoutEffect2, I as InputWrapper, v as Input, w as Badge$1, x as CartIcon, S as StickyTrigger } from "./Cart-DhZkShd2.mjs";
import * as React from "react";
import { forwardRef, useState, useMemo, useRef, useEffect, Fragment, useCallback, createContext, useContext, useLayoutEffect, createElement } from "react";
import { RadioGroup as RadioGroup$1, Switch as Switch$1, Transition, Dialog, Disclosure, Menu, Popover } from "@headlessui/react";
import useSWR from "swr";
import deepmerge from "deepmerge";
import { useInView } from "react-intersection-observer";
import { nanoid } from "nanoid";
import { useIdleTimer } from "react-idle-timer";
import "react-dom";
const logger = {
  error(...data) {
    console.error("[acm:error]", ...data);
  },
  warn(...data) {
    console.warn("[acm:warning]", ...data);
  },
  info(...data) {
    console.info("[acm:info]", ...data);
  },
  debug(...data) {
    console.debug("[acm:debug]", ...data);
  }
};
function gtmPush(event) {
  if (globalThis.window !== void 0) {
    if (window.dataLayer === void 0) {
      logger.warn("GTM container not loaded");
      window.dataLayer = [];
    }
    window.dataLayer.push(event);
  }
}
function isApiResponse(data) {
  return typeof data === "object" && data !== null && "response" in data;
}
function isErrorResponse(data) {
  return isApiResponse(data) && typeof data.response === "object" && // `response` should be a non-null object
  data.response !== null && "errors" in data.response && // `errors` array should exist
  Array.isArray(data.response.errors) && data.response.errors.length === 1 && // `errors` array can only contain one element
  data.response.errors[0].errorCode !== void 0;
}
function getErrorResponse(data) {
  if (!isErrorResponse(data)) return null;
  return data.response.errors[0];
}
async function fetcher(input, init, formatError) {
  const result = await fetch(input, {
    ...init,
    headers: {
      ...init == null ? void 0 : init.headers,
      "Content-Type": "application/json"
    }
  });
  const response = await result.json();
  if (!result.ok) {
    const errorResponse = getErrorResponse(response);
    if (!formatError) {
      throw new Error(errorResponse ? `${errorResponse.errorTitle} [${errorResponse.errorCode}]` : "Unknown error");
    } else {
      formatError(response);
    }
  }
  const { response: data } = response;
  return data;
}
function startChatbotSession(username) {
  var _a;
  if (window.sendToCIChatbot) {
    (_a = window.sendToCIChatbot) == null ? void 0 : _a.call(window, {
      name: "logged-in",
      value: {
        firstName: username,
        lastName: ""
      }
    });
  }
}
function endChatbotSession() {
  var _a;
  if (window.sendToCIChatbot) {
    (_a = window.sendToCIChatbot) == null ? void 0 : _a.call(window, { name: "logged-out" });
  }
}
function satayCase(name) {
  return name.trim().toLowerCase().replace(/[\W_]/g, "-").replace(/--+/g, "-");
}
function createBemName(block, ...elements) {
  return [block, ...elements].filter(Boolean).map(satayCase).join("__");
}
function interpolate(inputStr, params) {
  let str = inputStr;
  for (const [key, value] of Object.entries(params)) {
    const regex = RegExp(`{${key}}`, "g");
    let matches;
    while ((matches = regex.exec(str)) !== null) str = str.replace(matches[0], `${value ?? ""}`);
  }
  return str;
}
function normalizeElementsHeight(targetElementClass) {
  const elements = document.querySelectorAll(`.${targetElementClass}`);
  const elementsHeight = Array.from(elements).map((element) => element.clientHeight);
  const isHeightDifferent = elementsHeight.find((h) => h !== elementsHeight[0]);
  if (isHeightDifferent) {
    const highestElement = Math.max(...elementsHeight);
    elements.forEach((el) => {
      el.style.setProperty("height", `${highestElement}px`);
    });
  }
}
const SUPPORTED_LOCALES = ["en", "bm"];
const DEFAULT_LOCALE = "en";
const LOCALE_COOKIE = "acm_locale";
const ACCESS_TOKEN_COOKIE = "acm_ulm_access_token";
const REFRESH_TOKEN_COOKIE = "acm_ulm_refresh_token";
const ULM_UUID_COOKIE = "acm_ulm_uuid";
const ULM_EPUID_COOKIE = "AstroUlmEPUID";
const ULM_PAYLOAD_COOKIE = "acm_ulm_payload";
const ULM_HANDLER_TRIGGERED_COOKIE = "acm_ulm_handler_triggered";
const BANNER_DISMISSED_COOKIE = "acm_banner_dismissed";
const MODAL_BANNER_DISMISSED_COOKIE = "acm_modal_banner_dismissed";
const CHATBOT_USER_INFO = "ci-user-info";
const ABANDONED_CART_COOKIE = "acm_abandoned_cart";
const LOGIN_URL_EVENT = "login_url";
const ULM_PROFILE_EVENT = "ulm_profile";
const LOCALE_EVENT = "acm_locale";
const NAV_TAG = "acm_nav";
const UPDATE_CART_EVENT = "update_cart";
function convertLocale$1(locale = DEFAULT_LOCALE) {
  const localeMapping = {
    en: "eng",
    bm: "may"
  };
  return localeMapping[locale];
}
function getCookie(name) {
  if (globalThis.document === void 0) return null;
  try {
    const allCookies = decodeURIComponent(document.cookie).split(";").map((c) => c.trimStart());
    const cookie = allCookies.find((c) => c.startsWith(`${name}=`));
    return (cookie == null ? void 0 : cookie.split("=")[1]) ?? null;
  } catch (e) {
    return null;
  }
}
function getCookieDomain(url) {
  const match = url.match(/(astro\.com\.my|pink\.cat)/);
  return match ? `.${match[0]}` : void 0;
}
function removeCookie(name, domain) {
  if (globalThis.document !== void 0)
    document.cookie = [`${name}=`, `expires=Thu, 01 Jan 1970 00:00:01 GMT`, `path=/`, domain && `domain=${domain}`].filter(Boolean).join(";");
}
function removeCookies(cookies, domain) {
  cookies.forEach((cookie) => {
    if (typeof cookie === "string") removeCookie(cookie, domain);
    else removeCookie(cookie.name, cookie.domain ?? domain);
  });
}
function getExpiryUtcString(minutes) {
  const expiry = new Date(Date.now() + minutes * 60 * 1e3);
  return expiry.toUTCString();
}
function setCookie(name, value, minutesOrUtcExpiry, base64Encoded = false, domain, secure) {
  if (globalThis.document !== void 0) {
    const expires = typeof minutesOrUtcExpiry === "number" ? getExpiryUtcString(minutesOrUtcExpiry) : minutesOrUtcExpiry;
    document.cookie = [
      `${name}=${base64Encoded ? btoa(String(value)) : value}`,
      `expires=${expires}`,
      `path=/`,
      domain && `domain=${domain}`,
      secure && `secure`
    ].filter(Boolean).join(";");
  }
}
function extractConfig(configKey, data) {
  var _a;
  return ((_a = data.config.find(({ key }) => key === configKey)) == null ? void 0 : _a.value) ?? null;
}
function combineMerge(base, locale, options) {
  const result = base.slice();
  locale.forEach((item, index) => {
    if (typeof result[index] === "undefined") {
      result[index] = options.cloneUnlessOtherwiseSpecified(item, options);
    } else {
      result[index] = options.isMergeableObject(item) ? deepmerge(base[index], item, { arrayMerge: combineMerge }) : item;
    }
  });
  return result;
}
function mergeLocale(base, locale = {}) {
  return deepmerge(base, locale, { arrayMerge: combineMerge });
}
function isSupportedLocale(code) {
  return typeof code === "string" && SUPPORTED_LOCALES.includes(code);
}
function toggleLocale(locale) {
  if (!isSupportedLocale(locale)) return null;
  window.dispatchEvent(new CustomEvent(LOCALE_EVENT, { detail: locale }));
  setCookie(LOCALE_COOKIE, locale, 5e5, false, getCookieDomain(window.location.hostname));
  return locale;
}
function resizeImage(src, options) {
  const trParams = Object.entries(options).map(([key, value]) => `${key}-${value}`);
  return `https://resizer-acm.eco.astro.com.my${trParams.length ? `/tr:${trParams.join(",")}` : ""}/${src}`;
}
function dispatchUlmProfileEvent(detail) {
  window.dispatchEvent(new CustomEvent(ULM_PROFILE_EVENT, { detail }));
}
function hasExistingSession() {
  const accessToken = getCookie(ACCESS_TOKEN_COOKIE);
  const refreshToken = getCookie(REFRESH_TOKEN_COOKIE);
  return Boolean(accessToken || refreshToken);
}
function initLoginUrl(params, sessionId = "") {
  const { endpoint, queryParams = {} } = params;
  const searchParams = Object.entries(queryParams).reduce((acc, [key, value]) => {
    if (key === "state") {
      const ulmUuid = getCookie(ULM_UUID_COOKIE) ?? sessionId;
      const state = encodeURIComponent(value).replace("DEVICE_ID_REPLACER", ulmUuid).replace("LOCATION_REPLACER", "{location}");
      acc.push(`state=${state}`);
    } else {
      acc.push(`${key}=${encodeURIComponent(value)}`);
    }
    return acc;
  }, []);
  const constructedUrl = endpoint + (searchParams.length ? `?${searchParams.join("&")}` : "");
  window.dispatchEvent(new CustomEvent(LOGIN_URL_EVENT, { detail: constructedUrl }));
  return constructedUrl;
}
function isUlmProfile(profile) {
  return typeof profile === "object" && profile !== null && "ulmProfileToken" in profile;
}
function logout() {
  const domain = getCookieDomain(window.location.hostname);
  removeCookies(
    [ACCESS_TOKEN_COOKIE, REFRESH_TOKEN_COOKIE, ULM_PAYLOAD_COOKIE, ULM_UUID_COOKIE, ULM_EPUID_COOKIE],
    domain
  );
  dispatchUlmProfileEvent();
}
const getTokenExpiry = (token) => {
  const base64Url = token.split(".")[1];
  if (!base64Url) return null;
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const payload = JSON.parse(window.atob(base64));
  if ("exp" in payload) {
    return payload.exp;
  }
  return null;
};
async function refreshSession({ client, endpoints, payload, refreshSessionExpiry = 3600, startSessionExpiry }, isChatbotConfiguredToBeShown = true, sessionId = "") {
  const domain = getCookieDomain(window.location.hostname);
  const accessToken = getCookie(ACCESS_TOKEN_COOKIE);
  const refreshToken = getCookie(REFRESH_TOKEN_COOKIE);
  const ulmUuidCookie = getCookie(ULM_UUID_COOKIE);
  const ulmUuid = ulmUuidCookie ?? sessionId;
  if (!ulmUuidCookie) setCookie(ULM_UUID_COOKIE, sessionId, refreshSessionExpiry, false, domain, true);
  let profile = null;
  const ulmCookies = [ULM_PAYLOAD_COOKIE, ULM_UUID_COOKIE, ULM_EPUID_COOKIE];
  try {
    if (accessToken && endpoints.getUser) {
      ulmCookies.push(ACCESS_TOKEN_COOKIE);
      const { ulm, ulmProfileToken = "" } = await fetcher(endpoints.getUser, {
        method: "POST",
        headers: { Authorization: accessToken }
      });
      setCookie(ULM_PAYLOAD_COOKIE, payload, refreshSessionExpiry, false, domain, true);
      profile = { ...ulm, ulmProfileToken };
    } else if (refreshToken && endpoints.refresh) {
      ulmCookies.push(REFRESH_TOKEN_COOKIE);
      const {
        token = "",
        refreshToken: newRefreshToken = "",
        ulm,
        ulmProfileToken = ""
      } = await fetcher(endpoints.refresh, {
        method: "POST",
        headers: {
          Authorization: refreshToken,
          Client: client,
          "Device-Id": ulmUuid,
          "Ulm-Redirect-Uri": window.location.href
        }
      });
      const refreshTokenExpiry = getTokenExpiry(newRefreshToken);
      const refreshTokenUtcExpiry = new Date(refreshTokenExpiry * 1e3).toUTCString();
      setCookie(REFRESH_TOKEN_COOKIE, newRefreshToken, refreshTokenUtcExpiry, false, domain, true);
      setCookie(ACCESS_TOKEN_COOKIE, token, startSessionExpiry, false, domain, true);
      setCookie(ULM_PAYLOAD_COOKIE, payload, refreshSessionExpiry, false, domain, true);
      profile = { ...ulm, ulmProfileToken };
      ulmCookies.push(ACCESS_TOKEN_COOKIE);
    } else {
      removeCookies(ulmCookies, domain);
      if (isChatbotConfiguredToBeShown) endChatbotSession();
    }
  } catch (e) {
    logger.error(e);
    removeCookies(ulmCookies, domain);
    if (isChatbotConfiguredToBeShown) endChatbotSession();
  }
  dispatchUlmProfileEvent(profile ?? void 0);
  return profile;
}
class AbandonedCartEvent extends CustomEvent {
  constructor(event, detail) {
    super(event, { detail });
  }
}
function updateCart(value, shouldRefetchAbandonedCart = false) {
  const minutesOrUtcExpiry = 60 * 24 * 7;
  setCookie(
    ABANDONED_CART_COOKIE,
    JSON.stringify({
      lastFourDigit: value.lastFourDigit,
      leadId: value.leadId
    }),
    minutesOrUtcExpiry,
    false,
    getCookieDomain(window.location.hostname)
  );
  const event = new AbandonedCartEvent(UPDATE_CART_EVENT, { ...value, shouldRefetchAbandonedCart });
  window.dispatchEvent(event);
}
const resetCart = () => {
  removeCookie(ABANDONED_CART_COOKIE, getCookieDomain(window.location.hostname));
  const event = new AbandonedCartEvent(UPDATE_CART_EVENT, null);
  window.dispatchEvent(event);
};
const Badge = ({ children, className, size = "small", variant = "magenta1", ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "span",
  {
    className: cn(
      "inline-flex items-center rounded-full px-2 align-middle text-xs font-bold",
      size === "medium" && "px-3 py-[3px]",
      size === "large" && "px-4 py-[6px] text-sm",
      variant === "magenta1" && "bg-gradient-magenta1 text-white",
      variant === "magenta2" && "bg-gradient-magenta2 text-white",
      variant === "gray" && "bg-neutral-200 text-neutral-600",
      variant === "yellow" && "bg-yellow text-black",
      className
    ),
    ...props,
    children
  }
);
const Callout = ({ children, className, icon, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: cn("flex items-center rounded bg-gradient-lime p-4", className), ...props, children: [
  icon && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mr-4", children: icon }),
  children
] });
const HtmlText = ({ as: Wrapper = "p", text, ...props }) => (
  // eslint-disable-next-line react/no-danger
  /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper, { dangerouslySetInnerHTML: { __html: text }, ...props })
);
const Status = ({ children, className, icon, status, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: cn(
      "py-4 lg:py-6",
      status === "error" && "bg-red-200 text-red",
      status === "warning" && "bg-yellow-200 text-orange",
      status === "success" && "bg-lime-200 text-green",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "container flex items-center", children: [
      icon && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "mr-4", children: icon }),
      children
    ] })
  }
);
const AccountIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: 20, height: 20, ...props, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fill: "none", d: "M0 0h20v20H0z" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      fill: "currentcolor",
      d: "M17.2 18a.8.8 0 01-.795-.706l-.009-.235a2.4 2.4 0 00-2.255-2.259H6a2.4 2.4 0 00-2.4 2.4.8.8 0 01-1.6 0 4 4 0 013.827-4H14a4 4 0 014 4 .8.8 0 01-.8.8zM10 11.6a4.8 4.8 0 114.8-4.8 4.805 4.805 0 01-4.8 4.8zm0-8a3.2 3.2 0 103.2 3.2A3.2 3.2 0 0010 3.6z"
    }
  )
] });
const BurgerMenuIcon$1 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: 20, height: 20, ...props, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fill: "none", d: "M0 0h20v20H0z" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { fill: "currentcolor", width: "16", height: "2", rx: "1", transform: "translate(2 4)" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { fill: "currentcolor", width: "12", height: "2", rx: "1", transform: "translate(2 9)" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { fill: "currentcolor", width: "16", height: "2", rx: "1", transform: "translate(2 14)" })
] });
const LanguageIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: 20, height: 20, fill: "currentcolor", ...props, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M4.67 15.36h-.42A2.25 2.25 0 0 1 2 13.14V4.22A2.23 2.23 0 0 1 4.25 2h11.51A2.23 2.23 0 0 1 18 4.22v8.92a2.23 2.23 0 0 1-2.24 2.22h-6a2.25 2.25 0 0 0-1.72.8L6.49 18",
      fill: "none",
      stroke: "currentcolor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "m10.046 7.29-.72 1.789h1.45l-.73-1.79Zm0-3h.33l.13.07h.06l.09.069.08.09v.05l.07.14 2 4.84 1 2.42a.83.83 0 0 1-.11.82.85.85 0 0 1-1.18.14.858.858 0 0 1-.13-.14l-.07-.11-.05-.1-.78-1.9h-2.77l-.77 1.9a.83.83 0 0 1-.44.46h-.209a.84.84 0 0 1-.913-.583.78.78 0 0 1-.026-.307v-.24l1-2.39 2-4.81.08-.15.1-.12.1-.08.12-.07h.29Z" })
] });
const SearchIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: 20, height: 20, ...props, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fill: "none", d: "M0 0h20v20H0z" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M18.1 19a.9.9 0 01-.552-.189l-.085-.075-3.308-3.307A8.012 8.012 0 019.1 17.2a8.1 8.1 0 118.1-8.1 8.011 8.011 0 01-1.771 5.055l3.307 3.308A.9.9 0 0118.1 19zm-9-16.2a6.3 6.3 0 106.3 6.3 6.307 6.307 0 00-6.3-6.3z"
    }
  )
] });
const ArrowIcon = ({ className, direction, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none",
    className: cn(
      {
        "rotate-90": direction === "right",
        "-rotate-90": direction === "left",
        "rotate-180": direction === "down"
      },
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.7071 11.7071C14.3166 12.0976 13.6834 12.0976 13.2929 11.7071L8 6.41421L2.70711 11.7071C2.31658 12.0976 1.68342 12.0976 1.29289 11.7071C0.902369 11.3166 0.902369 10.6834 1.29289 10.2929L7.29289 4.29289C7.68342 3.90237 8.31658 3.90237 8.70711 4.29289L14.7071 10.2929C15.0976 10.6834 15.0976 11.3166 14.7071 11.7071Z",
        fill: "currentcolor"
      }
    )
  }
);
const PlusIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: 16, height: 16, fill: "none", ...props, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 8C1 7.44772 1.44772 7 2 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H2C1.44772 9 1 8.55228 1 8Z",
      fill: "currentcolor"
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 1C8.55228 1 9 1.44772 9 2V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V2C7 1.44772 7.44772 1 8 1Z",
      fill: "currentcolor"
    }
  )
] });
const ExploreIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { viewBox: "0 0 24 24", width: "24", height: "24", fill: "currentcolor", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M19.8098 10.75H15.4398C14.2398 10.75 13.2598 9.77001 13.2598 8.57001V4.19001C13.2598 2.99001 14.2398 2.01001 15.4398 2.01001H19.8098C21.0198 2.01001 21.9898 2.99001 21.9898 4.19001V8.56001C21.9898 9.76001 21.0098 10.74 19.8098 10.74V10.75ZM15.4398 3.88001C15.2698 3.88001 15.1298 4.02001 15.1298 4.19001V8.56001C15.1298 8.73001 15.2698 8.87001 15.4398 8.87001H19.8098C19.9798 8.87001 20.1298 8.73001 20.1298 8.56001V4.19001C20.1298 4.02001 19.9898 3.88001 19.8098 3.88001H15.4398Z",
      fill: "currentcolor"
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M8.55977 10.75H4.18977C2.97977 10.75 2.00977 9.77001 2.00977 8.57001V4.19001C2.00977 2.99001 2.98977 2.01001 4.18977 2.01001H8.55977C9.76977 2.01001 10.7398 2.99001 10.7398 4.19001V8.56001C10.7398 9.76001 9.75977 10.74 8.55977 10.74V10.75ZM4.18977 3.88001C4.01977 3.88001 3.86977 4.02001 3.86977 4.19001V8.56001C3.86977 8.73001 4.00977 8.87001 4.18977 8.87001H8.55977C8.72977 8.87001 8.87977 8.73001 8.87977 8.56001V4.19001C8.87977 4.02001 8.73977 3.88001 8.55977 3.88001H4.18977Z",
      fill: "currentcolor"
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M8.55977 22H4.18977C2.97977 22 2.00977 21.02 2.00977 19.82V15.45C2.00977 14.25 2.98977 13.27 4.18977 13.27H8.55977C9.76977 13.27 10.7398 14.25 10.7398 15.45V19.82C10.7398 21.02 9.75977 22 8.55977 22ZM4.18977 15.13C4.01977 15.13 3.86977 15.27 3.86977 15.44V19.81C3.86977 19.98 4.00977 20.12 4.18977 20.12H8.55977C8.72977 20.12 8.87977 19.98 8.87977 19.81V15.44C8.87977 15.27 8.73977 15.13 8.55977 15.13H4.18977Z",
      fill: "currentcolor"
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M18.54 22H15.43C14.23 22 13.25 21.02 13.25 19.82V15.45C13.25 14.25 14.23 13.27 15.43 13.27H19.8C21.01 13.27 21.98 14.25 21.98 15.45V18.04C21.98 18.56 21.56 18.98 21.05 18.98C20.54 18.98 20.12 18.56 20.12 18.04V15.45C20.12 15.28 19.98 15.14 19.8 15.14H15.43C15.26 15.14 15.12 15.28 15.12 15.45V19.82C15.12 19.99 15.26 20.13 15.43 20.13H18.54C19.06 20.13 19.47 20.55 19.47 21.07C19.47 21.59 19.05 22.01 18.54 22.01V22Z",
      fill: "currentcolor"
    }
  )
] });
const Button = forwardRef(
  ({ children, className, disabled, endIcon, size = "medium", startIcon, variant = "primary", ...props }, ref) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "button",
    {
      ref,
      type: "button",
      disabled,
      className: cn(
        "flex h-12 cursor-pointer items-center space-x-2 rounded-sm px-4 text-base font-bold focus-visible:outline focus-visible:outline-1 focus-visible:outline-blue disabled:cursor-default disabled:select-none",
        size === "small" && "h-8 space-x-1 text-sm",
        size === "large" && "h-14 text-xl font-extrabold",
        variant === "primary" && "bg-gradient-magenta1 text-white hover:bg-[linear-gradient(135deg,_#cf0071,_#d0283a)] disabled:bg-neutral-100 disabled:bg-none disabled:text-neutral-400 disabled:outline disabled:outline-1 disabled:-outline-offset-1 disabled:outline-neutral-300",
        variant === "secondary" && "bg-white text-magenta outline outline-1 -outline-offset-1 outline-neutral-300 hover:bg-neutral-200 disabled:text-neutral-400 disabled:hover:bg-white",
        variant === "accent" && "rounded-full bg-blue text-white hover:bg-[#14589e] focus-visible:outline-0 disabled:bg-neutral-100 disabled:text-neutral-400 disabled:outline disabled:outline-1 disabled:-outline-offset-1 disabled:outline-neutral-300",
        variant === "text" && "bg-inherit h-min p-0 font-normal text-magenta",
        className
      ),
      ...props,
      children: [
        startIcon && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: cn("h-6 w-6 flex-shrink-0", size === "small" && "h-5 w-5"), children: startIcon }),
        startIcon || endIcon ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children }) : children,
        endIcon && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: cn("h-6 w-6 flex-shrink-0", size === "small" && "h-5 w-5"), children: endIcon })
      ]
    }
  )
);
const CloseButton = forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsxRuntimeExports.jsx("button", { ref, type: "button", "aria-label": "Close", className: cn("focus-visible:outline-none", className), ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, { width: 20, height: 20 }) }));
const Checkbox = forwardRef(({ disabled, error, id, label, ...props }, ref) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "inline-flex items-center space-x-4", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "relative inline-flex h-6 w-6 p-0.5 focus-visible:outline-none", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        ref,
        type: "checkbox",
        id,
        "aria-describedby": `${id}-label`,
        className: "peer absolute inset-0 z-10 h-full w-full opacity-0",
        disabled,
        ...props
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        "aria-hidden": "true",
        className: cn(
          "h-5 w-5 rounded-xs border-2 border-transparent outline outline-1 -outline-offset-1 outline-neutral",
          disabled ? "peer-disabled:bg-neutral-200 peer-disabled:outline-neutral" : [
            "peer-focus-visible:border-blue-100 peer-focus-visible:outline-blue peer-focus-visible:peer-checked:border-transparent",
            error && "border-red-100 outline-red"
          ]
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TickIcon,
      {
        "aria-hidden": "true",
        className: "absolute left-1 top-1 hidden peer-checked:block peer-disabled:text-[#a1a1a3]"
      }
    )
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("label", { id: `${id}-label`, htmlFor: id, className: cn(disabled && "text-neutral-500"), children: label })
] }));
const IconButton = forwardRef(
  ({ className, icon, size = "medium", ...props }, ref) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button,
    {
      className: cn(
        "items-center justify-center [&>*]:h-6 [&>*]:w-6",
        size === "small" && "w-8 p-1.5 [&>*]:h-5 [&>*]:w-5",
        size === "medium" && "w-12 p-3",
        size === "large" && "w-14 p-4",
        className
      ),
      size,
      ...props,
      ref,
      children: icon
    }
  )
);
const RadioGroup = ({ disabledAll, name, onChange, options }) => {
  var _a, _b;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    RadioGroup$1,
    {
      className: "flex flex-col space-y-4",
      defaultValue: ((_a = options.find((option) => option.defaultValue)) == null ? void 0 : _a.value) ?? ((_b = options[0]) == null ? void 0 : _b.value),
      disabled: disabledAll,
      onChange,
      children: options.map(({ disabled: isDisabledOption, label, value }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        RadioGroup$1.Option,
        {
          value,
          disabled: isDisabledOption,
          className: "inline-flex items-center space-x-4 focus-visible:outline-none",
          children: ({ active, checked, disabled }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: cn("relative inline-flex h-6 w-6 p-0.5"), children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  type: "radio",
                  className: "absolute inset-0 h-full w-full opacity-0",
                  name,
                  value,
                  disabled
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "span",
                {
                  "aria-hidden": "true",
                  className: cn(
                    "h-5 w-5 rounded-full border-2 border-transparent bg-transparent outline outline-1 -outline-offset-1 outline-neutral",
                    checked && [
                      "border-0 bg-blue outline-none outline-transparent",
                      active && "outline-offset-0 outline-blue-400"
                    ],
                    disabled && "bg-neutral-200 outline-neutral"
                  )
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                TickIcon,
                {
                  "aria-hidden": "true",
                  className: cn(
                    "absolute left-1 top-1 hidden text-white",
                    checked && "block opacity-100",
                    disabled && "opacity-30"
                  )
                }
              )
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup$1.Label, { className: cn(disabled && "text-neutral-500"), children: label })
          ] })
        },
        value
      ))
    }
  );
};
function useAsync({
  endpoint,
  fetchCondition,
  formatError,
  formatResponse,
  shouldAutoRevalidate = true,
  options,
  // If false, disables auto-refetches after initial fetch, so long as a cache exists
  ...requestInit
}) {
  return useSWR(
    fetchCondition === void 0 || fetchCondition() ? endpoint : null,
    (url) => fetcher(url, requestInit).then(formatResponse),
    {
      revalidateIfStale: shouldAutoRevalidate,
      revalidateOnFocus: shouldAutoRevalidate,
      revalidateOnReconnect: shouldAutoRevalidate,
      ...options
    }
  );
}
function useDfConfig(endpoint, keys, options) {
  const configKeys = [keys].flat();
  return useAsync({
    endpoint,
    formatResponse: (response) => {
      if (typeof keys === "string") {
        const config = extractConfig(keys, response);
        if (config === null) {
          logger.error(`Missing '${keys}' DF config`);
          throw new Error(`Missing '${keys}' DF config`);
        }
        return config;
      }
      return configKeys.map((key) => extractConfig(key, response));
    },
    ...options
  });
}
function useBoolean(initialState = false) {
  const [state, setState] = useState(initialState);
  const callbacks = useMemo(
    () => ({
      on: () => setState(true),
      off: () => setState(false),
      toggle: () => setState((prev) => !prev)
    }),
    []
  );
  return [state, callbacks];
}
function useConst(init) {
  const ref = useRef(null);
  if (ref.current === null) {
    ref.current = typeof init === "function" ? init() : init;
  }
  return ref.current;
}
function getMediaQuery$1(breakpoint, direction) {
  const bpValues = {
    xs: 360,
    sm: 480,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536,
    "xs-v2": 0,
    "sm-v2": 640,
    "md-v2": 960,
    "lg-v2": 1280,
    "xl-v2": 1536
  };
  return `(${direction === "up" ? "min" : "max"}-width: ${typeof breakpoint === "number" ? breakpoint : bpValues[breakpoint]}px)`;
}
function getMatches$1(breakpoint, direction) {
  if (typeof window === void 0) return false;
  return window.matchMedia(getMediaQuery$1(breakpoint, direction)).matches;
}
function useBreakpoint(breakpoint, direction = "up") {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    const matchMedia = window.matchMedia(getMediaQuery$1(breakpoint, direction));
    const handleChange = () => setMatches(getMatches$1(breakpoint, direction));
    handleChange();
    matchMedia.addEventListener("change", handleChange);
    return () => {
      matchMedia.removeEventListener("change", handleChange);
    };
  }, [breakpoint, direction]);
  return matches;
}
function getMediaQuery(orientation) {
  return `(orientation: ${orientation})`;
}
function getMatches(orientation) {
  if (typeof window === void 0) return false;
  return window.matchMedia(getMediaQuery(orientation)).matches;
}
function useOrientation(orientation) {
  const [matches, setMatches] = useState(getMatches(orientation));
  useEffect(() => {
    const matchMedia = window.matchMedia(getMediaQuery(orientation));
    const handleChange = () => setMatches(getMatches(orientation));
    handleChange();
    matchMedia.addEventListener("change", handleChange);
    return () => {
      matchMedia.removeEventListener("change", handleChange);
    };
  }, [orientation]);
  return matches;
}
const Switch = ({ className, defaultChecked, disabled, onChange, ...props }) => {
  const [checked, setChecked] = useBoolean(defaultChecked);
  const handleChange = (value) => {
    setChecked.toggle();
    onChange == null ? void 0 : onChange(value);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Switch$1,
    {
      checked,
      onChange: handleChange,
      className: cn(
        "relative inline-flex h-6 w-10 shrink-0 cursor-pointer rounded-full bg-neutral-500 transition-colors duration-200 ease-in-out before:absolute before:inset-0 before:overflow-hidden before:rounded-full before:bg-blue before:opacity-0 before:transition-colors before:content-[''] hover:bg-neutral-300 hover:before:bg-blue-300 focus:outline-none",
        checked && "before:opacity-100",
        disabled && "pointer-events-none cursor-default select-none bg-neutral-200 before:bg-blue-100",
        className
      ),
      ...props,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "span",
        {
          "aria-hidden": "true",
          className: cn(
            "pointer-events-none inline-block h-[22px] w-[22px] translate-y-px rounded-full bg-white shadow-[0_2px_1px_0_rgba(0,0,0,0.06),0_2px_6px_0_rgba(0,0,0,0.15)] ring-0 transition duration-200 ease-in-out",
            checked ? "translate-x-[17px]" : "translate-x-px"
          )
        }
      )
    }
  );
};
const Modal = forwardRef(
  ({
    children,
    className,
    onClose = () => null,
    open,
    overlayTransitionProps,
    panelTransitionProps,
    panelClassName,
    wrapperClassName,
    ...props
  }, ref) => /* @__PURE__ */ jsxRuntimeExports.jsx(Transition, { appear: true, show: open, as: Fragment, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Dialog, { as: "div", ref, className: cn("acm acm-modal relative z-20", className), onClose, ...props, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Transition.Child,
      {
        as: Fragment,
        enter: "ease-out duration-200",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-150",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        ...overlayTransitionProps,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "fixed inset-0 bg-black-true bg-opacity-75" })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "acm_overflow_modal_wrapper fixed inset-0 overflow-y-auto", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: cn("grid h-full w-full items-center justify-center", wrapperClassName), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Transition.Child,
      {
        as: Fragment,
        enter: "ease-out duration-200",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "ease-in duration-150",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95",
        ...panelTransitionProps,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog.Panel, { className: cn("relative w-full max-w-4xl rounded bg-white", panelClassName), children })
      }
    ) }) })
  ] }) })
);
const Collapse = ({ as = "div", children, show = false }) => {
  const nodeRef = useRef(null);
  const handleRef = (ref) => {
    if (nodeRef.current) nodeRef.current.style.height = show ? `${(ref == null ? void 0 : ref.offsetHeight) ?? 0}px` : "0px";
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Transition,
    {
      show,
      as,
      className: "collapse-wrapper overflow-hidden transition-[height]",
      enter: "duration-150 ease-out",
      enterFrom: "h-0",
      enterTo: "h-full",
      leave: "duration-100 ease-in",
      leaveFrom: "h-full",
      leaveTo: "h-0",
      ref: nodeRef,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "collapse-inner-wrapper", ref: handleRef, children })
    }
  );
};
function createFooterId(...elements) {
  return createBemName("acm-footer", ...elements);
}
const AppModal = ({
  app: { appStoreLinks, bottomDescriptionHtml, longTitle, qrCode, topDescriptionHtml },
  ...modalProps
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  Modal,
  {
    ...modalProps,
    id: createFooterId("apps", "modal"),
    panelClassName: "grid max-w-screen-xs grid-cols-1 items-center gap-4 px-4 pb-8 pt-4 text-center",
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CloseButton, { className: "justify-self-end focus-visible:outline-none", onClick: modalProps.onClose }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "text-2xl", children: longTitle }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { text: topDescriptionHtml }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "justify-self-center", src: qrCode.src, alt: qrCode.alt, width: 156, height: 156 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { text: bottomDescriptionHtml }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "flex items-center justify-center space-x-1", children: appStoreLinks.map(({ name, newTab, src, url }) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: url, newTab, children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src, alt: name, height: 30 }) }) }, name)) })
    ]
  }
);
const Apps = ({ heading, apps }) => {
  const [showModal, setShowModal] = useBoolean(true);
  const [selectedApp, setSelectedApp] = useState();
  const isDesktop = useBreakpoint("lg");
  const handleItemClick = useCallback(
    (app) => (e) => {
      if (isDesktop) {
        e.preventDefault();
        setSelectedApp(app);
        setShowModal.on();
      }
    },
    [isDesktop, setShowModal]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id: createFooterId("apps"), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { className: "mb-4 font-extrabold", children: heading }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "space-y-4", children: apps.map((app) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "flex", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Link,
      {
        className: "inline-flex cursor-pointer items-center",
        href: app.mobileLink,
        onClick: handleItemClick(app),
        newTab: false,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              className: "mr-2 h-6 w-6 shrink-0",
              loading: "lazy",
              src: app.icon,
              alt: app.name,
              width: 24,
              height: 24
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: app.shortTitle })
        ]
      }
    ) }, app.name)) }),
    selectedApp && /* @__PURE__ */ jsxRuntimeExports.jsx(AppModal, { app: selectedApp, open: showModal, onClose: setShowModal.off })
  ] });
};
const ColumnHeader = ({ className, heading }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Disclosure.Button,
  {
    as: "h4",
    className: cn(
      "mb-2 flex w-full cursor-pointer items-center justify-between leading-6 lg:mb-4 lg:cursor-auto",
      className
    ),
    children: ({ open }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "font-extrabold", children: heading }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ArrowIcon,
        {
          direction: open ? "up" : "down",
          className: "transition-transform duration-150 ease-in-out lg:hidden"
        }
      )
    ] })
  }
);
const Complaint = ({ name, newTab, src, url }) => {
  const isDesktop = useBreakpoint("lg");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Disclosure, { as: "section", id: createFooterId("complaint"), children: ({ open }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ColumnHeader, { heading: name }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse, { show: open || isDesktop, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Disclosure.Panel, { static: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: url, newTab, children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "block pb-2 lg:pb-0", src, alt: name, loading: "lazy", width: 160, height: 76 }) }) }) })
  ] }) });
};
const LinkGroup = ({ heading, links }) => {
  const isDesktop = useBreakpoint("lg");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Disclosure, { as: "nav", className: "mt-2 first-of-type:mt-0 lg:mt-0", children: ({ open }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ColumnHeader, { heading, className: "px-4 lg:px-0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse, { show: open || isDesktop, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Disclosure.Panel,
      {
        as: "ul",
        static: true,
        className: "space-y-4 bg-black-true p-4 lg:space-y-1 lg:bg-transparent lg:p-0",
        children: links.map(({ name, newTab, url }) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "leading-6", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: url, newTab, children: name }) }, name))
      }
    ) })
  ] }) }, heading);
};
const Footer = ({ config }) => /* @__PURE__ */ jsxRuntimeExports.jsx("footer", { id: createFooterId(), className: "sticky top-[100vh] mt-32 bg-[#333] text-sm text-white", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "py-8 lg:container", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id: createFooterId("top-section"), className: "grid lg:grid-cols-6 lg:gap-4", children: [
    config.groups.map((group) => /* @__PURE__ */ jsxRuntimeExports.jsx(LinkGroup, { ...group }, group.heading)),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: "mt-2 flex flex-col justify-between px-4 lg:col-span-3 lg:mt-0 lg:flex-row lg:px-0", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Complaint, { ...config.complaint }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "grid gap-8", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("address", { id: createFooterId("contact-us"), className: "mt-3 not-italic lg:mt-0", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "leading-6", text: config.contacts.headingHtml }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-4 flex h-4 items-center space-x-6", children: config.contacts.socials.map(({ name, newTab, src, url, width }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: url, newTab, children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src, alt: name, height: 16, width }) }, url)) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Apps, { ...config.mobileApps })
      ] })
    ] })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("hr", { className: "mx-4 my-8 border-neutral lg:mx-auto" }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      id: createFooterId("bottom-section"),
      className: "flex flex-col space-y-6 px-4 lg:flex-row lg:items-baseline lg:justify-between lg:space-y-0 lg:px-0",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("nav", { id: createFooterId("document-links"), className: "divide-x divide-white", children: config.documentLinks.map(({ name, newTab, url }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link,
          {
            href: url,
            newTab,
            className: "px-2 no-underline first-of-type:pl-0 last-of-type:pr-0",
            children: name
          },
          url
        )) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          HtmlText,
          {
            id: createFooterId("copyright"),
            text: interpolate(config.copyrightHtml, { year: (/* @__PURE__ */ new Date()).getFullYear() })
          }
        )
      ]
    }
  )
] }) });
function createHeaderId$1(...elements) {
  return createBemName("acm-header", ...elements);
}
function triggerEvent$1(event) {
  gtmPush({ event: "navEvent", content_type: "ACM Header", ...event });
}
function createNavEvent$1(name, url, type = "main") {
  return () => triggerEvent$1({
    content_list_type: type === "mobile" ? "Mobile Navigation" : type === "nested" ? "Consumer Navigation" : "Main Navigation",
    content_title: name,
    content_id: url || "NA"
  });
}
function useBannerConfig$1(endpoint, portalRegexMap, wasBannerPreviouslyVisible) {
  const { data } = useAsync({
    endpoint,
    formatResponse: (response) => {
      const now = Date.now();
      const banner = response.find(
        (bannerResponse) => now >= new Date(bannerResponse.startTime).getTime() && now < new Date(bannerResponse.endTime).getTime()
      );
      if (!banner) return null;
      const visibleRegexes = banner.visibility.reduce((regexes, portal) => {
        const portalRegexString = portalRegexMap[portal];
        if (portalRegexString) regexes.push(new RegExp(portalRegexString, "i"));
        return regexes;
      }, []);
      const isVisible = Boolean(visibleRegexes.find((regex) => regex.test(window.location.href)));
      if (!isVisible) return null;
      return {
        titleHtml: banner.title,
        descriptionHtml: banner.description,
        logoImageUrl: banner.logoImageURL,
        backgroundImageUrl: banner.backgroundImageURL,
        showCountdownTimer: banner.showCountdownTimer,
        endTime: banner.endTime
      };
    },
    fetchCondition: () => {
      const hasDismissedBanner = getCookie(BANNER_DISMISSED_COOKIE) === "1";
      return !hasDismissedBanner || Boolean(wasBannerPreviouslyVisible);
    }
  });
  return data ?? null;
}
function calculateTimeLeft$1(endTime, timerUnit, optional = false) {
  const dateNow = (/* @__PURE__ */ new Date()).getTime();
  const distance = new Date(endTime).getTime() - dateNow;
  let timeLeft;
  switch (timerUnit) {
    case "day":
      timeLeft = distance / 864e5;
      break;
    case "hour":
      timeLeft = distance % 864e5 / 36e5;
      break;
    case "minute":
      timeLeft = distance % 36e5 / 6e4;
      break;
    case "second":
      timeLeft = distance % 6e4 / 1e3;
      break;
    default:
      timeLeft = 0;
      break;
  }
  if (timeLeft < 1) {
    if (optional) return null;
    return "00";
  }
  return Math.floor(timeLeft).toString().padStart(2, "0");
}
function useCountdownTimer$1(endTime) {
  const [day, setDay] = useState(calculateTimeLeft$1(endTime, "day", true));
  const [hour, setHour] = useState(calculateTimeLeft$1(endTime, "hour"));
  const [minute, setMinute] = useState(calculateTimeLeft$1(endTime, "minute"));
  const [second, setSecond] = useState(calculateTimeLeft$1(endTime, "second"));
  useEffect(() => {
    const interval = window.setInterval(() => {
      const days = calculateTimeLeft$1(endTime, "day", true);
      const hours = calculateTimeLeft$1(endTime, "hour");
      const minutes = calculateTimeLeft$1(endTime, "minute");
      const seconds = calculateTimeLeft$1(endTime, "second");
      setDay(days);
      setHour(hours);
      setMinute(minutes);
      setSecond(seconds);
    }, 1e3);
    return () => window.clearInterval(interval);
  }, [endTime]);
  return { day, hour, minute, second };
}
const TimerComponent$1 = ({ unit, value }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col items-center", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-[2rem] font-extrabold leading-[2.125rem]", children: value }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xs font-extrabold leading-[0.875rem]", children: unit })
] });
const CountdownTimer$1 = ({ endTime, units }) => {
  const { day, hour, minute, second } = useCountdownTimer$1(endTime);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      id: createHeaderId$1("banner", "countdown"),
      className: "mr-8 hidden items-center space-x-4 py-4 lg:ml-auto lg:flex",
      children: [
        day && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(TimerComponent$1, { value: day, unit: units.day }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: units.separator })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(TimerComponent$1, { value: hour, unit: units.hour }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: units.separator }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(TimerComponent$1, { value: minute, unit: units.minute }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: units.separator }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(TimerComponent$1, { value: second, unit: units.second })
      ]
    }
  );
};
const InlineCountdownTimer$1 = ({ endTime, units, ...props }) => {
  const { day, hour, minute, second } = useCountdownTimer$1(endTime);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: createHeaderId$1("banner", "inline-countdown"), ...props, children: [
    day && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      day,
      units.day,
      units.separator
    ] }),
    hour,
    units.hour,
    units.separator,
    minute,
    units.minute,
    units.separator,
    second,
    units.second
  ] });
};
const Banner$1 = ({
  dismissDuration,
  bcpV3Endpoint,
  portalRegexMap,
  showMiniBanner,
  timerUnits
}) => {
  const [isBannerShownThisSession, setIsBannerShownThisSession] = useBoolean();
  const [showBanner, setShowBanner] = useBoolean();
  const config = useBannerConfig$1(bcpV3Endpoint, portalRegexMap, isBannerShownThisSession);
  useEffect(() => {
    if (config) {
      setShowBanner.on();
      setIsBannerShownThisSession.on();
    }
  }, [config, setIsBannerShownThisSession, setShowBanner]);
  if (!config) return null;
  const { backgroundImageUrl, descriptionHtml, endTime, logoImageUrl, titleHtml, showCountdownTimer } = config;
  const handleClose = () => {
    setCookie(BANNER_DISMISSED_COOKIE, "1", dismissDuration, false, getCookieDomain(window.location.href));
    setShowBanner.off();
  };
  const handleMiniBannerClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  const handleTextClick = (event) => {
    if (event.target instanceof HTMLAnchorElement) event.stopPropagation();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Transition,
      {
        as: "aside",
        show: showBanner,
        id: createHeaderId$1("banner"),
        className: "relative grid bg-cover text-white transition-[grid-template-rows]",
        style: { backgroundImage: `url('${backgroundImageUrl}')` },
        enter: "ease-in duration-200",
        enterFrom: "grid-rows-[0fr]",
        enterTo: "grid-rows-[1fr]",
        leave: "ease-out duration-200",
        leaveFrom: "grid-rows-[1fr]",
        leaveTo: "grid-rows-[0fr]",
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "container-v2 flex items-start overflow-hidden lg:items-center", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "mr-4 shrink-0 self-center lg:mr-6", src: logoImageUrl, alt: "", loading: "lazy" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              id: createHeaderId$1("banner", "message"),
              className: "mr-4 py-2 lg:mr-8 lg:py-4 [&_a]:font-bold [&_a]:text-magenta [&_a]:hover:underline [&_a]:hover:decoration-current",
              children: [
                titleHtml && /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "font-extrabold lg:inline lg:after:inline lg:after:content-['_']", text: titleHtml }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "lg:inline", text: descriptionHtml }),
                showCountdownTimer && /* @__PURE__ */ jsxRuntimeExports.jsx(InlineCountdownTimer$1, { className: "mt-1 lg:hidden", endTime, units: timerUnits.shortForm })
              ]
            }
          ),
          showCountdownTimer && /* @__PURE__ */ jsxRuntimeExports.jsx(CountdownTimer$1, { endTime, units: timerUnits.fullForm }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(CloseButton, { className: cn("ml-auto pt-2 lg:pt-0", showCountdownTimer && "lg:ml-0"), onClick: handleClose })
        ] })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Transition,
      {
        as: "aside",
        show: showBanner && showMiniBanner,
        id: createHeaderId$1("mini-banner"),
        className: "fixed inset-x-0 top-0 z-20 cursor-pointer bg-cover text-base text-white transition",
        style: { backgroundImage: `url('${backgroundImageUrl}')` },
        enter: "ease-out duration-150",
        enterFrom: "-translate-y-full",
        enterTo: "translate-y-0",
        leave: "ease-in duration-100",
        leaveFrom: "translate-y-0",
        leaveTo: "-translate-y-full",
        onClick: handleMiniBannerClick,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "container-v2 flex justify-between py-1", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "p",
            {
              id: createHeaderId$1("mini-banner", "message"),
              role: "presentation",
              className: "overflow-hidden text-ellipsis whitespace-nowrap [&_a]:font-bold [&_a]:text-magenta [&_a]:hover:underline [&_a]:hover:decoration-current",
              onClick: handleTextClick,
              children: [
                titleHtml && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  HtmlText,
                  {
                    as: "strong",
                    className: "font-extrabold lg:after:inline lg:after:content-['_']",
                    text: titleHtml
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { as: "span", className: "hidden lg:inline", text: descriptionHtml })
              ]
            }
          ),
          showCountdownTimer && /* @__PURE__ */ jsxRuntimeExports.jsx(InlineCountdownTimer$1, { className: "ml-4 shrink-0", endTime, units: timerUnits.shortForm })
        ] })
      }
    )
  ] });
};
const AuthContext$1 = createContext({
  authenticated: false,
  isUxfPortal: false,
  loginUrl: "",
  logoutUrl: "",
  profileUrl: "",
  isChatbotConfiguredToBeShown: false,
  isLightspeed: false
});
function useAuth$1() {
  return useContext(AuthContext$1);
}
function handleChatbot$1(fn) {
  const elements = ["chat-button-frame", "chat-prompt-frame"].reduce((acc, id) => {
    const element = document.getElementById(id);
    if (element instanceof HTMLElement) return [...acc, element];
    return acc;
  }, []);
  const stickyElements = document.querySelectorAll("[data-livechat-sticky]");
  const stickyOffset = Array.from(stickyElements).reduce((tallestHeight, element) => {
    if (element instanceof HTMLElement && element.offsetHeight > tallestHeight) return element.offsetHeight;
    return tallestHeight;
  }, 0);
  const verticalTranslation = `translateY(-${stickyOffset}px)`;
  elements.forEach(
    (element) => stickyOffset ? element.style.setProperty("transform", verticalTranslation) : element.style.removeProperty("transform")
  );
  fn == null ? void 0 : fn();
}
function useChatbot$1(chatbotConfig, onCallback) {
  const { hiddenPortals } = chatbotConfig;
  useEffect(() => {
    const handleMutation = () => handleChatbot$1(onCallback);
    handleMutation();
    const observer = new MutationObserver(handleMutation);
    observer.observe(document, { subtree: true, childList: true });
    return () => {
      observer.disconnect();
    };
  }, [onCallback]);
  useEffect(() => {
    const match = hiddenPortals.find((regex) => regex && window.location.href.match(new RegExp(regex, "i")));
    if (match) {
      const styleElement = document.createElement("style");
      styleElement.innerHTML = `#chat-button-frame,#chat-prompt-frame,#chat-window-frame{display:none}`;
      styleElement.dataset.chatbotOverride = "";
      document.head.appendChild(styleElement);
    } else {
      document.querySelectorAll("[data-chatbot-override]").forEach((element) => {
        element.remove();
      });
    }
  }, [hiddenPortals]);
}
const AuthProvider$1 = ({
  children,
  loginUrlParams,
  onAuth,
  onInit,
  profileUrl: profileUrlConfig,
  session,
  whitelistedUxfDomains,
  chatbotConfig
}) => {
  const sessionId = useConst(nanoid());
  const [hasSession, setHasSession] = useState(false);
  const [authenticating, setAuthenticating] = useState(false);
  const [isUxfPortal, setIsUxfPortal] = useState(false);
  const [loginUrl, setLoginUrl] = useState("");
  const [logoutUrl, setLogoutUrl] = useState("");
  const [profileUrl, setProfileUrl] = useState(profileUrlConfig.default);
  const [username, setUsername] = useState("");
  const [isLightspeed, setIsLightspeed] = useState(false);
  const isChatbotConfiguredToBeShown = Boolean(
    !chatbotConfig.hiddenPortals.find((regex) => regex && window.location.href.match(new RegExp(regex, "i")))
  );
  const initializeChatbotCustomerName = useCallback(() => {
    const hasInitializedChatbotSession = getCookie(CHATBOT_USER_INFO);
    if (hasSession && username && isChatbotConfiguredToBeShown && !hasInitializedChatbotSession) {
      startChatbotSession(username);
    }
  }, [hasSession, isChatbotConfiguredToBeShown, username]);
  useChatbot$1(chatbotConfig, initializeChatbotCustomerName);
  useEffect(() => {
    const constructedUrl = initLoginUrl(loginUrlParams, sessionId);
    setLoginUrl(constructedUrl);
    const uxfEnabled = whitelistedUxfDomains.includes(window.location.hostname);
    setHasSession(Boolean(uxfEnabled || hasExistingSession()));
    setIsUxfPortal(uxfEnabled);
    setProfileUrl(uxfEnabled ? profileUrlConfig.uxf : profileUrlConfig.default);
    setLogoutUrl(uxfEnabled ? profileUrlConfig.uxf : "");
    if (constructedUrl) onInit == null ? void 0 : onInit({ ulmUrl: constructedUrl, isUxfPortal: uxfEnabled });
    const ulmProfileEventHandler = (e) => {
      const profile = e.detail;
      if (!uxfEnabled) setHasSession(isUlmProfile(profile));
    };
    window.addEventListener(ULM_PROFILE_EVENT, ulmProfileEventHandler);
    return () => {
      window.removeEventListener(ULM_PROFILE_EVENT, ulmProfileEventHandler);
    };
  }, [loginUrlParams, onInit, profileUrlConfig.default, profileUrlConfig.uxf, sessionId, whitelistedUxfDomains]);
  useEffect(() => {
    if (loginUrl && !authenticating) {
      setAuthenticating(true);
      refreshSession(session, isChatbotConfiguredToBeShown, sessionId).then((profile) => {
        setUsername((profile == null ? void 0 : profile.name) || "");
        if (profile == null ? void 0 : profile.is_lightspeed) setIsLightspeed(true);
        onAuth == null ? void 0 : onAuth(profile);
      });
    }
  }, [authenticating, isChatbotConfiguredToBeShown, loginUrl, onAuth, sessionId, session]);
  const context = useMemo(
    () => ({
      authenticated: hasSession,
      isUxfPortal,
      loginUrl,
      logoutUrl,
      profileUrl,
      isChatbotConfiguredToBeShown,
      isLightspeed
    }),
    [hasSession, isUxfPortal, loginUrl, logoutUrl, profileUrl, isChatbotConfiguredToBeShown, isLightspeed]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AuthContext$1.Provider, { value: context, children });
};
const NavItemText$1 = ({ bold, boldOnHover, className, text, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "span",
  {
    "data-title": text,
    className: cn(
      "tracking-wide antialiased outline-none before:invisible before:block before:h-0 before:overflow-hidden before:font-bold before:tracking-wide before:content-[attr(data-title)]",
      bold && "font-bold tracking-normal [text-shadow:0px_0px_currentcolor]",
      boldOnHover && "hover:font-bold hover:tracking-normal hover:[text-shadow:0px_0px_currentcolor] focus:font-bold focus:tracking-normal focus:[text-shadow:0px_0px_currentcolor]",
      className
    ),
    ...props,
    children: text
  }
);
const Account$1 = ({ button, menuLabel, onLogin, onLogout, shouldOverrideLogout }) => {
  const { authenticated, loginUrl, logoutUrl, profileUrl, isChatbotConfiguredToBeShown, isLightspeed } = useAuth$1();
  const handleLogout = (closeMenu) => () => {
    if (!shouldOverrideLogout) logout();
    if (isChatbotConfiguredToBeShown) endChatbotSession();
    onLogout == null ? void 0 : onLogout();
    closeMenu == null ? void 0 : closeMenu();
  };
  const handleLogin = () => {
    createNavEvent$1("Login")();
    onLogin == null ? void 0 : onLogin();
    window.location.href = interpolate(loginUrl, { location: encodeURIComponent(window.location.href) });
  };
  if (authenticated) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "button",
        {
          type: "button",
          onClick: handleLogout(),
          className: cn("hidden h-10 items-center", isLightspeed && "lg:flex"),
          "aria-label": "Login",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(AccountIcon, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText$1, { text: menuLabel.logout, className: "ml-2 hidden lg:block" })
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Menu, { as: "div", className: cn("relative flex h-10 items-center", isLightspeed && "lg:hidden"), children: ({ close, open }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Menu.Button, { className: "flex focus-visible:outline-none", "aria-label": "Profile", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(AccountIcon, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText$1, { text: button.profile, bold: open, className: "ml-2 hidden lg:block" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Transition,
          {
            as: Fragment,
            enter: "origin-top-right transition ease-out duration-100",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "origin-top-right transition ease-in duration-75",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95",
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Menu.Items,
              {
                id: createHeaderId$1("profile-menu"),
                className: "absolute right-0 top-full z-10 space-y-4 rounded-sm bg-black p-4 text-right text-base shadow-lg outline-none lg:top-[calc(100%_+_8px)]",
                children: [
                  !isLightspeed && /* @__PURE__ */ jsxRuntimeExports.jsx(Menu.Item, { as: Link, href: profileUrl, onClick: close, className: "inline-block whitespace-nowrap", children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText$1, { text: menuLabel.manage, boldOnHover: true }) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Menu.Item,
                    {
                      as: Link,
                      href: logoutUrl || void 0,
                      onClick: handleLogout(close),
                      className: "inline-block cursor-pointer whitespace-nowrap",
                      children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText$1, { text: menuLabel.logout, boldOnHover: true })
                    }
                  )
                ]
              }
            )
          }
        )
      ] }) })
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("button", { type: "button", onClick: handleLogin, className: "flex h-10 items-center", "aria-label": "Login", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(AccountIcon, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText$1, { text: button.login, className: "ml-2 hidden lg:block" })
  ] });
};
const LocaleContext$1 = createContext(DEFAULT_LOCALE);
function useLocale$1() {
  return useContext(LocaleContext$1);
}
const LocaleProvider$1 = ({ children, locale }) => /* @__PURE__ */ jsxRuntimeExports.jsx(LocaleContext$1.Provider, { value: locale, children });
const LanguageSwitcher$1 = ({ onChange, options }) => {
  const locale = useLocale$1();
  const selectedOption = options.find((option) => option.locale === locale) ?? {
    locale,
    name: "",
    shortName: locale.toUpperCase()
  };
  const handleChange = (option, closeMenu) => () => {
    const updatedLocale = toggleLocale(option.locale);
    if (updatedLocale !== null) onChange == null ? void 0 : onChange(updatedLocale);
    closeMenu();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Menu, { as: "div", className: "relative flex h-10 items-center", children: ({ close, open }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Menu.Button, { className: "flex focus-visible:outline-none", "aria-label": "Language", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LanguageIcon, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText$1, { text: selectedOption.shortName, bold: open, className: "ml-2 hidden lg:block" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Transition,
      {
        as: Fragment,
        enter: "origin-top-right transition ease-out duration-100",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "origin-top-right transition ease-in duration-75",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Menu.Items,
          {
            id: createHeaderId$1("language-switcher"),
            className: "absolute right-0 top-full z-10 space-y-4 rounded-sm bg-black p-4 text-base shadow-lg outline-none lg:top-[calc(100%_+_8px)]",
            children: options.map((option) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Menu.Item,
              {
                as: "div",
                className: "flex cursor-pointer items-center justify-between",
                onClick: handleChange(option, close),
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    NavItemText$1,
                    {
                      text: option.name,
                      bold: selectedOption.locale === option.locale,
                      boldOnHover: true,
                      className: cn(
                        "inline-block whitespace-nowrap",
                        selectedOption.locale === option.locale && "text-magenta"
                      )
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    TickIcon,
                    {
                      className: cn(
                        "invisible ml-16 shrink-0 text-magenta",
                        selectedOption.locale === option.locale && "visible"
                      )
                    }
                  )
                ]
              },
              option.locale
            ))
          }
        )
      }
    )
  ] }) });
};
const ResetIcon$1 = (props) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: "20", height: "20", ...props, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z",
      fill: "currentcolor",
      opacity: "0.4"
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m13.831 13.016-3.014-3.018 3.014 3.018ZM7.337 14.19l2.666-2.669 2.66 2.665a1.075 1.075 0 1 0 1.522-1.522l-2.662-2.665 2.662-2.665.003-.003a1.074 1.074 0 0 0 .003-1.504 1.063 1.063 0 0 0-1.53-.002l-2.658 2.661-2.658-2.66a1.063 1.063 0 0 0-1.524-.005 1.053 1.053 0 0 0 .004 1.517l2.657 2.66-2.658 2.662a1.063 1.063 0 0 0 .003 1.532 1.083 1.083 0 0 0 1.51-.002Z",
      fill: "#fff"
    }
  )
] });
const SearchBar$1 = ({ className, endpoint, placeholder, queryKey }) => {
  const inputRef = useRef(null);
  const [value, setValue] = useState("");
  const resetValue = () => {
    var _a;
    setValue("");
    (_a = inputRef.current) == null ? void 0 : _a.focus();
  };
  const handleSubmit = (event) => {
    const data = new FormData(event.currentTarget);
    const keyword = data.get(queryKey);
    if (typeof keyword === "string" && keyword.trim()) ;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { id: createHeaderId$1("search"), className: "relative", action: endpoint, onSubmit: handleSubmit, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        ref: inputRef,
        className: cn(
          "h-14 appearance-none rounded-sm bg-white p-4 pr-[52px] text-base placeholder-current caret-blue outline-none placeholder:opacity-40 [&::-webkit-search-cancel-button]:appearance-none",
          className
        ),
        name: queryKey,
        type: "search",
        placeholder,
        autoComplete: "off",
        value,
        onChange: (e) => setValue(e.target.value)
      }
    ),
    value.length ? /* @__PURE__ */ jsxRuntimeExports.jsx(ResetIcon$1, { className: "absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer", onClick: resetValue }) : /* @__PURE__ */ jsxRuntimeExports.jsx(SearchIcon, { className: "pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-neutral-400 lg:hidden" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "submit", hidden: true, className: "hidden" })
  ] });
};
const Search$1 = ({ button, form: formProps }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Popover, { as: "div", className: "hidden h-10 items-center lg:flex", children: ({ open }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Popover.Button,
    {
      className: "flex focus-visible:outline-none",
      onClick: createNavEvent$1(open ? "Close Search" : "Search"),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(SearchIcon, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText$1, { text: button, bold: open, className: "ml-2 hidden lg:block" })
      ]
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Transition,
    {
      as: Fragment,
      enter: "origin-top-right transition ease-out duration-100",
      enterFrom: "opacity-0 scale-95",
      enterTo: "opacity-100 scale-100",
      leave: "origin-top-right transition ease-in duration-75",
      leaveFrom: "opacity-100 scale-100",
      leaveTo: "opacity-0 scale-95",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Popover.Panel, { className: "absolute right-18 top-full z-10 shadow-lg lg:top-[calc(100%_+_8px)]", focus: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchBar$1, { ...formProps, className: "w-[368px] bg-black outline-none" }) })
    }
  )
] }) });
const UtilityNav$1 = ({
  account,
  className,
  hideLanguageSwitcher: hideLanguageByPortal,
  languageOptions,
  hideLanguageRegex,
  onLocaleChange,
  onLogin,
  onLogout,
  search,
  shouldOverrideLogout
}) => {
  const [hideLanguageFromDf, setHideLanguageFromDf] = useState(false);
  useEffect(() => {
    if (hideLanguageRegex) {
      setHideLanguageFromDf(hideLanguageRegex.findIndex((regex) => RegExp(regex, "i").test(window.location.href)) >= 0);
    }
  }, [hideLanguageRegex]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("nav", { id: createHeaderId$1("utilities"), className: cn("flex items-center space-x-6 text-sm", className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Search$1, { ...search }),
    !hideLanguageByPortal && !hideLanguageFromDf && /* @__PURE__ */ jsxRuntimeExports.jsx(LanguageSwitcher$1, { options: languageOptions, onChange: onLocaleChange }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Account$1, { ...account, shouldOverrideLogout, onLogin, onLogout })
  ] });
};
const GlobalNavItem$1 = ({ links, name, newTab, url, regex, onLinkClick, closeDrawer }) => {
  const [showPopover, setShowPopover] = useBoolean();
  const isCurrentPage = !!regex && RegExp(regex, "i").test(window.location.href);
  return links ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Popover, { as: "div", className: "relative hidden h-20 items-center lg:flex", "data-nav": "nested", children: [
    url ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      Link,
      {
        onMouseEnter: setShowPopover.on,
        onMouseLeave: setShowPopover.off,
        href: url,
        newTab,
        onClick: (e) => {
          onLinkClick == null ? void 0 : onLinkClick(e, { name, url, newTab, links, regex }, closeDrawer);
        },
        className: "hidden h-full items-center lg:flex",
        "data-nav": "link",
        forwardUtm: true,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText$1, { text: name, bold: isCurrentPage, boldOnHover: true })
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
      Popover.Button,
      {
        className: "h-full focus-visible:outline-none",
        onClick: (e) => {
          onLinkClick == null ? void 0 : onLinkClick(e, { name, url }, closeDrawer);
        },
        onMouseEnter: setShowPopover.on,
        onMouseLeave: setShowPopover.off,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText$1, { text: name, bold: isCurrentPage, boldOnHover: true })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Transition,
      {
        as: Fragment,
        show: showPopover,
        enter: "transition ease-out duration-100",
        enterFrom: "opacity-0 -translate-y-1",
        enterTo: "opacity-100 translate-y-0",
        leave: "transition ease-in duration-75",
        leaveFrom: "opacity-100 translate-y-0",
        leaveTo: "opacity-0 -translate-y-1",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Popover.Panel,
          {
            as: "nav",
            static: true,
            className: "absolute -left-4 top-[calc(100%_-_8px)] z-10 flex flex-col space-y-4 whitespace-nowrap rounded-sm border-neutral bg-white p-4 text-black shadow",
            onMouseEnter: setShowPopover.on,
            onMouseLeave: setShowPopover.off,
            children: links.map((nestedItem) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              Link,
              {
                href: nestedItem.url,
                newTab: nestedItem.newTab,
                onClick: (e) => {
                  onLinkClick == null ? void 0 : onLinkClick(e, nestedItem, closeDrawer);
                  createNavEvent$1(nestedItem.name, nestedItem.url, "nested");
                },
                forwardUtm: true,
                children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  NavItemText$1,
                  {
                    text: nestedItem.name,
                    bold: !!nestedItem.regex && RegExp(nestedItem.regex, "i").test(window.location.href),
                    boldOnHover: true
                  }
                )
              },
              nestedItem.url
            ))
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    Link,
    {
      href: url,
      newTab,
      onClick: (e) => {
        onLinkClick == null ? void 0 : onLinkClick(e, { name, url, newTab, regex }, closeDrawer);
      },
      className: "hidden lg:block",
      "data-nav": "link",
      forwardUtm: true,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText$1, { text: name, bold: isCurrentPage, boldOnHover: true })
    }
  );
};
const GlobalNav$1 = ({
  background = "magenta",
  centerMobileLogo,
  items,
  logo,
  logoSize,
  onMenuClick,
  onLinkClick,
  onLogoClick,
  utilityNavProps,
  closeDrawer
}) => {
  const isDesktop = useBreakpoint("lg");
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: createHeaderId$1("global-nav"), className: cn(background === "magenta" && "bg-gradient-magenta1"), children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "container-v2 relative flex h-14 items-center lg:h-20", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", "aria-label": "Menu", className: "mr-5 block lg:hidden", onClick: onMenuClick, children: /* @__PURE__ */ jsxRuntimeExports.jsx(BurgerMenuIcon$1, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("nav", { className: cn("flex grow items-center space-x-6", centerMobileLogo && "justify-evenly lg:justify-start"), children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Link,
        {
          href: logo.url,
          newTab: logo.newTab,
          forwardUtm: true,
          onClick: (e) => {
            createNavEvent$1("Astro Logo", logo.url);
            onLogoClick == null ? void 0 : onLogoClick(e, logo.url);
          },
          className: cn(
            "shrink-0 lg:mr-4",
            centerMobileLogo && "absolute left-1/2 -translate-x-1/2 lg:static lg:left-0 lg:translate-x-0"
          ),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: logo.src,
              alt: logo.name,
              className: "h-6 lg:h-8",
              height: logoSize && (isDesktop ? logoSize.desktop.height : logoSize.mobile.height),
              width: logoSize && (isDesktop ? logoSize.desktop.width : logoSize.mobile.width)
            }
          )
        }
      ),
      items.map((item) => /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalNavItem$1, { ...item, closeDrawer, onLinkClick }, item.name))
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(UtilityNav$1, { ...utilityNavProps, className: "lg:hidden" })
  ] }) });
};
function useCrossPromoConfig$1(endpoint, locale, shouldFetch) {
  const { data, isLoading } = useDfConfig(endpoint, "cross_promotion", {
    fetchCondition: () => Boolean(shouldFetch)
  });
  if (!data)
    return {
      config: {
        title: "Explore websites in Astro",
        logo: { src: "", alt: "" },
        products: []
      },
      isLoading: true
    };
  const localeMapping = {
    en: "en",
    bm: "ms"
  };
  return {
    config: {
      title: data.titleLocales[localeMapping[locale]],
      logo: { src: data.titleLogoUrl, alt: "Astro" },
      products: data.products.map((product) => ({
        image: product.thumbnail,
        name: product.title,
        description: product.description,
        url: product.external_link
      }))
    },
    isLoading
  };
}
const CrossPromo$1 = ({ endpoint, onClose, open }) => {
  const locale = useLocale$1();
  const {
    config: { title, logo, products },
    isLoading
  } = useCrossPromoConfig$1(endpoint, locale, open);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Modal,
    {
      open,
      id: createHeaderId$1("brands"),
      panelClassName: "h-full max-w-full overflow-auto rounded-none bg-neutral-50",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "container-2 flex flex-col py-8", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(CloseButton, { className: "mb-4 self-end", onClick: onClose }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { id: createHeaderId$1("brands", "header"), className: "mb-8 flex items-center", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "text-[22px] font-bold", children: title }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: logo.src, alt: logo.alt, className: "ml-2 h-6" })
        ] }),
        isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Loading..." }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: createHeaderId$1("brands", "grid"), className: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3", children: products.map(({ description, image, name, url }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Link, { href: url, newTab: true, className: "flex rounded-sm bg-white p-2 shadow", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "row-span-3 rounded-xs", src: image, alt: name, width: 120, height: 120, loading: "lazy" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ml-2 flex flex-col", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mb-1 font-extrabold leading-none", children: name }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-[13px]", children: description }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-auto text-[13px]", children: url })
          ] })
        ] }, name)) })
      ] })
    }
  );
};
const UniversalNav$1 = ({ crossPromo, utilityNavProps, sites, variant }) => {
  const [showBrands, setShowBrands] = useBoolean();
  const [boldIndex, setBoldIndex] = useState(0);
  const filteredSites = sites.filter((_, index) => variant === "mobile" ? index !== boldIndex : true);
  const handleBrandsClick = () => {
    setShowBrands.on();
    createNavEvent$1(crossPromo.name, "", variant === "mobile" ? "mobile" : "main")();
  };
  useEffect(() => {
    const index = filteredSites.findIndex(({ regex }) => regex && RegExp(regex, "i").test(window.location.href));
    if (index >= 0) setBoldIndex(index);
  }, [filteredSites]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      id: createHeaderId$1("universal-nav"),
      className: cn("h-10 bg-black", variant === "desktop" && "hidden lg:block"),
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "container-v2 relative flex h-full justify-center lg:justify-between", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("nav", { className: "flex items-center justify-center space-x-6 text-sm text-white lg:justify-start lg:space-x-7", children: [
          filteredSites.map(({ name, newTab, url }, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            Link,
            {
              href: url,
              newTab,
              onClick: createNavEvent$1(name, url, variant === "mobile" ? "mobile" : "main"),
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText$1, { text: name, bold: variant === "desktop" && index === boldIndex, boldOnHover: true })
            },
            name
          )),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            NavItemText$1,
            {
              className: "cursor-pointer align-baseline",
              text: crossPromo.name,
              bold: showBrands,
              boldOnHover: true,
              onClick: handleBrandsClick
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(CrossPromo$1, { endpoint: crossPromo.endpoint, open: showBrands, onClose: setShowBrands.off })
        ] }),
        utilityNavProps && /* @__PURE__ */ jsxRuntimeExports.jsx(UtilityNav$1, { ...utilityNavProps })
      ] })
    }
  );
};
const NavItem = ({ links, name, newTab, url, onLinkClick, closeDrawer }) => links ? /* @__PURE__ */ jsxRuntimeExports.jsx(Disclosure, { as: "nav", children: ({ open }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Disclosure.Button, { className: "flex w-full items-center justify-between py-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xl font-extrabold", children: name }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowIcon, { direction: open ? "up" : "down", className: "h-5 w-5 text-magenta transition-transform" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse, { show: open, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Disclosure.Panel, { as: "ul", static: true, className: "space-y-6 pb-4 pt-2", children: links.map((link) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Link,
    {
      href: link.url,
      newTab: link.newTab,
      forwardUtm: true,
      onClick: (e) => onLinkClick == null ? void 0 : onLinkClick(e, link, closeDrawer),
      children: link.name
    }
  ) }, link.name)) }) })
] }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
  Link,
  {
    href: url,
    newTab,
    className: "inline-block w-full py-4 text-xl font-extrabold",
    forwardUtm: true,
    onClick: (e) => onLinkClick == null ? void 0 : onLinkClick(e, { name, url, newTab }, closeDrawer),
    children: name
  }
);
const MobileDrawer = ({
  config: { global, universal, utility },
  onClose,
  open,
  closeDrawer,
  onLinkClick
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  Modal,
  {
    open,
    onClose,
    id: createHeaderId$1("mobile-drawer"),
    className: "z-30",
    panelClassName: "fixed inset-0 flex max-w-full flex-col rounded-none",
    panelTransitionProps: {
      enterFrom: "-translate-x-full",
      enterTo: "translate-x-0",
      leaveFrom: "translate-x-0",
      leaveTo: "-translate-x-full"
    },
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { id: createHeaderId$1("mobile-drawer", "header"), className: "sticky top-0 z-10 h-[82px] bg-gradient-magenta1", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative flex h-14 justify-center text-white", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(CloseButton, { className: "absolute left-4 top-1/2 -translate-y-1/2", onClick: onClose }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "place-self-center text-xl", children: global.menu })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "container-v2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SearchBar$1,
          {
            ...utility.search.form,
            className: "w-full border border-neutral shadow focus:border focus:border-blue"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "section",
        {
          id: createHeaderId$1("mobile-drawer", "menu"),
          className: "container-v2 grow divide-y divide-neutral overflow-auto pb-12 pt-10",
          children: global.items.map((item) => /* @__PURE__ */ jsxRuntimeExports.jsx(NavItem, { ...item, closeDrawer, onLinkClick }, item.name))
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("footer", { className: "sticky top-[100vh]", children: /* @__PURE__ */ jsxRuntimeExports.jsx(UniversalNav$1, { variant: "mobile", ...universal }) })
    ]
  }
);
function useModalBannerConfig$1(endpoint, portalRegexMap) {
  const { authenticated } = useAuth$1();
  const { data } = useAsync({
    endpoint,
    formatResponse: (response) => {
      const now = Date.now();
      const modalBanner = response.find(
        (modalBannerResponse) => now >= new Date(modalBannerResponse.startTime).getTime() && now < new Date(modalBannerResponse.endTime).getTime()
      );
      if (!modalBanner) return null;
      const visibleRegexes = modalBanner.visibility.map((portal) => portalRegexMap[portal]);
      const isVisible = visibleRegexes.some((regex) => window.location.href.match(new RegExp(regex, "i")));
      if (!isVisible) return null;
      if (!modalBanner.userSegment.length) return null;
      const loggedIn = Boolean(modalBanner.userSegment.find((user) => user === "loggedIn"));
      const nonLoggedIn = Boolean(modalBanner.userSegment.find((user) => user === "nonLoggedIn"));
      if (!loggedIn && !nonLoggedIn) return null;
      if (loggedIn && !nonLoggedIn && !authenticated) return null;
      if (!loggedIn && nonLoggedIn && authenticated) return null;
      return {
        dismissDuration: modalBanner.cookiesExpiry,
        mobileImage: {
          name: modalBanner.mobileImage.altText,
          url: modalBanner.url,
          src: modalBanner.mobileImage.image
        },
        desktopImage: {
          name: modalBanner.desktopImage.altText,
          url: modalBanner.url,
          src: modalBanner.desktopImage.image
        }
      };
    },
    fetchCondition: () => {
      const hasDismissedBanner = getCookie(MODAL_BANNER_DISMISSED_COOKIE) === "1";
      return !hasDismissedBanner;
    }
  });
  return data ?? null;
}
const ModalBanner$1 = ({ endpoint, portalRegexMap }) => {
  const config = useModalBannerConfig$1(endpoint, portalRegexMap);
  const [showModal, setShowModal] = useBoolean();
  useEffect(() => {
    if (config) setShowModal.on();
  }, [config, setShowModal]);
  if (!config) return null;
  const { dismissDuration, desktopImage, mobileImage } = config;
  const handleClose = () => {
    setShowModal.off();
    setCookie(MODAL_BANNER_DISMISSED_COOKIE, "1", dismissDuration, false, getCookieDomain(window.location.href));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Modal,
    {
      open: showModal,
      id: createHeaderId$1("modal-banner"),
      panelClassName: "h-[480px] max-h-screen w-80 max-w-full overscroll-contain rounded lg:h-[1200px] lg:w-[800px]",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(CloseButton, { className: "absolute right-4 top-4", onClick: handleClose }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: mobileImage.url, id: createHeaderId$1("modal-banner", "mobile"), className: "block lg:hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: mobileImage.src, alt: mobileImage.name, className: "rounded", loading: "lazy" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: desktopImage.url, id: createHeaderId$1("modal-banner", "desktop"), className: "hidden lg:block", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: desktopImage.src, alt: desktopImage.name, className: "rounded", loading: "lazy" }) })
      ]
    }
  );
};
const Header$1 = ({
  background = "magenta",
  centerMobileLogo,
  config,
  hideLanguageSwitcher,
  locale = DEFAULT_LOCALE,
  onAuth,
  onInit,
  onLocaleChange,
  onLogin,
  onLogout,
  onLinkClick,
  onLogoClick,
  shouldOverrideLogout
}) => {
  const utilityNavProps = {
    ...config.utility,
    hideLanguageSwitcher,
    shouldOverrideLogout,
    onLogin,
    onLogout,
    onLocaleChange,
    onLinkClick
  };
  const [showDrawer, setShowDrawer] = useBoolean();
  const { ref: headerRef, inView: isHeaderInView } = useInView();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AuthProvider$1, { ...config.auth, chatbotConfig: config.chatbot, onInit, onAuth, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(LocaleProvider$1, { locale, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Banner$1, { ...config.banner, showMiniBanner: !isHeaderInView }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { id: createHeaderId$1(), ref: headerRef, className: "relative text-white", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(UniversalNav$1, { variant: "desktop", ...config.universal, utilityNavProps }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        GlobalNav$1,
        {
          ...config.global,
          background,
          centerMobileLogo,
          utilityNavProps,
          onMenuClick: setShowDrawer.on,
          closeDrawer: setShowDrawer.off,
          onLinkClick,
          onLogoClick
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        MobileDrawer,
        {
          config,
          open: showDrawer,
          closeDrawer: setShowDrawer.off,
          onClose: setShowDrawer.off,
          onLinkClick
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBanner$1, { endpoint: config.banner.modal.bcpV3Endpoint, portalRegexMap: config.banner.portalRegexMap })
  ] }) });
};
const BubbleTail = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8 13", ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M0 0v13h7.006c.919 0 1.344-1.522.649-2.325z" }) });
function useChatUrl(chatEndpoint, chatCodes, path) {
  const [chatUrl, setChatUrl] = useState("");
  const configureUrl = useCallback(() => {
    const matchedUrl = chatCodes.find(({ regex }) => RegExp(regex).test(window.location.href));
    if (matchedUrl) setChatUrl(interpolate(chatEndpoint, { code: matchedUrl.code }));
    else setChatUrl("");
  }, [chatCodes, chatEndpoint]);
  useEffect(() => {
    window.addEventListener("popstate", configureUrl);
    return () => {
      window.removeEventListener("popstate", configureUrl);
    };
  }, [configureUrl]);
  useEffect(() => {
    configureUrl();
  }, [path, configureUrl]);
  return chatUrl;
}
function useStickyOffset() {
  const [stickyOffset, setStickyOffset] = useState(0);
  useEffect(() => {
    const mutationHandler = () => {
      let tallestStickyElementHeight = 0;
      const stickyElements = document.querySelectorAll("[data-livechat-sticky]");
      stickyElements.forEach((element) => {
        if (element instanceof HTMLElement && element.offsetHeight > tallestStickyElementHeight)
          tallestStickyElementHeight = element.offsetHeight;
      });
      setStickyOffset(tallestStickyElementHeight);
    };
    const observer = new MutationObserver(mutationHandler);
    mutationHandler();
    observer.observe(document, { subtree: true, childList: true });
    return () => {
      observer.disconnect();
    };
  }, []);
  return stickyOffset;
}
function createLiveChatId(...elements) {
  return `acm-live-chat${elements.length ? `__${elements.join("__")}` : ""}`;
}
const LiveChatComponent = ({
  config: {
    bubbleDescription,
    bubbleTitle,
    chatCodes,
    chatEndpoint,
    helpText,
    icon,
    idleSecondsToShowBubble,
    scrollHeightToShowBubble
  },
  path
}) => {
  const liveChatUrl = useChatUrl(chatEndpoint, chatCodes, path);
  const stickyOffset = useStickyOffset();
  const [idle, setIdle] = useState(false);
  const [shrink, setShrink] = useState(false);
  useIdleTimer({
    element: document,
    debounce: 250,
    timeout: idleSecondsToShowBubble * 1e3,
    onIdle: () => window.scrollY > scrollHeightToShowBubble && setIdle(true)
  });
  useLayoutEffect(() => {
    const scrollHandler = () => {
      if (window.scrollY > 0)
        requestAnimationFrame(() => {
          setShrink(true);
          setIdle(false);
        });
    };
    window.addEventListener("scroll", scrollHandler, { once: true });
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Transition,
    {
      id: createLiveChatId(),
      show: Boolean(liveChatUrl),
      appear: true,
      enter: "ease-out duration-200",
      enterFrom: "opacity-0 scale-95",
      enterTo: "opacity-100 scale-100",
      leave: "ease-in duration-150",
      leaveFrom: "opacity-100 scale-100",
      leaveTo: "opacity-0 scale-95",
      className: "fixed bottom-4 right-4 z-10 text-black transition-all",
      style: { bottom: stickyOffset + 16 },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Link,
          {
            id: createLiveChatId("fab"),
            href: liveChatUrl,
            newTab: true,
            className: cn(
              "relative flex h-12 max-w-xs items-center overflow-hidden rounded-full bg-[#333] p-3 transition-[max-width] duration-300",
              shrink && "max-w-[48px]"
            ),
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "shrink-0", src: icon.src, alt: icon.alt, width: 24, height: 24, loading: "lazy" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "span",
                {
                  className: cn(
                    "ml-2 min-w-max font-bold text-white transition-colors duration-200",
                    shrink && "text-transparent"
                  ),
                  children: helpText
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Transition,
          {
            show: idle,
            as: Link,
            href: liveChatUrl,
            newTab: true,
            id: createLiveChatId("bubble"),
            className: "absolute bottom-0 right-[calc(100%_+_16px)] flex w-[calc(100vw_-_96px)] items-start justify-between rounded-sm rounded-br-none bg-[#e1fec6] p-4 drop-shadow sm:w-[272px]",
            enter: "transition origin-bottom-right duration-150 ease-out",
            enterFrom: "opacity-0 scale-90",
            enterTo: "opacity-1 scale-100",
            leave: "transition origin-bottom-right duration-100 ease-in",
            leaveFrom: "opacity-1 scale-100",
            leaveTo: "opacity-0 scale-90",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mb-1 font-bold", children: bubbleTitle }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: bubbleDescription })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                CloseButton,
                {
                  className: "ml-4",
                  onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIdle(false);
                  }
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(BubbleTail, { className: "height-[13px] absolute -right-2 bottom-0 w-2 fill-[#e1fec6]" })
            ]
          }
        )
      ]
    }
  );
};
const LiveChat = ({ config, path }) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  if (isClient) return /* @__PURE__ */ jsxRuntimeExports.jsx(LiveChatComponent, { config, path });
};
const presetEndpoints$3 = {
  acm: {
    production: "https://digital-fortress-assets.eco.astro.com.my/prod/config/K5OjDOxv2Z/config.json",
    staging: "https://digital-fortress-dev.eco.astro.com.my/dev/config/dpMB5pNylZ/config.json"
  },
  myastro: {
    production: "https://digital-fortress-assets.eco.astro.com.my/prod/config/ZKpywDPB3M/config.json",
    staging: "https://digital-fortress-dev.eco.astro.com.my/dev/config/VZYyoAzvN5/config.json"
  },
  store: {
    production: "https://digital-fortress-assets.eco.astro.com.my/prod/config/K5OjDOxv2Z/config.json",
    staging: "https://digital-fortress-dev.eco.astro.com.my/dev/config/dpMB5pNylZ/config.json"
  }
};
const fallbackData$1 = (portal) => ({
  header: {
    universal: {
      sites: [
        { name: "Consumer", url: "" },
        { name: "Business", url: "" },
        { name: "Corporate", url: "" },
        { name: "Advertising", url: "" }
      ],
      crossPromo: {
        endpoint: "",
        name: "Our Brands"
      }
    },
    global: {
      logo: portal === "acm" ? {
        src: "https://acm-assets.eco.astro.com.my/images/astro-logo-white.svg",
        name: "Astro",
        url: ""
      } : {
        src: "https://acm-assets.eco.astro.com.my/images/myastro/logo_transparent_bg_15082022.svg",
        name: "MyAstro",
        url: ""
      },
      menu: "Menu",
      items: portal === "acm" ? [
        { name: "Astro TV Packs", url: "" },
        { name: "Astro Fibre", url: "" },
        { name: "Products & Services", url: "" },
        { name: "Content Guide", url: "" },
        { name: "Promotions", url: "" },
        { name: "My Account", url: "" },
        { name: "Support", url: "" }
      ] : [
        { name: "Account", url: "" },
        { name: "Astro Store", url: "" },
        { name: "Content", url: "" },
        { name: "Rewards", url: "" },
        { name: "Support", url: "" }
      ]
    },
    utility: {
      languageOptions: [],
      account: {
        button: {
          login: "Login",
          profile: "Profile"
        },
        menuLabel: {
          manage: "",
          logout: ""
        }
      },
      search: {
        button: "Search",
        form: {
          endpoint: "",
          queryKey: "",
          placeholder: ""
        }
      },
      hideLanguageRegex: []
    },
    auth: {
      loginUrlParams: {
        endpoint: "",
        queryParams: {}
      },
      profileUrl: {
        default: "",
        uxf: ""
      },
      session: {
        endpoints: {
          refresh: "",
          getUser: ""
        },
        client: "",
        payload: "",
        startSessionExpiry: 1440,
        refreshSessionExpiry: 10080
      },
      whitelistedUxfDomains: []
    },
    banner: {
      endpoint: "",
      bcpV3Endpoint: "",
      portalRegexMap: {
        homepage: "astro\\.com\\.my\\/?(bm)?(\\?.*?)?$",
        fibre: "astro\\.com\\.my\\/fibre",
        shop: "shop\\.astro\\.com\\.my",
        product: "products?\\.astro\\.com\\.my",
        support: "support\\.astro\\.com\\.my",
        promotions: "promotions\\.astro\\.com\\.my",
        uxf: "",
        contentGuide: "content\\.com\\.my",
        legacy: "astro\\.com\\.my\\/(?!fibre|bm)."
      },
      enabledPortals: [],
      dismissDuration: 1440,
      timerUnits: {
        fullForm: { day: "", hour: "", minute: "", second: "", separator: "" },
        shortForm: { day: "", hour: "", minute: "", second: "", separator: "" }
      },
      modal: {
        endpoint: "",
        bcpV3Endpoint: "https://contenthub-api.eco.astro.com.my/bcp/v3/entry-modal-en.json"
      }
    },
    chatbot: {
      hiddenPortals: []
    }
  },
  footer: {
    groups: [],
    complaint: { name: "", url: "", src: "" },
    contacts: {
      headingHtml: "",
      socials: []
    },
    mobileApps: {
      heading: "",
      apps: []
    },
    documentLinks: [],
    copyrightHtml: ""
  },
  liveChat: {
    chatEndpoint: "",
    chatCodes: [],
    scrollHeightToShowBubble: 400,
    idleSecondsToShowBubble: 30,
    icon: { src: "", alt: "" },
    helpText: "",
    bubbleTitle: "",
    bubbleDescription: ""
  }
});
function useNavConfig$1({
  endpoint,
  environment = "production",
  locale = DEFAULT_LOCALE,
  portal = "acm"
}) {
  var _a;
  const { data: df } = useDfConfig(endpoint || ((_a = presetEndpoints$3[portal]) == null ? void 0 : _a[environment]), [
    "header",
    "footer",
    "live_chat"
  ]);
  if (df) {
    const { locales: headerLocales = {}, ...rawHeaderDf } = df[0];
    const headerDf = mergeLocale(rawHeaderDf, headerLocales[locale]);
    const headerConfig = { ...headerDf };
    headerConfig.utility.languageOptions = headerDf.utility.languageOptions.reduce((acc, { locale: optionLocale, ...option }) => {
      if (isSupportedLocale(optionLocale)) acc.push({ locale: optionLocale, ...option });
      return acc;
    }, []);
    const { locales: footerLocales = {}, ...rawFooterDf } = df[1];
    const footerConfig = mergeLocale(rawFooterDf, footerLocales[locale]);
    const { locales: liveChatLocales = {}, ...rawLiveChatDf } = df[2];
    const liveChatDf = mergeLocale(rawLiveChatDf, liveChatLocales[locale]);
    const liveChatConfig = { ...liveChatDf };
    liveChatConfig.chatCodes = liveChatDf.chatCodes.map(({ code, regex }) => ({
      code: code ?? liveChatDf.defaultChatCode,
      regex
    }));
    return {
      header: headerConfig,
      footer: footerConfig,
      liveChat: liveChatConfig
    };
  }
  return fallbackData$1(portal);
}
const NavProvider$1 = ({ children, dfEndpoint, environment, onLocaleChange, portal }) => {
  const [locale, setLocale] = useState(DEFAULT_LOCALE);
  const config = useNavConfig$1({ portal, environment, endpoint: dfEndpoint, locale });
  useEffect(() => {
    const localeEventHandler = (e) => {
      const updatedLocale = e.detail;
      if (updatedLocale && isSupportedLocale(updatedLocale)) {
        setLocale(updatedLocale);
        onLocaleChange == null ? void 0 : onLocaleChange(updatedLocale);
      }
    };
    window.addEventListener(LOCALE_EVENT, localeEventHandler);
    return () => {
      window.removeEventListener(LOCALE_EVENT, localeEventHandler);
    };
  }, [onLocaleChange]);
  useEffect(() => {
    let preferredLocale = getCookie(LOCALE_COOKIE);
    if (!preferredLocale) {
      const [localeUrlSegment] = window.location.pathname.split("/").slice(1);
      preferredLocale = localeUrlSegment;
    }
    toggleLocale(preferredLocale);
  }, []);
  return typeof children === "function" ? children({ config, locale }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children });
};
function createProductCardClass(...elements) {
  return createBemName("product-card", ...elements);
}
function getHighestElementHeight(targetElementClass) {
  const element = document.querySelectorAll(targetElementClass);
  const highestElement = Math.max(...Array.from(element).map((d) => d.clientHeight));
  return highestElement;
}
function normalizeProductCard(containerId, datasetValue = "") {
  const productCardDataAttr = datasetValue ? `[data-product-card-group="${datasetValue}"]` : "";
  const container = document.getElementById(containerId);
  const hasRibbonInsideTheWrapper = container == null ? void 0 : container.querySelector(
    `${productCardDataAttr} .product-card__ribbon`
  );
  const hasBadgesInsideTheWrapper = container == null ? void 0 : container.querySelector(
    `${productCardDataAttr} .product-card__badges`
  );
  const productCards = container == null ? void 0 : container.querySelectorAll(`${productCardDataAttr}.product-card`);
  const descriptionHeight = getHighestElementHeight(`${productCardDataAttr} .product-card__description`);
  const titleHeight = getHighestElementHeight(`${productCardDataAttr} .product-card__header`);
  const panelWrapperHeight = getHighestElementHeight(`${productCardDataAttr} .product-card__panels-wrapper`);
  productCards == null ? void 0 : productCards.forEach((productCard) => {
    if (!datasetValue && productCard.dataset.productCardGroup) return;
    const hasOwnRibbon = productCard.querySelector(".product-card__ribbon");
    if (!hasOwnRibbon && hasRibbonInsideTheWrapper) {
      const ribbonWrapper = productCard.querySelector(".product-card__ribbon-wrapper");
      if (ribbonWrapper) {
        ribbonWrapper.style.height = "36px";
      }
    }
    const hasOwnBadges = productCard.querySelector(".product-card__badges");
    if (!hasOwnBadges && hasBadgesInsideTheWrapper) {
      const badgesWrapper = productCard.querySelector(".product-card__badges-wrapper");
      if (badgesWrapper) {
        badgesWrapper.style.height = "20px";
      }
    }
    const description = productCard.querySelector(".product-card__description");
    if (description) {
      description.style.height = `${descriptionHeight}px`;
    }
    const title = productCard.querySelector(".product-card__header");
    if (title) {
      title.style.height = `${titleHeight}px`;
    }
    const panelWrapper = productCard.querySelector(".product-card__panels-wrapper");
    if (panelWrapper) {
      panelWrapper.style.height = `${panelWrapperHeight}px`;
    }
  });
}
const Ribbon = ({ backgroundImageUrl, text, shouldReduceOpacity }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    style: { backgroundImage: `url(${backgroundImageUrl})` },
    className: cn(
      createProductCardClass("ribbon"),
      "relative -mb-7 line-clamp-1 h-16 w-full rounded-t duration-75 lg:rounded-t-lg",
      shouldReduceOpacity && "opacity-75"
    ),
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "pt-2 text-center text-sm", text })
  }
);
const SelectorWrapper = ({ selected, children, className, onChange, type, ...props }) => {
  const isInfoCard = type === "info";
  const handleClick = (event) => {
    if (isInfoCard) return;
    event.stopPropagation();
    onChange == null ? void 0 : onChange();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      onClick: handleClick,
      className: cn("relative overflow-hidden rounded bg-white shadow lg:rounded-lg", className),
      "aria-hidden": "true",
      role: isInfoCard ? "" : "button",
      ...props,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            className: cn(
              "absolute  right-0 top-0 h-0 w-0 border-b-[48px] border-l-0 border-r-[48px] border-t-0 border-solid border-transparent border-r-neutral-200 duration-75",
              selected && "border-r-blue-500",
              isInfoCard && "hidden"
            )
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { viewBox: "0 0 16 16", className: "pointer-events-none absolute right-2 top-2 h-4 w-4 text-white opacity-100", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fill: "none", d: "M0 0h16v16H0z" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "path",
              {
                d: "M5.615 14.746a2 2 0 01-1.508-.685l-2.913-3.249A2 2 0 014.21 8.184l1.385 1.5 6.2-6.975a2 2 0 013.049 2.59l-7.709 8.746a2 2 0 01-1.512.7z",
                fill: "currentColor"
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "px-4 py-6 lg:px-6", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "div",
              {
                className: cn(
                  "pointer-events-none absolute left-0 top-0 z-[1] h-full w-full rounded border border-neutral-300 bg-transparent duration-75 lg:rounded-lg",
                  // The z-index is set to 1 to ensure that the wisepop modal, which has a fixed position and a z-index of 1, appears in front of the product card. This is because the DOM node of the wisepop modal is rendered after the DOM node of the product card.
                  selected && "border-2 border-blue-500",
                  isInfoCard && "border-neutral-200"
                )
              }
            ),
            children
          ] })
        ] })
      ]
    }
  );
};
const ProductCard = ({
  showCtaButton,
  ctaButtonText,
  ctaButtonUrl,
  onCtaButtonClick,
  icon,
  title,
  price,
  originalPrice,
  perMonthText,
  description,
  image,
  badges,
  ribbon,
  panels,
  forwardUtm,
  grouping,
  gaEventsConfig,
  ...baseSelectorProps
}) => {
  const ctaButtonUrlWithUtm = useUrlWithUtmQuery(ctaButtonUrl);
  const handleCtaButtonClick = () => {
    if (ctaButtonUrl) {
      const redirectionUrl = forwardUtm && ctaButtonUrlWithUtm ? ctaButtonUrlWithUtm : ctaButtonUrl;
      window.location.href = redirectionUrl;
      gtmPush({
        event: "select_item",
        content_type: "ACM Product",
        content_list_type: (gaEventsConfig == null ? void 0 : gaEventsConfig.contentListType) || "",
        content_title: title,
        content_id: redirectionUrl,
        item_name: ctaButtonText
      });
    }
    onCtaButtonClick == null ? void 0 : onCtaButtonClick();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      ...grouping ? { "data-product-card-group": grouping } : {},
      className: cn(createProductCardClass(), "relative w-full max-w-[328px]"),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: cn(createProductCardClass("ribbon-wrapper")), children: ribbon && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Ribbon,
          {
            ...ribbon,
            shouldReduceOpacity: baseSelectorProps.type === "selection" && !baseSelectorProps.selected
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(SelectorWrapper, { ...baseSelectorProps, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: cn(createProductCardClass("header"), "flex items-center"), children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("img", { width: 32, height: 32, alt: icon.alt, src: icon.src, loading: "lazy" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "ml-2 text-lg font-bold text-neutral-800", children: title })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-2 font-extrabold", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-2xl", children: price }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: perMonthText }),
            originalPrice && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-1.5 text-sm font-normal text-neutral-400", children: /* @__PURE__ */ jsxRuntimeExports.jsx("s", { children: originalPrice }) })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: cn(createProductCardClass("badges-wrapper"), "mt-2"), children: badges && badges.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: cn(createProductCardClass("badges"), "flex space-x-2"), children: badges.map((badgeText) => /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { variant: "gray", children: badgeText })) }) }),
          image ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: cn(createProductCardClass("banner"), "-mx-6 mt-4"), children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "relative block w-full pb-[56.25%]", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "absolute left-0 top-0 h-full w-full object-cover", src: image.src, alt: image.alt }) }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("hr", { className: "my-4 text-neutral-200" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: cn(createProductCardClass("description"), "mt-4 line-clamp-3 text-neutral-800"), children: description }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: cn(createProductCardClass("panels-wrapper"), "mt-4 space-y-4"), children: !!panels && panels }),
          showCtaButton && /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { className: "mt-6 block w-full text-center", onClick: handleCtaButtonClick, children: ctaButtonText })
        ] })
      ]
    }
  );
};
const Panel = ({
  title,
  icon,
  ctaLinkText,
  onCtaLinkClick,
  panelClassName,
  children,
  panelSelected,
  className,
  gaEventsConfig,
  packTitle
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: "flex items-center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: icon.src, alt: icon.alt, loading: "lazy", width: 24, height: 24 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: cn("ml-2 line-clamp-1 font-bold", panelSelected && "text-green"), children: title })
    ] }),
    ctaLinkText && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        variant: "text",
        className: "ml-2 whitespace-nowrap",
        onClick: (e) => {
          e.stopPropagation();
          gtmPush({
            event: "view_item",
            content_type: "ACM Product",
            content_list_type: (gaEventsConfig == null ? void 0 : gaEventsConfig.contentListType) || "",
            content_title: packTitle,
            item_name: ctaLinkText
          });
          onCtaLinkClick == null ? void 0 : onCtaLinkClick();
        },
        children: ctaLinkText
      }
    )
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: cn("mt-2 rounded-md bg-neutral-50 p-4", panelClassName), children })
] });
const ListPanel = ({ list, ...panelConfig }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Panel, { className: cn(createProductCardClass("base-panel")), ...panelConfig, children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { className: "grid gap-y-4", children: list.map(({ icon: { src, alt }, description }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("img", { width: 32, height: 32, src, alt, loading: "lazy" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "ml-2", children: description })
] }, src)) }) });
const AddButton = ({ onClick, selected }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "button",
  {
    type: "button",
    className: cn(
      "grid h-6 w-6 place-items-center rounded-sm bg-white",
      selected ? "bg-blue text-white" : "border border-neutral-300 bg-white"
    ),
    onClick,
    children: selected ? /* @__PURE__ */ jsxRuntimeExports.jsx(TickIcon, { width: 12, height: 12 }) : /* @__PURE__ */ jsxRuntimeExports.jsx(PlusIcon, { width: 12, height: 12 })
  }
);
const MAX_NUMBER_OF_ICONS$1 = 5;
const UpsellPanel = ({
  type,
  selected,
  panelIcon,
  description,
  onIconButtonClick,
  selectedPanelContent,
  ...panelConfig
}) => {
  if (type === "addon" && selected && selectedPanelContent) {
    const { addOns, price, panelTitle } = selectedPanelContent;
    const hasExceeded = MAX_NUMBER_OF_ICONS$1 < addOns.length;
    const extraItemAmount = hasExceeded ? addOns.length - MAX_NUMBER_OF_ICONS$1 + 1 : null;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Panel, { ...panelConfig, panelClassName: "bg-lime-200 h-24", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex justify-between", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "line-clamp-1 font-bold", children: panelTitle }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(AddButton, { selected, onClick: onIconButtonClick })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-1.5 flex items-end justify-between", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center -space-x-1", children: [
          addOns.filter((_, index) => !hasExceeded ? true : index < MAX_NUMBER_OF_ICONS$1 - 1).map(({ src, alt }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-8 w-8 overflow-hidden rounded-sm ring-2 ring-lime-200", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { loading: "lazy", src, alt, className: "h-full w-full" }, src) })),
          hasExceeded && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "flex h-8 w-8 items-center justify-center rounded-sm bg-lime-300 text-sm font-bold text-neutral-800 ring-2 ring-lime-200", children: [
            "+",
            extraItemAmount
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { className: "bg-lime-300 text-neutral-800", children: price })
      ] })
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Panel, { ...panelConfig, panelClassName: "bg-lime-200 h-24", panelSelected: selected, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex h-16 items-start justify-between", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("img", { width: 32, height: 32, src: panelIcon.src, alt: panelIcon.alt }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "mx-2 line-clamp-3 flex-1 text-sm", text: description }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AddButton,
      {
        selected,
        onClick: (e) => {
          e.stopPropagation();
          onIconButtonClick();
        }
      }
    )
  ] }) });
};
const BroadbandCard = (props) => {
  const { type } = props;
  let cardConfig;
  if (type === "selection") {
    const { selected, onChange } = props;
    cardConfig = {
      type,
      selected,
      onChange
    };
  } else {
    const { ctaButtonUrl, ctaButtonText, onCtaButtonClick } = props;
    cardConfig = {
      type,
      ctaButtonUrl,
      ctaButtonText,
      onCtaButtonClick
    };
  }
  const { upsellDetail, baseDetail, ...baseCardDetail } = props;
  [{ ...baseDetail, type: "list" }];
  let upsellPanelConfig = null;
  if (upsellDetail) {
    upsellPanelConfig = {
      type: upsellDetail.type,
      title: upsellDetail.title,
      panelIcon: upsellDetail.panelIcon,
      icon: upsellDetail.icon,
      onIconButtonClick: upsellDetail.onIconButtonClick,
      description: upsellDetail.description,
      ctaLinkText: upsellDetail.ctaLinkText,
      onCtaLinkClick: upsellDetail.onCtaLinkClick,
      selected: upsellDetail.selected,
      selectedPanelContent: {
        panelTitle: upsellDetail.panelTitle,
        addOns: upsellDetail.addOns,
        price: upsellDetail.price
      }
    };
  }
  const panels = [/* @__PURE__ */ jsxRuntimeExports.jsx(ListPanel, { ...baseDetail }), upsellPanelConfig && /* @__PURE__ */ jsxRuntimeExports.jsx(UpsellPanel, { ...upsellPanelConfig })];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ProductCard, { ...baseCardDetail, ...cardConfig, showCtaButton: cardConfig.type === "info", panels });
};
const MAX_NUMBER_OF_ICONS = 6;
const ContentPanel = ({ channelDescription, bundledAddOns, ...panelConfig }) => {
  const hasExceeded = MAX_NUMBER_OF_ICONS < bundledAddOns.length;
  const extraItemAmount = hasExceeded ? bundledAddOns.length - MAX_NUMBER_OF_ICONS + 1 : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Panel, { className: cn(createProductCardClass("base-panel")), ...panelConfig, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "font-bold", children: channelDescription }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-2 flex items-center -space-x-1", children: [
      bundledAddOns.filter((_, index) => !hasExceeded ? true : index < MAX_NUMBER_OF_ICONS - 1).map(({ src, alt }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-10 w-10 overflow-hidden rounded-sm bg-white ring-2 ring-neutral-50", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { loading: "lazy", src, alt, className: "h-full w-full" }, src) })),
      hasExceeded && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "flex h-10 w-10 items-center justify-center rounded-sm bg-magenta-50 text-sm font-bold text-magenta ring-2 ring-neutral-50", children: [
        "+",
        extraItemAmount
      ] })
    ] })
  ] });
};
const PackCard = (props) => {
  const { type } = props;
  const { grouping } = props;
  let cardConfig;
  if (type === "selection") {
    const { selected, onChange } = props;
    cardConfig = {
      type,
      selected,
      onChange
    };
  } else {
    const { ctaButtonUrl, ctaButtonText, onCtaButtonClick } = props;
    cardConfig = {
      type,
      ctaButtonUrl,
      ctaButtonText,
      onCtaButtonClick
    };
  }
  const { upsellDetail, baseDetail, gaEventsConfig, ...baseCardDetail } = props;
  let upsellPanelConfig = null;
  let upgradePackDetails = {};
  if (upsellDetail) {
    if (upsellDetail.type === "upgrade") {
      upsellPanelConfig = {
        type: upsellDetail.type,
        title: upsellDetail.selected ? upsellDetail.upgradeTitle : upsellDetail.title,
        panelIcon: upsellDetail.panelIcon,
        icon: upsellDetail.selected ? upsellDetail.selectedIcon : upsellDetail.icon,
        onIconButtonClick: upsellDetail.onIconButtonClick,
        description: upsellDetail.description,
        ctaLinkText: upsellDetail.ctaLinkText,
        onCtaLinkClick: upsellDetail.onCtaLinkClick,
        selected: upsellDetail.selected
      };
      if (upsellPanelConfig.selected) upgradePackDetails = upsellDetail.upgradePack;
    } else {
      upsellPanelConfig = {
        type: upsellDetail.type,
        title: upsellDetail.title,
        panelIcon: upsellDetail.panelIcon,
        icon: upsellDetail.icon,
        onIconButtonClick: upsellDetail.onIconButtonClick,
        description: upsellDetail.description,
        ctaLinkText: upsellDetail.ctaLinkText,
        onCtaLinkClick: upsellDetail.onCtaLinkClick,
        selected: upsellDetail.selected,
        selectedPanelContent: {
          panelTitle: upsellDetail.panelTitle,
          addOns: upsellDetail.addOns,
          price: upsellDetail.price
        }
      };
    }
  }
  const packTitle = upgradePackDetails.title || baseCardDetail.title;
  const newPanel = [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ContentPanel,
      {
        packTitle,
        gaEventsConfig,
        ...baseDetail,
        ...upgradePackDetails == null ? void 0 : upgradePackDetails.baseDetail
      }
    ),
    upsellPanelConfig && /* @__PURE__ */ jsxRuntimeExports.jsx(UpsellPanel, { ...upsellPanelConfig })
  ];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ProductCard,
    {
      gaEventsConfig,
      ...baseCardDetail,
      ...upgradePackDetails,
      ...cardConfig,
      grouping,
      showCtaButton: cardConfig.type === "info",
      panels: newPanel
    }
  );
};
const Normalizer = ({ id, ...props }) => {
  useEffect(() => {
    if (!id) return;
    const productCardWithAttribute = document == null ? void 0 : document.querySelectorAll(`[data-product-card-group]`);
    const grouping = [...new Set([...Array.from(productCardWithAttribute)].map((pc) => pc.dataset.productCardGroup))];
    normalizeProductCard(id);
    grouping.forEach((group) => normalizeProductCard(id, group));
  }, [id]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id, ...props });
};
const PopupModal = ({ isOpen, wrapperClassName, panelClassName, children }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Modal$1, { open: isOpen, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  ModalContent,
  {
    overrideAnimations: true,
    className: cn(
      "left-0 top-0 flex translate-x-0 translate-y-0 rounded-none border-none bg-transparent p-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
      "acm_overflow_modal_wrapper h-full w-full items-center justify-center data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
      wrapperClassName
    ),
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: cn("h-full w-full md:p-10 lg:py-8 xl:max-w-7xl xl:px-18", panelClassName), children })
  }
) });
const presetEndpoints$2 = {
  popupDf: {
    production: "https://digital-fortress-assets.eco.astro.com.my/prod/config/6rPy3LqBn0/config.json",
    staging: "https://digital-fortress-dev.eco.astro.com.my/dev/config/lE2v1p2BxY/config.json"
  },
  productPopup: {
    production: "https://cassandra-api.eco.astro.com.my/cassandra/api/v1/product-card/popup",
    staging: "https://cassandra-api-stg.eco.astro.com.my/cassandra/api/v1/product-card/popup"
  },
  productPopupV2: {
    production: "https://cassandra-api.eco.astro.com.my/cassandra/api/v2/product-card/popup",
    staging: "https://cassandra-api-stg.eco.astro.com.my/cassandra/api/v2/product-card/popup"
  },
  channelListing: {
    production: "https://contenthub-api.eco.astro.com.my/channel/min.json",
    staging: "https://contenthub-api-stg.eco.astro.com.my/channel/min.json"
  }
};
const gaContentType = "ACM Product Pop-up";
const pricePrefix = "RM";
function mapFromId(ids, data) {
  return ids.reduce((acc, id) => {
    const idString = id.toString();
    return data[idString] ? [...acc, data[idString]] : acc;
  }, []);
}
function convertLocale(locale = DEFAULT_LOCALE) {
  const localeMapping = {
    en: "eng",
    bm: "may"
  };
  return localeMapping[locale];
}
function formatAsPrice(price) {
  const priceToFixed = Number(price).toFixed(2);
  return pricePrefix + priceToFixed.toString();
}
function usePopupDfConfig(environment, locale) {
  const { data: df } = useDfConfig(presetEndpoints$2.popupDf[environment], "product_popup", {
    shouldAutoRevalidate: false
  });
  if (df) {
    const { locales = {}, ...rawPopupDf } = df;
    const popupDf = mergeLocale(rawPopupDf, locales[locale]);
    const { defaultWhiteList } = popupDf;
    const popupTextConfig = {
      layoutTextConfig: popupDf.layout,
      mainContentTextConfig: popupDf.mainContent,
      singleSecondaryContentTextConfig: popupDf.singleSecondaryContent,
      groupedSecondaryContentTextConfig: popupDf.groupedSecondaryContent,
      appContentTextConfig: popupDf.appContent,
      broadbandContentTextConfig: popupDf.broadbandContent
    };
    return { ...popupTextConfig, defaultWhiteList };
  }
  return null;
}
function useChannelListing(endpoint) {
  const { data: channelData, error: channelError } = useAsync({
    endpoint,
    formatResponse: (response) => response
  });
  if (channelError) {
    logger.error(channelError);
    return null;
  }
  return channelData;
}
function createSidebarConfig$2(response) {
  return response.map((category) => ({
    title: category.categoryTitle,
    categoryContent: category.apps.map((item) => ({
      id: item.id,
      title: item.baseDetails.name,
      icon: item.baseDetails.icon ? { src: item.baseDetails.icon, alt: item.baseDetails.name } : void 0
    }))
  }));
}
function createAppContentConfig(response, df, hasSession) {
  const { baseDetails, plans, type, bfDetails, gfDetails } = { ...response };
  const priceDetails = hasSession ? bfDetails : gfDetails;
  const getCheapestPlanPrice = () => {
    const cheapestPlan = response.plans.reduce(
      (lowest, item) => item[hasSession ? "bfDetails" : "gfDetails"].price < lowest[hasSession ? "bfDetails" : "gfDetails"].price ? item : lowest
    );
    return hasSession ? cheapestPlan.bfDetails.price : cheapestPlan.gfDetails.price;
  };
  return {
    featureConfig: {
      featureShows: baseDetails.images.map((item) => ({
        image: {
          src: item.image,
          alt: item.altText
        }
      })),
      featureShowTitle: df.featureShowTitle
    },
    appDescriptionConfig: {
      title: baseDetails.name,
      subtitle: plans.length > 1 ? interpolate(df.minPriceText, {
        minPrice: formatAsPrice(getCheapestPlanPrice())
      }) : formatAsPrice(plans.length === 1 ? getCheapestPlanPrice() : priceDetails.price),
      icon: {
        src: baseDetails.icon,
        alt: baseDetails.name
      },
      description: baseDetails.description
    },
    planCardCarousel: {
      title: plans.length <= 1 ? df.planCardSectionTitle.singlePlan : interpolate(df.planCardSectionTitle.multiPlan, { planAmount: plans.length }),
      cards: type === "app" ? [
        {
          title: baseDetails.name,
          icon: {
            src: baseDetails.icon,
            alt: baseDetails.name
          },
          price: formatAsPrice(priceDetails.price),
          perMonthText: df.perMonthText,
          isDiscounted: Boolean(priceDetails.originalPrice),
          subPrice: priceDetails.originalPrice ? formatAsPrice(priceDetails.originalPrice) : priceDetails.rrp ? interpolate(df.rrpText, {
            rrp: formatAsPrice(priceDetails.rrp)
          }) : void 0,
          perks: baseDetails.highlights.map((highlight) => ({
            icon: highlight.icon ? {
              src: highlight.icon,
              alt: highlight.id
            } : void 0,
            title: highlight.text
          }))
        }
      ] : plans.map((plan) => {
        const planPriceDetails = hasSession ? plan.bfDetails : plan.gfDetails;
        return {
          title: plan.baseDetails.name,
          icon: { src: plan.baseDetails.icon, alt: plan.baseDetails.name },
          price: formatAsPrice(hasSession ? plan.bfDetails.price : plan.gfDetails.price),
          perMonthText: df.perMonthText,
          isDiscounted: Boolean(planPriceDetails.originalPrice),
          subPrice: planPriceDetails.originalPrice ? formatAsPrice(planPriceDetails.originalPrice) : planPriceDetails.rrp ? interpolate(df.rrpText, {
            rrp: formatAsPrice(planPriceDetails.rrp)
          }) : void 0,
          perks: plan.baseDetails.highlights.map((highlight) => ({
            icon: highlight.icon ? {
              src: highlight.icon,
              alt: highlight.id
            } : void 0,
            title: highlight.text
          }))
        };
      })
    }
  };
}
function useAppContentConfig({
  platform,
  locale,
  environment,
  inclusionList
}) {
  const apiLanguageOption = convertLocale(locale);
  const df = usePopupDfConfig(environment, locale);
  const hasSession = hasExistingSession();
  const { data: response, error } = useAsync({
    shouldAutoRevalidate: false,
    endpoint: (
      // eslint-disable-next-line prefer-template
      `${presetEndpoints$2.productPopupV2[environment]}?platform=${platform}&language=${apiLanguageOption}&explore=app`
    ),
    formatResponse: (res) => res
  });
  const data = useMemo(() => {
    if (response) {
      if (!inclusionList) return response;
      const includedAppIds = inclusionList.map((filterObject) => filterObject.appId);
      return response.reduce((acc, category) => {
        const apps = category.apps.filter((app) => includedAppIds.includes(app.id)).map((app) => {
          const appInclusionSettings = inclusionList.find((list) => list.appId === app.id);
          const planInclusionList = appInclusionSettings == null ? void 0 : appInclusionSettings.plans;
          if (!planInclusionList || planInclusionList.length === 0) {
            return {
              ...app
            };
          }
          return {
            ...app,
            plans: app.plans.filter((plan) => planInclusionList.includes(plan.id))
          };
        });
        acc.push({ ...category, apps });
        return acc;
      }, []);
    }
  }, [inclusionList, response]);
  if (error) {
    logger.error(error);
  }
  const getAppContentConfig = useCallback(
    (appId) => {
      const mainContentData = data == null ? void 0 : data.flatMap((category) => category.apps).find((item) => item.id === appId);
      if (mainContentData && df) {
        return createAppContentConfig(mainContentData, df.appContentTextConfig, hasSession || false);
      }
      return null;
    },
    [data, df, hasSession]
  );
  const sidebarConfig = data ? createSidebarConfig$2(data) : null;
  return {
    sidebar: sidebarConfig,
    getAppContentConfig,
    categories: data
  };
}
function createBroadbandContent(broadbandSpeedDetails, df, hasSession) {
  return broadbandSpeedDetails.map((speed) => ({
    id: speed.id,
    descriptionConfig: {
      title: speed.baseDetails.name,
      subtitle: hasSession ? speed.bfDetails.displayPrice : speed.gfDetails.displayPrice,
      icon: {
        src: speed.baseDetails.icon,
        alt: speed.baseDetails.name
      },
      notes: hasSession ? speed.bfDetails.notes : speed.gfDetails.notes
    },
    features: hasSession ? speed.bfDetails.uniqueSellingPoints.map((usp) => ({
      icon: {
        src: usp.icon,
        alt: usp.id
      },
      description: usp.text
    })) : speed.gfDetails.uniqueSellingPoints.map((usp) => ({
      icon: {
        src: usp.icon,
        alt: usp.id
      },
      description: usp.text
    })),
    info: hasSession ? speed.bfDetails.additionalInfo.map((info) => ({
      icon: {
        src: info.icon,
        alt: info.id
      },
      description: info.text
    })) : speed.gfDetails.additionalInfo.map((info) => ({
      icon: {
        src: info.icon,
        alt: info.id
      },
      description: info.text
    })),
    featureTitle: df.broadbandFeatureTitle,
    infoTitle: df.infoTitle
  }));
}
function createMeshContent(meshDevicesDetails, df, hasSession) {
  return meshDevicesDetails.map((device) => ({
    id: device.id,
    descriptionConfig: {
      title: device.baseDetails.name,
      icon: {
        src: device.baseDetails.icon,
        alt: device.baseDetails.name
      }
    },
    features: hasSession ? device.baseDetails.highlights.map((highlight) => ({
      icon: {
        src: highlight.icon,
        alt: highlight.id
      },
      description: highlight.text
    })) : device.baseDetails.highlights.map((highlight) => ({
      icon: {
        src: highlight.icon,
        alt: highlight.id
      },
      description: highlight.text
    })),
    featureTitle: df.meshFeatureTitle
  }));
}
function createBroadbandPopUpContentConfig(data, df, hasSession) {
  return {
    sideBarConfig: {
      categories: data.map((popUpType) => {
        if (popUpType.type === "broadband") {
          return {
            title: popUpType.categoryTitle,
            categoryContent: popUpType.broadbandSpeeds.map((speed) => ({
              id: speed.id,
              title: speed.baseDetails.name,
              icon: { src: speed.baseDetails.icon, alt: speed.baseDetails.name }
            }))
          };
        }
        return {
          title: popUpType.categoryTitle,
          categoryContent: popUpType.meshDevices.map((device) => ({
            id: device.id,
            title: device.baseDetails.name,
            icon: { src: device.baseDetails.icon, alt: device.baseDetails.name }
          }))
        };
      })
    },
    exploreButtonText: df.exploreButtonText,
    content: data.map((popUpType) => {
      if (popUpType.type === "broadband") {
        return createBroadbandContent(popUpType.broadbandSpeeds, df, hasSession);
      }
      return createMeshContent(popUpType.meshDevices, df, hasSession);
    }).flat()
  };
}
function useBroadbandContentConfig(locale, platform, environment, showMesh, isp, broadbandInclusionList) {
  var _a;
  const apiLanguageOption = convertLocale(locale);
  const hasSession = hasExistingSession();
  const { data, error } = useAsync({
    shouldAutoRevalidate: false,
    endpoint: (
      // eslint-disable-next-line prefer-template
      presetEndpoints$2.productPopupV2[environment] + `?platform=${platform}&language=${apiLanguageOption}&explore=${showMesh ? "broadband,mesh" : "broadband"}` + (isp ? `&isp=${isp}` : "")
    ),
    formatResponse: (response) => response
  });
  const df = (_a = usePopupDfConfig(environment, locale)) == null ? void 0 : _a.broadbandContentTextConfig;
  if (error) {
    logger.error(error);
    return null;
  }
  if (!data || data.length === 0 || !df) return null;
  const config = createBroadbandPopUpContentConfig(data, df, hasSession);
  if (broadbandInclusionList) {
    const meshId = showMesh && config.sideBarConfig.categories[1].categoryContent[0].id;
    const filteredContent = config.content.filter(
      (content) => broadbandInclusionList.includes(content.id) || content.id === meshId
    );
    const filteredBroadbandSidebar = config.sideBarConfig.categories[0].categoryContent.filter(
      (content) => broadbandInclusionList.includes(content.id)
    );
    const filteredConfig = {
      ...config,
      content: filteredContent,
      sideBarConfig: {
        categories: [
          { ...config.sideBarConfig.categories[0], categoryContent: filteredBroadbandSidebar },
          ...showMesh ? [config.sideBarConfig.categories[1]] : []
        ]
      }
    };
    return filteredConfig;
  }
  return config;
}
function createSidebarConfig$1(response) {
  return response.map((category) => ({
    title: category.categoryTitle,
    categoryContent: category.tvPacks.map((item) => ({
      id: item.id,
      title: item.baseDetails.name,
      icon: item.baseDetails.icon ? { src: item.baseDetails.icon, alt: item.baseDetails.name } : void 0,
      badge: item.baseDetails.tag || void 0
    }))
  }));
}
function createMainContentConfig(response, df, hasSession, utilizeDfPricing) {
  return {
    packConfig: {
      title: response.baseDetails.name,
      icon: response.baseDetails.icon ? { src: response.baseDetails.icon, alt: response.baseDetails.name } : void 0,
      description: response.baseDetails.description,
      // TODO: Relook on this
      price: formatAsPrice(
        utilizeDfPricing && df.overwritePrice ? df.overwritePrice[response.id] ? df.overwritePrice[response.id] : hasSession ? response.bfDetails.price : response.gfDetails.price : hasSession ? response.bfDetails.price : response.gfDetails.price
      ),
      originalPrice: utilizeDfPricing && df.overwritePrice && df.overwritePrice[response.id] ? formatAsPrice(
        response.gfDetails.originalPrice ? response.gfDetails.originalPrice : response.gfDetails.price
      ) : hasSession ? response.bfDetails.originalPrice ? formatAsPrice(response.bfDetails.originalPrice) : void 0 : response.gfDetails.originalPrice ? formatAsPrice(response.gfDetails.originalPrice) : void 0,
      badge: response.baseDetails.tag || void 0,
      packImage: { src: response.baseDetails.images[0].image, alt: response.baseDetails.images[0].altText }
    },
    addOnConfig: {
      title: interpolate(df.bundledContentTextConfig.addOnsSectionTitle, {
        noOfChannels: response.bundledContent.noOfChannels
      }),
      content: response.bundledContent.addOns.map((addOn) => ({
        id: addOn.id,
        title: addOn.name,
        description: interpolate(
          addOn.type === "asianFav" ? addOn.noOfApps > 1 ? df.bundledContentTextConfig.groupedSecondaryContentAddOnItemDescription.multiApp : df.bundledContentTextConfig.groupedSecondaryContentAddOnItemDescription.singleApp : addOn.noOfChannels > 1 ? df.bundledContentTextConfig.addOnItemDescription.multiChannel : df.bundledContentTextConfig.addOnItemDescription.singleChannel,
          { noOfApps: addOn.noOfApps, noOfChannels: addOn.noOfChannels }
        ),
        icon: { src: addOn.icon, alt: addOn.name },
        type: addOn.type
      }))
    },
    appConfig: {
      title: interpolate(
        response.bundledContent.noOfApps > 1 ? df.bundledContentTextConfig.appSectionTitle.multiApp : df.bundledContentTextConfig.appSectionTitle.singleApp,
        { noOfApps: response.bundledContent.noOfApps }
      ),
      content: response.bundledContent.apps.map((app) => ({
        id: app.id,
        type: app.type,
        title: app.name,
        description: interpolate(
          app.noOfScreens > 1 ? df.bundledContentTextConfig.appItemDescription.multiScreen : df.bundledContentTextConfig.appItemDescription.singleScreen,
          { noOfScreens: app.noOfScreens, resolution: app.resolution }
        ),
        icon: { src: app.icon, alt: app.name }
      }))
    },
    serviceConfig: response.bundledContent.services.length > 0 ? {
      title: df.bundledContentTextConfig.serviceSectionTitle,
      content: response.bundledContent.services.map((service) => ({
        id: service.id,
        type: service.type,
        title: service.baseDetails.name,
        icon: { src: service.baseDetails.icon, alt: service.baseDetails.name }
      }))
    } : void 0,
    backgroundImage: response.baseDetails.backgroundBanner,
    contentsTitle: df.contentsTitle,
    subsectionCollapseText: df.subsectionCollapseText,
    subsectionExpandText: df.subsectionExpandText,
    perMonthText: df.perMonthText,
    ctaLink: response.baseDetails.ctaLinkWeb || void 0
  };
}
function createSecondaryChannelContentConfig(response, df, channelList, locale) {
  return {
    featureShowTitle: df.featureShowTitle,
    channelSectionTitle: df.channelSectionTitle,
    icon: { src: response.icon, alt: response.name },
    title: response.name,
    subtitle: interpolate(response.channels.length > 1 ? df.packSubtitle.multiChannel : df.packSubtitle.singleChannel, {
      noOfChannels: response.channels.length
    }),
    description: response.description,
    featureShows: response.images.map((item) => ({
      image: {
        src: item.image,
        alt: item.altText
      }
    })),
    channels: mapFromId(response.channels, channelList).map((channel) => ({
      title: locale === "bm" ? channel.subtitle_my : channel.subtitle,
      image: {
        src: channel.imageUrl,
        alt: channel.title
      },
      subtitle: channel.title
    }))
  };
}
function usePackContentConfig({
  platform,
  locale,
  environment,
  inclusionList,
  utilizeDfPricing
}) {
  const hasSession = hasExistingSession();
  const apiLanguageOption = convertLocale(locale);
  const df = usePopupDfConfig(environment, locale);
  const channelList = useChannelListing(presetEndpoints$2.channelListing[environment]);
  const { data: response, error } = useAsync({
    shouldAutoRevalidate: false,
    endpoint: (
      // eslint-disable-next-line prefer-template
      `${presetEndpoints$2.productPopupV2[environment]}?platform=${platform}&language=${apiLanguageOption}&explore=pack`
    ),
    formatResponse: (res) => res
  });
  const data = useMemo(() => {
    if (response) {
      if (!inclusionList) return response;
      return response.reduce((acc, category) => {
        const tvPacks = category.tvPacks.filter((packs) => inclusionList.includes(packs.id));
        acc.push({ ...category, tvPacks });
        return acc;
      }, []);
    }
  }, [inclusionList, response]);
  if (error) {
    logger.error(error);
  }
  const getMainContentConfig = useCallback(
    (packId) => {
      const mainContentData = data == null ? void 0 : data.flatMap((category) => category.tvPacks).find((item) => item.id === packId);
      if (mainContentData && df) {
        return createMainContentConfig(
          mainContentData,
          df.mainContentTextConfig,
          hasSession || false,
          utilizeDfPricing
        );
      }
      return null;
    },
    [data, df, hasSession, utilizeDfPricing]
  );
  const getPackChannelContentConfig = useCallback(
    (packId, contentId) => {
      const mainContentData = data == null ? void 0 : data.flatMap((category) => category.tvPacks).find((item) => item.id === packId);
      const channelContentData = mainContentData == null ? void 0 : mainContentData.bundledContent.addOns.find((item) => item.id === contentId);
      if (!channelContentData || !df || !channelList) return null;
      return createSecondaryChannelContentConfig(
        channelContentData,
        df.singleSecondaryContentTextConfig,
        channelList,
        locale
      );
    },
    [channelList, data, df, locale]
  );
  const sidebarConfig = data ? createSidebarConfig$1(data) : null;
  return {
    sidebar: sidebarConfig,
    getMainContentConfig,
    getPackChannelContentConfig,
    categories: data
  };
}
const ReturnButton = ({ buttonText, onClick }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, { icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowIcon, { direction: "left" }), variant: "accent", size: "small", onClick }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-2", children: buttonText || /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-5 w-[192px] rounded-sm" }) })
] });
const BottomBar = ({
  ctaButtonText,
  showExploreButton,
  showCtaButton,
  onExploreButtonClick,
  onReturnButtonClick,
  onCtaButtonClick,
  exploreButtonText,
  returnButtonText,
  showReturnButton
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-auto flex h-16 items-center px-4 py-2 md:pl-8", children: [
  showExploreButton && /* @__PURE__ */ jsxRuntimeExports.jsx(ReturnButton, { onClick: onExploreButtonClick, buttonText: exploreButtonText }),
  showReturnButton && /* @__PURE__ */ jsxRuntimeExports.jsx(ReturnButton, { onClick: onReturnButtonClick, buttonText: returnButtonText }),
  showCtaButton && ctaButtonText && /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { className: "ml-auto flex-shrink-0 px-4 md:mr-6 xl:px-10", onClick: onCtaButtonClick, children: ctaButtonText })
] });
const CategoryContentText = ({ boldOnHover, bold, className, text, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "span",
  {
    "data-title": text,
    className: cn(
      "mt-0.5 tracking-wide antialiased outline-none before:invisible before:block before:h-0 before:overflow-hidden before:font-bold before:tracking-wide before:content-[attr(data-title)]",
      boldOnHover && "focus:font-bold group-hover:font-bold group-hover:tracking-normal group-hover:text-magenta-v2",
      bold && "font-bold tracking-normal text-magenta-v2",
      className
    ),
    ...props,
    children: text
  }
);
const CategoryContent = ({
  title,
  icon,
  badge,
  onCategoryItemClick,
  id,
  isSelected
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    className: cn(
      "group flex cursor-pointer rounded-sm px-2 py-4 text-neutral-v2-80 hover:bg-neutral-v2-5",
      isSelected && "bg-neutral-v2-5"
    ),
    onClick: () => onCategoryItemClick(id, title),
    onKeyDown: () => onCategoryItemClick(id, title),
    role: "button",
    tabIndex: 0,
    children: [
      icon && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { height: 24, width: 24, alt: icon.alt, src: icon.src, loading: "lazy", className: "mr-2 shrink-0 self-start" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CategoryContentText, { text: title, bold: isSelected }),
      badge && /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { className: "ml-auto self-center", children: badge })
    ]
  }
);
const SidebarCategory = ({ title, categoryContent, onCategoryItemClick }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mb-4", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "align-center flex items-center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-neutral-v2-80 ty-heading5", children: title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("hr", { className: "ml-2 inline-block flex-grow text-neutral-v2-5" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "space-y-1 pt-4", children: categoryContent.map((item) => /* @__PURE__ */ createElement(CategoryContent, { onCategoryItemClick, ...item, key: item.id })) })
] });
const SidebarSkeleton = () => {
  const categoryAmount = 2;
  const subCategoryAmount = 3;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: [...Array(categoryAmount).keys()].map((key) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mb-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "align-center flex items-center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center flex h-5 items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-3.5 w-24" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("hr", { className: "ml-2 inline-block flex-grow text-neutral-v2-20" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "space-y-1 pt-4", children: [...Array(subCategoryAmount).keys()].map((innerKey) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex rounded-sm px-2 py-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "mr-2 h-6 w-6 shrink-0 self-start" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center flex items-center py-px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "my-0.5 h-4 w-36" }) })
    ] }, innerKey)) })
  ] }, key)) });
};
const Sidebar = ({ categories, onCategoryItemClick, activePack }) => /* @__PURE__ */ jsxRuntimeExports.jsx("aside", { className: "w-full px-4 pt-4 max-md:mt-1.5", children: categories.length === 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarSkeleton, {}) : categories.map((category) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SidebarCategory,
  {
    onCategoryItemClick,
    title: category.title,
    categoryContent: category.categoryContent.map((item) => ({ ...item, isSelected: item.id === activePack }))
  },
  category.title
)) });
const PopupLayout = ({
  exploreButtonText,
  className,
  children,
  isSubContentVisible,
  childContainerClassName,
  ctaButtonText,
  sidebarCategories,
  secondaryContentReturnButtonText,
  sidebarReturnButtonText,
  onCategoryItemClick,
  showBottomBar,
  onSecondaryContentReturnButtonClick,
  onCloseButtonClick,
  onCtaButtonClick,
  showCtaButton,
  activeSidebarItemId,
  isSidebarDefaultOpened: sidebarDefaultOpen
}) => {
  const isDesktop = useBreakpoint("lg");
  const isTablet = useBreakpoint("md");
  const [isSidebarVisible, setSidebarVisible] = useBoolean(sidebarDefaultOpen);
  const handleCategoryItemClick = (itemId, itemTitle) => {
    onCategoryItemClick(itemId, itemTitle);
    setSidebarVisible.off();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: cn("relative flex h-full overflow-hidden bg-white md:rounded", className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: cn("absolute right-4 top-4 z-10 flex rounded-lg bg-white"), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      CloseButton,
      {
        className: cn(
          "rounded-lg p-1.5 shadow-[0px_4px_20px_0px_rgba(77,79,90,0.1)]",
          isSubContentVisible && "lg:shadow-none"
        ),
        onClick: onCloseButtonClick
      }
    ) }),
    !isDesktop ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      Transition,
      {
        show: isSidebarVisible,
        enter: "duration-150 ease-out",
        enterFrom: "w-0",
        enterTo: "w-screen md:w-[calc(100vw_-_80px)]",
        leave: "duration-100 ease-in",
        leaveFrom: "w-screen md:w-[calc(100vw_-_80px)]",
        leaveTo: "w-0",
        className: "overflow-y-auto overflow-x-hidden",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-screen md:w-[calc(100vw_-_80px)]", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Sidebar,
          {
            categories: sidebarCategories,
            onCategoryItemClick: handleCategoryItemClick,
            activePack: activeSidebarItemId
          }
        ) })
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "overflow-y-auto overflow-x-hidden lg:w-[256px] xl:w-[272px]", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Sidebar,
      {
        categories: sidebarCategories,
        onCategoryItemClick: handleCategoryItemClick,
        activePack: activeSidebarItemId
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex h-full flex-1 flex-col overflow-hidden", children: [
      isSubContentVisible && onSecondaryContentReturnButtonClick && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hidden h-16 items-center px-4 lg:flex", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ReturnButton, { buttonText: secondaryContentReturnButtonText, onClick: onSecondaryContentReturnButtonClick }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: cn(
            "w-screen flex-1 overflow-y-auto rounded-bl-sm md:w-[calc(100vw_-_80px)] lg:w-full lg:rounded-bl",
            isSubContentVisible && "lg:rounded-tl",
            isSidebarVisible && "overflow-hidden lg:overflow-y-auto",
            showBottomBar && "rounded-bl-sm lg:rounded-bl",
            childContainerClassName
          ),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "overflow-x-hidden", children })
        }
      ),
      showBottomBar && /* @__PURE__ */ jsxRuntimeExports.jsx(
        BottomBar,
        {
          onExploreButtonClick: setSidebarVisible.on,
          ctaButtonText,
          returnButtonText: isSubContentVisible ? secondaryContentReturnButtonText : isTablet ? sidebarReturnButtonText : "",
          showCtaButton: !(isSidebarVisible && !isDesktop) && !(isSubContentVisible && !isDesktop) && showCtaButton,
          showExploreButton: !isSidebarVisible && !isDesktop && !isSubContentVisible,
          showReturnButton: (isSidebarVisible || Boolean(isSubContentVisible)) && !isDesktop,
          onReturnButtonClick: () => {
            isSubContentVisible ? onSecondaryContentReturnButtonClick == null ? void 0 : onSecondaryContentReturnButtonClick() : setSidebarVisible.off();
          },
          exploreButtonText,
          onCtaButtonClick
        }
      )
    ] })
  ] });
};
const Description = ({ icon, title, subtitle, description, strikethroughPrice, notes }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded bg-neutral-v2-0 p-4 shadow-sm-below", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center", children: [
    icon,
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ml-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "ty-heading5 md:ty-heading4", children: title }),
      subtitle && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex text-neutral-v2-80 ty-caption md:ty-body", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { text: subtitle }),
        strikethroughPrice && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-1 text-neutral-v2-60 line-through", children: strikethroughPrice })
      ] })
    ] })
  ] }),
  notes && /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "mt-2 text-neutral-v2-80 ty-caption", text: notes }),
  description && /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "mt-4 text-neutral-v2-80", text: description })
] });
const ChevronDownIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  "path",
  {
    className: "outliner",
    d: "M3 5L8 11L13 5",
    stroke: "black",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) });
const CarouselContext = React.createContext(null);
function useCarousel() {
  const context = React.useContext(CarouselContext);
  if (!context) {
    throw new Error("useCarousel must be used within a <Carousel />");
  }
  return context;
}
const Carousel = React.forwardRef(
  ({ orientation = "horizontal", opts, setApi, plugins, className, children, ...props }, ref) => {
    const [carouselRef, api] = useEmblaCarousel(
      {
        ...opts,
        axis: orientation === "horizontal" ? "x" : "y"
      },
      plugins
    );
    const [canScrollPrev, setCanScrollPrev] = React.useState(false);
    const [canScrollNext, setCanScrollNext] = React.useState(false);
    const onSelect = (carouselApi) => {
      if (!carouselApi) {
        return;
      }
      setCanScrollPrev(carouselApi.canScrollPrev());
      setCanScrollNext(carouselApi.canScrollNext());
    };
    const scrollPrev = React.useCallback(() => {
      api == null ? void 0 : api.scrollPrev();
    }, [api]);
    const scrollNext = React.useCallback(() => {
      api == null ? void 0 : api.scrollNext();
    }, [api]);
    const handleKeyDown = React.useCallback(
      (event) => {
        if (event.key === "ArrowLeft") {
          event.preventDefault();
          scrollPrev();
        } else if (event.key === "ArrowRight") {
          event.preventDefault();
          scrollNext();
        }
      },
      [scrollPrev, scrollNext]
    );
    React.useEffect(() => {
      if (!api || !setApi) {
        return;
      }
      setApi(api);
    }, [api, setApi]);
    React.useEffect(() => {
      if (!api) {
        return;
      }
      api.on("reInit", () => onSelect(api));
      api.on("select", () => onSelect(api));
      api == null ? void 0 : api.off("select", () => onSelect(api));
    }, [api]);
    const contextValue = React.useMemo(
      () => ({ carouselRef, api, scrollPrev, scrollNext, canScrollPrev, canScrollNext, orientation }),
      [carouselRef, api, scrollPrev, scrollNext, canScrollPrev, canScrollNext, orientation]
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(CarouselContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        ref,
        onKeyDownCapture: handleKeyDown,
        className: cn("relative", className),
        role: "region",
        "aria-roledescription": "carousel",
        ...props,
        children
      }
    ) });
  }
);
Carousel.displayName = "Carousel";
const CarouselContent = React.forwardRef(
  ({ className, containerClassname, ...props }, ref) => {
    const { carouselRef, orientation } = useCarousel();
    return (
      // Adding containerClassname for custom first container styles
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: carouselRef, className: cn("overflow-hidden", containerClassname), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          ref,
          className: cn("flex", orientation === "horizontal" ? "ml-0" : "-mt-4 flex-col", className),
          ...props
        }
      ) })
    );
  }
);
CarouselContent.displayName = "CarouselContent";
const CarouselItem = React.forwardRef(
  ({ className, ...props }, ref) => {
    const { orientation } = useCarousel();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        ref,
        role: "group",
        "aria-roledescription": "slide",
        className: cn("min-w-0 shrink-0 grow-0 basis-full", orientation === "horizontal" ? "pl-4" : "pt-4", className),
        ...props
      }
    );
  }
);
CarouselItem.displayName = "CarouselItem";
const CarouselPrevious = React.forwardRef(
  ({ className, size = "icon", ...props }, ref) => {
    const { orientation, scrollPrev, canScrollPrev } = useCarousel();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        ref,
        size,
        className: cn(
          "absolute h-8 w-8 rounded-full",
          orientation === "horizontal" ? "-left-12 top-1/2 -translate-y-1/2" : "-top-12 left-1/2 -translate-x-1/2 rotate-90",
          className
        ),
        disabled: !canScrollPrev,
        onClick: scrollPrev,
        ...props,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronDownIcon, { className: "h-4 w-4", direction: "left" })
      }
    );
  }
);
CarouselPrevious.displayName = "CarouselPrevious";
const CarouselNext = React.forwardRef(
  ({ className, size = "icon", ...props }, ref) => {
    const { orientation, scrollNext, canScrollNext } = useCarousel();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button$1,
      {
        ref,
        size,
        className: cn(
          "absolute h-8 w-8 rounded-full",
          orientation === "horizontal" ? "-right-12 top-1/2 -translate-y-1/2" : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90",
          className
        ),
        disabled: !canScrollNext,
        onClick: scrollNext,
        ...props,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronDownIcon, { className: "h-4 w-4", direction: "right" })
      }
    );
  }
);
CarouselNext.displayName = "CarouselNext";
const FeatureCarousel = ({ featureShows, featureShowTitle, featureShowIcon }) => {
  const [emblaApi, setEmblaApi] = useState();
  useEffect(() => {
    if (emblaApi) {
      emblaApi.scrollTo(0);
    }
  }, [emblaApi, featureShows]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-10 lg:mt-8", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mb-4 flex items-center", children: [
      featureShowIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(
        "img",
        {
          src: featureShowIcon.src,
          alt: featureShowIcon.alt,
          loading: "lazy",
          className: "mr-2",
          height: 32,
          width: 32
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "ty-heading5 md:ty-heading4", children: featureShowTitle })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Carousel, { setApi: setEmblaApi, opts: { dragFree: true }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CarouselContent, { containerClassname: "overflow-visible", className: "-ml-2 md:-ml-4", children: featureShows.map(({ image, title, description }) => (
      // Slides within the container: 2.1 slides on mobile, 2.5 slides on tablet, 3 slides on desktop
      /* @__PURE__ */ jsxRuntimeExports.jsxs(CarouselItem, { className: "basis-[48%] pl-2 md:basis-[40%] md:pl-4 xl:basis-1/3", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "relative block w-full overflow-hidden rounded-sm pb-[56.25%]", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "absolute left-0 top-0 h-full w-full object-cover", src: image.src, alt: image.alt }) }),
        title && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-2 line-clamp-1 ty-heading5", children: title }),
        description && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-1 line-clamp-1 text-neutral-v2-80 ty-caption md:ty-body", children: description })
      ] }, image.alt)
    )) }) })
  ] });
};
const DescriptionSkeleton = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded bg-neutral-v2-0 p-4 shadow-sm-below", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-12 w-12" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ml-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-centerflex items-center py-px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "my-0.5 h-5 w-36" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center flex items-center py-px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "my-0.5 h-4 w-48" }) })
    ] })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center mt-4 flex items-center py-px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "my-0.5 h-4 w-full" }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center flex items-center py-px md:hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "my-0.5 h-4 w-1/3" }) })
] });
const FeatureCarouselSkeleton = ({
  hasIcon,
  showSlideDescriptionSkeleton: showSlideDescription
}) => {
  const slideAmount = 2;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mb-4 flex items-center", children: [
      hasIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "mr-2 h-8 w-8" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "mb-1 h-5 w-44" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mb-0 flex pr-2", children: [...Array(slideAmount).keys()].map((key) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative mr-2 w-2/4 xl:w-1/3", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "box-border w-full rounded-sm pb-[56.25%]" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center mt-2 flex items-center py-px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "my-0.5 h-4 w-36" }) }),
      showSlideDescription && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center mt-1 flex h-5 items-center py-px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-3.5 w-20 md:h-4" }) })
    ] }, key)) })
  ] });
};
const PlanCard = ({ perMonthText, isDiscounted, perks, subPrice, price, title, icon }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "plan-card w-[312px] rounded-lg border-neutral-v2-5 bg-neutral-v2-0 px-6 py-4 shadow-md-v2", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "plan-card-header-wrapper", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "plan-card-title mb-2 flex items-center", children: [
      icon && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "mr-2 h-6 w-6", width: 24, height: 24, src: icon.src, alt: icon.alt }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ty-heading5", children: title })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ty-heading3", children: price }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ty-heading5", children: perMonthText }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: cn("text-neutral-v2-60 ty-footnote", isDiscounted && "line-through"), children: subPrice })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("hr", { className: "mb-2 mt-4 text-neutral-v2-10" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "plan-card-perk-wrapper space-y-2", children: perks.map((perk) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center ty-footnote", children: [
    perk.icon && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: perk.icon.src, alt: perk.icon.alt, width: 24, height: 24, className: "m-2 h-6 w-6 flex-shrink-0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { text: perk.title, className: "ml-2" })
  ] }, perk.title)) })
] });
const BundledItem = ({ title, itemType, image, subtitle }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start", children: [
  itemType === "app" ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rounded-sm bg-neutral-v2-0", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: image.src, alt: image.alt, width: 40, height: 40, loading: "lazy" }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex-shrink-0 rounded-sm bg-neutral-v2-0 px-1 py-1.5", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: image.src, alt: image.alt, height: 36, width: 64, loading: "lazy" }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ml-2", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "line-clamp-1 text-neutral-v2-90 ty-heading5", children: title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "line-clamp-1 text-neutral-v2-80 ty-footnote", children: subtitle })
  ] })
] }, title);
const ChannelListing = ({ channelTitle, channels }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-6 md:mt-8", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "mb-2 ty-heading5 md:mb-4 lg:ty-heading4", children: channelTitle }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid gap-4 md:grid-cols-2 xl:grid-cols-3", children: channels.map((channel) => /* @__PURE__ */ createElement(BundledItem, { ...channel, itemType: "channel", key: channel.subtitle })) })
] });
const ChannelContentSkeleton = () => {
  const bundledContentAmount = 5;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(DescriptionSkeleton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-8", children: /* @__PURE__ */ jsxRuntimeExports.jsx(FeatureCarouselSkeleton, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-7 md:mt-9", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center mb-2 flex h-6 items-center md:mb-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-[18px] w-52" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid gap-4 md:grid-cols-2 xl:grid-cols-3", children: [...Array(bundledContentAmount).keys()].map((key) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-12 w-18 flex-shrink-0 rounded-sm px-1 py-1.5" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ml-2", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center flex items-center py-px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "my-0.5 h-4 w-36" }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center flex h-5 items-center py-px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "my-0.5 h-3.5 w-20 md:h-4" }) })
        ] })
      ] }, key)) })
    ] })
  ] });
};
const ChannelContent = ({ config: contentConfig }) => {
  if (!contentConfig) return /* @__PURE__ */ jsxRuntimeExports.jsx(ChannelContentSkeleton, {});
  const { icon, channels, featureShows, channelSectionTitle, featureShowTitle } = contentConfig;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-full flex-1 overflow-y-auto overflow-x-hidden rounded bg-neutral-v2-5", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "p-4 pb-6 md:px-8 md:pb-6 md:pt-16 lg:py-6 xl:px-10 xl:py-8", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Description,
      {
        ...contentConfig,
        icon: icon && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "img",
            {
              src: icon.src,
              alt: icon.alt,
              height: 36,
              width: 36,
              loading: "lazy",
              className: "box-content rounded-sm border border-neutral-200 p-1.5 max-md:hidden"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: icon.src, alt: icon.alt, height: 40, width: 40, loading: "lazy", className: "md:hidden" })
        ] })
      }
    ),
    featureShows.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(FeatureCarousel, { featureShows, featureShowTitle }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChannelListing, { channelTitle: channelSectionTitle, channels })
  ] }) });
};
const BundledContentDescription = ({
  title,
  description,
  icon,
  type
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: cn(
        "mr-2 flex h-10 w-10 flex-shrink-0 rounded-sm bg-white",
        type !== "app" && "border border-neutral-200"
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "img",
        {
          className: "m-auto",
          width: type === "app" ? 40 : 32,
          height: type === "app" ? 40 : 32,
          loading: "lazy",
          src: icon.src,
          alt: icon.alt
        }
      )
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex min-w-0 flex-grow-0 flex-col pr-2", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "truncate lg:ty-heading5", children: title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "line-clamp-1 text-neutral-v2-80 ty-caption", children: description })
  ] })
] });
const BundledContentItem = ({
  title,
  description,
  icon,
  type,
  id,
  onAddOnClick
}) => {
  if (onAddOnClick)
    return (
      // returns as a button
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          onClick: () => onAddOnClick(id, type, title),
          onKeyDown: () => onAddOnClick(id, type, title),
          role: "button",
          tabIndex: 0,
          className: "group flex cursor-pointer items-center overflow-hidden p-2 md:rounded-sm md:hover:bg-neutral-v2-5",
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(BundledContentDescription, { ...{ title, description, icon, type } }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "my-auto ml-auto flex h-8 w-8 items-center justify-end md:hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              IconButton,
              {
                icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowIcon, { direction: "right" }),
                variant: "secondary",
                size: "small",
                className: "relative -right-2 p-2 text-neutral-v2-60 outline-0 hover:bg-white [&>svg]:h-4 [&>svg]:w-4"
              }
            ) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "my-auto ml-auto hidden md:group-hover:block", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, { icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowIcon, { direction: "right" }), size: "small" }) })
          ]
        }
      )
    );
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "group flex items-center overflow-hidden p-2 md:rounded-sm", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BundledContentDescription, { ...{ title, description, icon, type } }) });
};
const BundledContentCollapsible = ({
  isOpen,
  onOpenChange,
  title,
  bundledContent,
  onAddOnClick,
  canOpen
}) => {
  const isDesktop = useBreakpoint("xl");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Collapsible, { onOpenChange, open: isOpen, className: "mb-4 rounded-md bg-white pb-2 shadow-md", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      CollapsibleTrigger,
      {
        className: cn(
          "flex h-12 w-full items-center justify-between border-b border-b-neutral-200 px-4 ty-heading5",
          !canOpen && "cursor-auto"
        ),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: "ty-heading5", children: title }),
          canOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: cn(
                "items-center justify-center rounded bg-transparent p-1.5 text-black transition-colors hover:bg-neutral-200",
                isOpen && "bg-neutral-200"
              ),
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowIcon, { direction: isOpen ? "up" : "down", className: "h-5 w-5 transition-all" })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col px-2 pt-2 md:grid md:grid-cols-2 md:px-4 xl:grid-cols-3", children: bundledContent.slice(0, isDesktop ? 3 : 2).map((content) => /* @__PURE__ */ createElement(BundledContentItem, { ...content, key: content.title, onAddOnClick })) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CollapsibleContent, { className: "space-y-4 overflow-hidden px-2 data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down md:px-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "overflow-hidden transition-[max-height] duration-150 ease-in-out", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col md:grid md:grid-cols-2 xl:grid-cols-3", children: bundledContent.slice(isDesktop ? 3 : 2).map((content) => /* @__PURE__ */ createElement(BundledContentItem, { ...content, key: content.title, onAddOnClick })) }) }) })
  ] });
};
const BundledContentSkeleton = () => {
  const bundledContentAmount = 2;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mb-4 rounded-md bg-white shadow", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex h-12 w-full items-center justify-between border-b border-b-neutral-200 px-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-5 w-28" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "p-2 xl:px-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col md:grid md:grid-cols-2 xl:grid-cols-3", children: [...Array(bundledContentAmount).keys()].map((key) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "group flex items-center overflow-hidden p-2 md:rounded-sm", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "mr-2 flex h-10 w-10 flex-shrink-0 rounded-sm" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex h-[42px] min-w-0 flex-grow-0 flex-col pr-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center flex items-center py-px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "my-0.5 h-4 w-36" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center flex h-5 items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-3.5 w-24" }) })
      ] })
    ] }, key)) }) })
  ] });
};
const PackDescriptionSkeleton = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex rounded-md bg-white p-2 shadow md:mt-16", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-grow flex-col p-2", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "mr-2.5 h-6 w-6 self-start md:h-8 md:w-8" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-4 w-1/2" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center mt-2 flex items-center py-px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "my-0.5 h-4 w-full" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center mb-4 flex items-center py-px md:mb-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "my-0.5 h-4 w-2/3" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "jusify-center lex mt-auto items-center py-px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "my-0.5 h-6 w-32" }) })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "shrink-0 md:block xl:ml-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rounded-sm", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "md:h-[166px] md:w-[296px] xl:h-[206px] xl:w-[368px]" }) }) })
] }) });
const MainContentSkeleton = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-0 overflow-hidden rounded-none pb-[56.26%] md:hidden" }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "px-4 md:px-10", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mb-8 mt-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(PackDescriptionSkeleton, {}) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mb-1 flex lg:mb-0.5", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-5 w-44 md:h-6" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "ml-auto mr-0 h-4 w-20 self-end" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "pb-8 pt-4", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(BundledContentSkeleton, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(BundledContentSkeleton, {})
    ] })
  ] })
] });
const ProductDescription = ({
  packImage,
  badge,
  title,
  description,
  icon,
  price,
  originalPrice,
  perMonthText
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex rounded-md bg-white p-2 shadow md:mt-16", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-grow flex-col p-2", children: [
    badge && /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { className: "mb-2 mr-auto", children: badge }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center", children: [
      icon && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mr-2.5 h-6 w-6 self-start md:h-8 md:w-8", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: icon.src, alt: icon.alt }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "ty-heading5 lg:ty-heading3", children: title })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "mb-4 mt-2 line-clamp-2 text-neutral-v2-80 md:mb-2", text: description }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-auto", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ty-heading4", children: price }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ty-heading5", children: perMonthText }),
      originalPrice && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "ml-2 text-neutral-v2-40 line-through", children: originalPrice })
    ] })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hidden shrink-0 md:block xl:ml-2", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "overflow-hidden rounded-sm", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "img",
    {
      src: packImage.src,
      alt: packImage.alt,
      className: "object-cover md:h-[166px] md:w-[296px] xl:h-[206px] xl:w-[368px]"
    }
  ) }) })
] });
const ProductContent = ({ mainContentConfig, onAddOnClick, gaConfig }) => {
  const isDesktop = useBreakpoint("xl");
  const isExpandable = (items, isLargeScreen) => items > (isLargeScreen ? 3 : 2);
  const { expandedItems, setItems, toggleItem } = useCollapsibleController();
  useEffect(() => {
    setItems([]);
  }, [mainContentConfig, setItems]);
  if (!mainContentConfig) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(MainContentSkeleton, {});
  }
  const {
    packConfig,
    addOnConfig,
    appConfig,
    serviceConfig,
    backgroundImage: backgroundBanner,
    contentsTitle,
    subsectionCollapseText,
    subsectionExpandText,
    perMonthText
  } = mainContentConfig;
  const isAddOnsExpandable = isExpandable(addOnConfig.content.length, isDesktop);
  const isAppExpandable = isExpandable(appConfig.content.length, isDesktop);
  const isServiceExpandable = serviceConfig && isExpandable(serviceConfig.content.length, isDesktop);
  const isAppExpanded = expandedItems.includes("app");
  const isAddOnsExpanded = expandedItems.includes("addOns");
  const isServiceExpanded = expandedItems.includes("service");
  const toggleAppExpand = () => {
    isAppExpandable && toggleItem("app");
  };
  const toggleAddOnsExpand = () => {
    isAddOnsExpandable && toggleItem("addOns");
  };
  const toggleServiceExpand = () => {
    isServiceExpandable && toggleItem("service");
  };
  const toggleAllSectionsExpanded = () => {
    if ((isAppExpanded || !isAppExpandable) && (isAddOnsExpanded || !isAddOnsExpandable) && (isServiceExpanded || !isServiceExpandable)) {
      if (gaConfig) {
        gtmPush({
          event: "view_item",
          content_type: gaContentType,
          content_list_type: gaConfig.contentListType,
          content_title: packConfig.title,
          item_name: subsectionCollapseText
        });
      }
      setItems([]);
    } else {
      if (gaConfig) {
        gtmPush({
          event: "view_item",
          content_type: gaContentType,
          content_list_type: gaConfig.contentListType,
          content_title: packConfig.title,
          item_name: subsectionExpandText
        });
      }
      setItems(["app", "addOns", "service"]);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        className: "-mb-52 hidden h-52 bg-cover bg-no-repeat md:block",
        style: {
          backgroundImage: `linear-gradient(180deg, rgba(246, 246, 248, 0.15) 0%, #F6F6F8 100%), url('${backgroundBanner}')`
        }
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-0 overflow-hidden pb-[56.26%] md:hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: packConfig.packImage.src, alt: packConfig.packImage.alt }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "px-4 md:px-10", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mb-8 mt-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ProductDescription, { ...packConfig, perMonthText }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "ty-heading5 lg:ty-heading4", children: contentsTitle }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button,
            {
              onClick: toggleAllSectionsExpanded,
              className: "ml-auto mr-0 cursor-pointer self-end text-blue-v2-60",
              variant: "text",
              children: !isAppExpandable && !isAddOnsExpandable ? "" : (isAppExpanded || !isAppExpandable) && (isAddOnsExpanded || !isAddOnsExpandable) ? subsectionCollapseText : subsectionExpandText
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "pb-8 pt-4", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            BundledContentCollapsible,
            {
              isOpen: isAppExpanded,
              title: appConfig.title,
              bundledContent: appConfig.content,
              onOpenChange: toggleAppExpand,
              canOpen: isAppExpandable
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            BundledContentCollapsible,
            {
              isOpen: isAddOnsExpanded,
              title: addOnConfig.title,
              bundledContent: addOnConfig.content,
              onOpenChange: toggleAddOnsExpand,
              onAddOnClick,
              canOpen: isAddOnsExpandable
            }
          ),
          serviceConfig && /* @__PURE__ */ jsxRuntimeExports.jsx(
            BundledContentCollapsible,
            {
              isOpen: isServiceExpanded,
              title: serviceConfig.title,
              bundledContent: serviceConfig.content,
              onOpenChange: toggleServiceExpand,
              canOpen: isServiceExpandable
            }
          )
        ] })
      ] })
    ] })
  ] });
};
const ProductPopupLayout = ({
  layoutTextConfig,
  initialPackId,
  locale,
  platform,
  environment,
  onCloseButtonClick,
  onCtaButtonClick,
  gaEventsConfig,
  gaEvents,
  viewOnly,
  inclusionList,
  utilizeDfPricing
}) => {
  const {
    sidebar,
    getMainContentConfig,
    getPackChannelContentConfig: getSecondaryChannelContentConfig,
    categories
  } = usePackContentConfig({ platform, locale, environment, inclusionList, utilizeDfPricing });
  const isDesktop = useBreakpoint("lg");
  const [mainContentId, setMainContentId] = useState(initialPackId);
  const [showSecondaryContent, setShowSecondaryContent] = useBoolean();
  const [secondaryContentId, setSecondaryContentId] = useState("");
  const mainContent = mainContentId ? getMainContentConfig(mainContentId) : null;
  const secondaryContent = mainContentId && secondaryContentId ? getSecondaryChannelContentConfig(mainContentId, secondaryContentId) : null;
  const handleCategoryItemClick = (packId, packTitle) => {
    if ((gaEvents == null ? void 0 : gaEvents.onCategoryItemClick) && mainContentId !== packId) {
      gaEvents.onCategoryItemClick(packId, packTitle);
    }
    setShowSecondaryContent.off();
    setMainContentId(packId);
  };
  const handleSecondaryContentClick = (addOnId, title) => {
    if (gaEvents == null ? void 0 : gaEvents.onSecondaryContentClick) {
      gaEvents.onSecondaryContentClick(addOnId, title);
    }
    setShowSecondaryContent.on();
    setSecondaryContentId(addOnId);
  };
  useEffect(() => {
    if (!initialPackId && categories) {
      setMainContentId(categories[0].tvPacks[0].id);
    }
  }, [categories, initialPackId]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    PopupLayout,
    {
      className: "ty-body",
      sidebarCategories: sidebar || [],
      activeSidebarItemId: mainContentId,
      childContainerClassName: "bg-neutral-v2-5 border-b lg:border-l border-neutral-200",
      ...layoutTextConfig,
      sidebarReturnButtonText: layoutTextConfig.sidebarReturnButtonText,
      secondaryContentReturnButtonText: (mainContent == null ? void 0 : mainContent.packConfig.title) || "",
      showBottomBar: viewOnly ? !isDesktop : true,
      isSubContentVisible: showSecondaryContent,
      onCategoryItemClick: handleCategoryItemClick,
      onSecondaryContentReturnButtonClick: () => {
        setShowSecondaryContent.off();
      },
      onCloseButtonClick,
      showCtaButton: Boolean(mainContent) && !(viewOnly && !isDesktop),
      onCtaButtonClick: () => {
        if (mainContent && mainContent.ctaLink) {
          if (gaEventsConfig) {
            gtmPush({
              event: "view_item",
              content_type: gaContentType,
              content_list_type: gaEventsConfig.contentListType,
              content_title: mainContent.packConfig.title,
              content_id: mainContent.ctaLink,
              item_name: layoutTextConfig.ctaButtonText
            });
          }
          if (onCtaButtonClick && mainContentId) onCtaButtonClick(mainContentId);
          else window.location.href = mainContent.ctaLink;
        }
      },
      children: showSecondaryContent ? /* @__PURE__ */ jsxRuntimeExports.jsx(ChannelContent, { config: secondaryContent }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
        ProductContent,
        {
          onAddOnClick: (addOnId, type, title) => handleSecondaryContentClick(addOnId, title),
          isSecondaryContentVisible: showSecondaryContent,
          mainContentConfig: mainContent,
          gaConfig: gaEventsConfig
        }
      )
    }
  );
};
const ProductPopup = ({
  popupConfig,
  isOpen,
  wrapperClassName,
  panelClassName,
  onCloseButtonClick,
  onCtaButtonClick,
  gaEventsConfig,
  gaEvents,
  viewOnly
}) => {
  var _a;
  const PopupDfConfig = usePopupDfConfig(popupConfig.environment, popupConfig.locale);
  if (!PopupDfConfig) {
    return null;
  }
  const visiblePackIds = popupConfig.inclusionList || ((_a = PopupDfConfig.defaultWhiteList) == null ? void 0 : _a.pack);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PopupModal, { isOpen, wrapperClassName, panelClassName, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    ProductPopupLayout,
    {
      layoutTextConfig: PopupDfConfig.layoutTextConfig,
      ...popupConfig,
      inclusionList: visiblePackIds,
      viewOnly,
      onCloseButtonClick,
      onCtaButtonClick,
      gaEventsConfig,
      gaEvents
    }
  ) });
};
const PlanCardCarousel = ({ planCards }) => {
  useEffect(() => {
    normalizeElementsHeight("plan-card-perk-wrapper");
    normalizeElementsHeight("plan-card-header-wrapper");
    normalizeElementsHeight("plan-card-title");
  }, [planCards]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Carousel, { opts: { dragFree: true }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CarouselContent, { containerClassname: "overflow-visible", className: "-ml-2 md:-ml-4", children: planCards.map((planCard) => /* @__PURE__ */ jsxRuntimeExports.jsx(CarouselItem, { className: "basis-auto pl-2 md:pl-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(PlanCard, { ...planCard }) }, planCard.title)) }) });
};
const AppContent = ({ config }) => {
  if (!config) return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {});
  const { featureConfig, appDescriptionConfig, planCardCarousel } = config;
  const { icon } = appDescriptionConfig;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "h-full flex-1 overflow-y-auto overflow-x-hidden rounded bg-neutral-v2-5 p-4 pb-6 md:px-8 md:pb-6 md:pt-16 lg:py-6 xl:px-10 xl:py-8", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Description,
      {
        ...appDescriptionConfig,
        icon: icon && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: icon.src, alt: icon.alt, height: 40, width: 40, loading: "lazy", className: "md:hidden" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: icon.src, alt: icon.alt, height: 48, width: 48, loading: "lazy", className: "max-md:hidden" })
        ] })
      }
    ),
    featureConfig.featureShows.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(FeatureCarousel, { ...featureConfig }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-8", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mb-4 ty-heading5 md:ty-heading4", children: planCardCarousel.title }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PlanCardCarousel, { planCards: planCardCarousel.cards })
    ] })
  ] });
};
const AppLayout = ({
  platform,
  locale,
  environment,
  initialSelectionId,
  inclusionList,
  isSidebarDefaultOpened,
  gaEvents,
  onCloseButtonClick
}) => {
  const { sidebar, getAppContentConfig, categories } = useAppContentConfig({
    platform,
    locale,
    environment,
    inclusionList
  });
  const [selectedAppId, setSelectedAppId] = useState(initialSelectionId);
  const isDesktop = useBreakpoint("lg");
  const mainContent = selectedAppId ? getAppContentConfig(selectedAppId) : null;
  const handleCategoryItemClick = (itemId, itemTitle) => {
    if ((gaEvents == null ? void 0 : gaEvents.onCategoryItemClick) && selectedAppId !== itemId) {
      gaEvents.onCategoryItemClick(itemId, itemTitle);
    }
    setSelectedAppId(itemId);
  };
  useEffect(() => {
    if (!initialSelectionId && categories) {
      setSelectedAppId(categories[0].apps[0].id);
    }
  }, [categories, initialSelectionId]);
  const PopupDfConfig = usePopupDfConfig(environment, locale);
  if (!PopupDfConfig) return null;
  const { appContentTextConfig } = PopupDfConfig;
  const { exploreButtonText } = appContentTextConfig;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    PopupLayout,
    {
      className: "ty-body",
      sidebarCategories: sidebar || [],
      activeSidebarItemId: selectedAppId,
      childContainerClassName: "bg-neutral-v2-5 border-b lg:border-l border-neutral-200",
      showBottomBar: !isDesktop,
      onCategoryItemClick: handleCategoryItemClick,
      onCloseButtonClick,
      exploreButtonText,
      isSidebarDefaultOpened,
      children: mainContent ? /* @__PURE__ */ jsxRuntimeExports.jsx(AppContent, { config: mainContent }) : null
    }
  );
};
const BroadbandContent = ({ ...props }) => {
  if (!props) return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {});
  const { descriptionConfig, featureTitle, features, info, infoTitle } = props;
  const { icon } = descriptionConfig;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "h-full flex-1 items-center space-y-8 overflow-y-auto overflow-x-hidden rounded bg-neutral-v2-5 p-4 pb-6 md:px-8 md:pb-6 md:pt-16 lg:py-6 xl:px-10 xl:py-8", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Description,
      {
        ...descriptionConfig,
        icon: icon && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            src: icon.src,
            alt: icon.alt,
            height: 48,
            width: 48,
            loading: "lazy",
            className: "max-md:h-10 max-md:w-10"
          }
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mb-4 ty-heading5 lg:ty-heading4", children: featureTitle }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid gap-x-2 gap-y-4 rounded bg-white p-4 shadow-sm-below md:grid-cols-2 lg:grid-cols-3", children: features.map((feature) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            src: feature.icon.src,
            alt: feature.icon.alt,
            height: 32,
            width: 32,
            loading: "lazy",
            className: "mr-2 shrink-0"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "ty-footnote", text: feature.description })
      ] }, feature.description)) })
    ] }),
    info && info.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mb-4 ty-heading5 lg:ty-heading4", children: infoTitle }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid gap-x-2 gap-y-4 rounded bg-white p-4 shadow-sm-below md:grid-cols-2 lg:grid-cols-3", children: info.map((infoItem) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            src: infoItem.icon.src,
            alt: infoItem.icon.alt,
            height: 32,
            width: 32,
            loading: "lazy",
            className: "my-1 mr-2 shrink-0"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "ty-footnote", text: infoItem.description })
      ] }, infoItem.description)) })
    ] })
  ] });
};
const BroadbandLayout = ({ ...props }) => {
  var _a;
  const {
    locale,
    environment,
    initialSelectionId,
    onCloseButtonClick,
    platform,
    gaEvents,
    showMesh,
    isp,
    broadbandInclusionList
  } = props;
  const contentConfig = useBroadbandContentConfig(locale, platform, environment, showMesh, isp, broadbandInclusionList);
  const isDesktop = useBreakpoint("lg");
  const [selectedSidebarItemId, setSelectedSidebarItemId] = useState(
    initialSelectionId ?? void 0
  );
  const broadbandContentSelected = contentConfig == null ? void 0 : contentConfig.content.find((broadband) => broadband.id === selectedSidebarItemId);
  const handleCategoryItemClick = (selectedId, selectedTitle) => {
    if ((gaEvents == null ? void 0 : gaEvents.onCategoryItemClick) && selectedSidebarItemId !== selectedId) {
      gaEvents.onCategoryItemClick(selectedId, selectedTitle);
    }
    setSelectedSidebarItemId(selectedId);
  };
  useEffect(() => {
    if (contentConfig) {
      const isSelectedSidebarItemValid = contentConfig.sideBarConfig.categories.some(
        (category) => category.categoryContent.find((content) => content.id === selectedSidebarItemId)
      );
      if (isSelectedSidebarItemValid) {
        setSelectedSidebarItemId(selectedSidebarItemId);
      } else {
        setSelectedSidebarItemId(contentConfig == null ? void 0 : contentConfig.sideBarConfig.categories[0].categoryContent[0].id);
      }
    }
  }, [contentConfig, initialSelectionId, selectedSidebarItemId]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    PopupLayout,
    {
      className: "ty-body",
      sidebarCategories: ((_a = contentConfig == null ? void 0 : contentConfig.sideBarConfig) == null ? void 0 : _a.categories) || [],
      activeSidebarItemId: selectedSidebarItemId,
      childContainerClassName: "bg-neutral-v2-5 border-b lg:border-l border-neutral-200",
      showBottomBar: !isDesktop,
      onCategoryItemClick: handleCategoryItemClick,
      onCloseButtonClick,
      exploreButtonText: (contentConfig == null ? void 0 : contentConfig.exploreButtonText) || "",
      children: broadbandContentSelected && /* @__PURE__ */ jsxRuntimeExports.jsx(BroadbandContent, { ...broadbandContentSelected })
    }
  );
};
function createSidebarConfig(response, title) {
  return response.map((category) => ({
    title,
    categoryContent: category.contents.map((item) => ({
      id: item.id,
      title: item.baseDetails.name,
      icon: item.baseDetails.icon ? { src: item.baseDetails.icon, alt: item.baseDetails.name } : void 0
    }))
  }));
}
function createChannelContentConfig(response, df, hasSession, channelList, locale) {
  const { baseDetails, bfDetails, gfDetails, contentDetails } = response;
  return {
    featureShowTitle: df.featureShowTitle,
    channelSectionTitle: df.channelSectionTitle,
    icon: {
      src: baseDetails.icon,
      alt: baseDetails.name
    },
    title: baseDetails.name,
    subtitle: formatAsPrice(hasSession ? bfDetails.price : gfDetails.price),
    strikethroughPrice: hasSession && bfDetails.originalPrice ? formatAsPrice(bfDetails.originalPrice) : !hasSession && gfDetails.originalPrice ? formatAsPrice(gfDetails.originalPrice) : void 0,
    description: baseDetails.description,
    featureShows: baseDetails.images.map((item) => ({
      image: {
        src: item.image,
        alt: item.altText
      }
    })),
    channels: mapFromId(contentDetails.channels, channelList).map((channel) => ({
      title: locale === "bm" ? channel.subtitle_my : channel.subtitle,
      image: {
        src: channel.imageUrl,
        alt: channel.title
      },
      subtitle: channel.title
    }))
  };
}
function useChannelContentConfig({
  platform,
  locale,
  environment,
  inclusionList
}) {
  const apiLanguageOption = convertLocale(locale);
  const df = usePopupDfConfig(environment, locale);
  const hasSession = hasExistingSession();
  const channelList = useChannelListing(presetEndpoints$2.channelListing[environment]);
  const { data: response, error } = useAsync({
    shouldAutoRevalidate: false,
    endpoint: (
      // eslint-disable-next-line prefer-template
      `${presetEndpoints$2.productPopupV2[environment]}?platform=${platform}&language=${apiLanguageOption}&explore=content`
    ),
    formatResponse: (res) => res
  });
  const data = useMemo(() => {
    if (response) {
      if (!inclusionList) return response;
      return response.reduce((acc, category) => {
        const contents = category.contents.filter((content) => inclusionList.includes(content.id));
        acc.push({ ...category, contents });
        return acc;
      }, []);
    }
  }, [inclusionList, response]);
  if (error) {
    logger.error(error);
  }
  const getChannelContentConfig = useCallback(
    (contentId) => {
      const mainContentData = data == null ? void 0 : data.flatMap((category) => category.contents).find((item) => item.id === contentId);
      if (mainContentData && df && channelList) {
        return createChannelContentConfig(
          mainContentData,
          df.singleSecondaryContentTextConfig,
          hasSession || false,
          channelList,
          locale
        );
      }
      return null;
    },
    [channelList, data, df, hasSession, locale]
  );
  const sidebarConfig = data && df ? createSidebarConfig(data, df.singleSecondaryContentTextConfig.sidebarTitle) : null;
  return {
    sidebar: sidebarConfig,
    getChannelContentConfig,
    categories: data
  };
}
const ChannelLayout = ({
  platform,
  locale,
  environment,
  initialSelectionId,
  inclusionList,
  gaEvents,
  onCloseButtonClick,
  isSidebarDefaultOpened
}) => {
  const isDesktop = useBreakpoint("lg");
  const PopupDfConfig = usePopupDfConfig(environment, locale);
  const [selectedSidebarItemId, setSelectedSidebarItemId] = useState(initialSelectionId);
  const { getChannelContentConfig, sidebar, categories } = useChannelContentConfig({
    platform,
    locale,
    environment,
    inclusionList
  });
  const config = selectedSidebarItemId ? getChannelContentConfig(selectedSidebarItemId) : null;
  const handleCategoryItemClick = (itemId, itemTitle) => {
    if ((gaEvents == null ? void 0 : gaEvents.onCategoryItemClick) && selectedSidebarItemId !== itemId) {
      gaEvents.onCategoryItemClick(itemId, itemTitle);
    }
    setSelectedSidebarItemId(itemId);
  };
  useEffect(() => {
    if (!initialSelectionId && categories) {
      setSelectedSidebarItemId(categories[0].contents[0].id);
    }
  }, [categories, initialSelectionId]);
  if (!PopupDfConfig) return null;
  const { singleSecondaryContentTextConfig } = PopupDfConfig;
  const { exploreButtonText } = singleSecondaryContentTextConfig;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    PopupLayout,
    {
      className: "ty-body",
      sidebarCategories: sidebar || [],
      activeSidebarItemId: selectedSidebarItemId,
      childContainerClassName: "bg-neutral-v2-5 border-b lg:border-l border-neutral-200",
      showBottomBar: !isDesktop,
      onCategoryItemClick: handleCategoryItemClick,
      onCloseButtonClick,
      exploreButtonText,
      isSidebarDefaultOpened,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChannelContent, { config })
    }
  );
};
const AddOnPopup = ({ ...props }) => {
  var _a, _b, _c, _d, _e;
  const { isOpen, popupConfig, onCloseButtonClick, contentType, gaEvents, panelClassName, wrapperClassName } = props;
  const PopupDfConfig = usePopupDfConfig(popupConfig.environment, popupConfig.locale);
  const visibleBroadbandIds = contentType === "broadband" && props.broadbandInclusionList || ((_a = PopupDfConfig == null ? void 0 : PopupDfConfig.defaultWhiteList) == null ? void 0 : _a.broadBand) || void 0;
  const visibleAppIds = ((_b = popupConfig.inclusionFilters) == null ? void 0 : _b.apps) || ((_c = PopupDfConfig == null ? void 0 : PopupDfConfig.defaultWhiteList) == null ? void 0 : _c.app);
  const visibleContentIds = ((_d = popupConfig.inclusionFilters) == null ? void 0 : _d.content) || ((_e = PopupDfConfig == null ? void 0 : PopupDfConfig.defaultWhiteList) == null ? void 0 : _e.content);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PopupModal, { isOpen, wrapperClassName, panelClassName, children: contentType === "broadband" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    BroadbandLayout,
    {
      ...popupConfig,
      onCloseButtonClick,
      showMesh: !!props.showMesh,
      isp: props.isp,
      broadbandInclusionList: visibleBroadbandIds,
      gaEvents
    }
  ) : contentType === "app" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    AppLayout,
    {
      ...popupConfig,
      inclusionList: visibleAppIds,
      onCloseButtonClick,
      gaEvents
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    ChannelLayout,
    {
      ...popupConfig,
      inclusionList: visibleContentIds,
      onCloseButtonClick,
      gaEvents
    }
  ) });
};
function isServiceDetails(data) {
  return data.supportedBrands !== void 0 || data.apps !== void 0;
}
const AstroBoxContent = ({ data, title }) => {
  var _a, _b, _c, _d;
  if (!data || !title) return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {});
  const { baseDetails, id } = data;
  const { name, icon, highlights } = baseDetails;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "h-full flex-1 space-y-8 overflow-y-auto overflow-x-hidden rounded bg-neutral-v2-5 p-4 pb-6 md:px-8 md:pb-6 md:pt-16 lg:py-6 xl:px-10 xl:py-8", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mb-10 rounded bg-neutral-v2-0 p-4 shadow-sm-below lg:mb-8", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: icon, alt: "", height: 40, width: 40, loading: "lazy", className: "md:hidden" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: icon, alt: "", height: 48, width: 48, loading: "lazy", className: "max-md:hidden" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "my-auto ml-2 ty-heading5 md:ty-heading4 lg:ml-4", children: name })
    ] }) }),
    isServiceDetails(baseDetails) && baseDetails.supportedBrands && baseDetails.supportedBrands.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mb-4 ty-heading5 lg:ty-heading4", children: (_a = title[id]) == null ? void 0 : _a.supportedTvBrandTitle }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rounded bg-white p-4 shadow-sm-below", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-wrap items-center gap-2", children: baseDetails.supportedBrands.map((image) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        "img",
        {
          src: image.image,
          alt: image.altText,
          loading: "lazy",
          className: "h-auto max-h-[38px] min-w-[68px] object-contain lg:max-h-[48px]"
        },
        image.id
      )) }) }),
      ((_b = title[id]) == null ? void 0 : _b.supportedTvBrandNote) ? /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "mt-4 ty-footnote", text: (_c = title[id]) == null ? void 0 : _c.supportedTvBrandNote }) : null
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mb-4 ty-heading5 lg:ty-heading4", children: title[id].highlightTitle }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid gap-x-2 gap-y-2 rounded bg-white p-4 shadow-sm-below md:grid-cols-2 lg:grid-cols-3", children: highlights.map((highlight) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center", children: [
        highlight.icon ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: highlight.icon, alt: "", height: 32, width: 32, loading: "lazy", className: "mr-2" }) : null,
        /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "ty-footnote", text: highlight.text })
      ] }, highlight.text)) })
    ] }),
    isServiceDetails(baseDetails) && baseDetails.apps && baseDetails.apps.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mb-4 ty-heading5 lg:ty-heading4", children: (_d = title[id]) == null ? void 0 : _d.specialOfferTitle }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid grid-cols-1 gap-4 lg:grid-cols-2", children: baseDetails.apps.map(({ id: appDetailsId, baseDetails: appDetails }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "rounded bg-white p-4 shadow-sm-below", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center", children: [
          appDetails.icon ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: appDetails.icon, alt: "", height: 32, width: 32, loading: "lazy", className: "mr-2 h-8 w-8" }) : null,
          /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "ty-body", text: appDetails.name })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("hr", { className: "my-4 text-neutral-v2-10" }),
        appDetails.highlights.map((highlight) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mb-2 flex items-center last:mb-0", children: [
          highlight.icon ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: highlight.icon, alt: "", height: 16, width: 16, loading: "lazy", className: "mr-2" }) : null,
          /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "ty-footnote", text: highlight.text })
        ] }, highlight.text))
      ] }, appDetailsId)) })
    ] })
  ] });
};
const AstroBoxSkeleton = ({ isService = true }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "h-full flex-1 space-y-8 overflow-y-auto overflow-x-hidden rounded bg-neutral-v2-5 p-4 pb-6 md:px-8 md:pb-6 md:pt-16 lg:py-6 xl:px-10 xl:py-8", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "rounded bg-neutral-v2-0 p-4 shadow-sm-below", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-10 w-10 rounded-sm" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "my-auto ml-4", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-4 w-[148px] rounded-sm" }) })
  ] }) }),
  isService && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "mb-4 h-5 w-[153px] rounded-sm" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid grid-cols-4 gap-x-2 gap-y-4 rounded bg-white p-4 shadow-sm-below md:grid-cols-2 lg:grid-cols-3", children: [1, 2, 3, 4].map((num) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-[38px] w-[68px] rounded-sm" }) }, num)) })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "mb-4 h-5 w-[153px] rounded-sm" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid gap-x-2 gap-y-4 rounded bg-white p-4 shadow-sm-below md:grid-cols-2 lg:grid-cols-3", children: [1, 2].map((num) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "mr-2 h-8 w-8 rounded-sm" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-5 w-[192px] rounded-sm" })
    ] }, num)) })
  ] }),
  isService && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "mb-4 h-5 w-[153px] rounded-sm" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mb-4 grid gap-x-2 gap-y-4 rounded bg-white p-4 shadow-sm-below last:mb-0 md:grid-cols-2 lg:grid-cols-3", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "mr-2 h-8 w-8 rounded-sm" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "my-auto h-5 w-[192px] rounded-sm" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("hr", { className: "text-neutral-v2-10" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "mb-2 h-5 w-full rounded-sm" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-5 w-full rounded-sm" })
      ] })
    ] })
  ] })
] });
function isViewing(data) {
  return data.type === "viewingDevice";
}
const AstroBoxLayout = ({ ...props }) => {
  const { data, config } = props;
  const isDesktop = useBreakpoint("lg");
  const [selectedSidebarItemId, setSelectedSidebarItemId] = useState(
    (config == null ? void 0 : config.initialSelectionId) ?? void 0
  );
  const allClickableSidebarItems = useMemo(() => {
    if (data) {
      return data.flatMap((category) => {
        if (isViewing(category)) {
          return category.viewingDevices.map((device) => device);
        }
        return category.services.map((service) => service);
      });
    }
    return [];
  }, [data]);
  const sidebarCategories = useMemo(() => {
    if (data) {
      const categories = [];
      data.forEach((category) => {
        const existItem = categories.find((cat) => cat.title === category.categoryTitle);
        const allItemDetails = isViewing(category) ? category.viewingDevices : category.services;
        const categoryContent = allItemDetails.map((details) => ({
          id: details.id,
          title: details.baseDetails.name,
          icon: {
            src: details.baseDetails.icon,
            alt: ""
          }
        }));
        if (existItem) {
          existItem.categoryContent = existItem.categoryContent.concat(categoryContent);
        } else {
          categories.push({
            title: category.categoryTitle,
            categoryContent
          });
        }
      });
      return categories;
    }
    return [];
  }, [data]);
  const exploreBtnText = useMemo(() => {
    var _a;
    if (data && selectedSidebarItemId) {
      return (_a = data.find((category) => {
        if (isViewing(category)) {
          return category.viewingDevices.find((device) => device.id === selectedSidebarItemId);
        }
        return category.services.find((service) => service.id === selectedSidebarItemId);
      })) == null ? void 0 : _a.categoryTitle;
    }
  }, [data, selectedSidebarItemId]);
  const astroBoxContentSelected = allClickableSidebarItems == null ? void 0 : allClickableSidebarItems.find((box) => box.id === selectedSidebarItemId);
  const handleCategoryItemClick = (selectedId) => {
    var _a;
    setSelectedSidebarItemId(selectedId);
    (_a = config == null ? void 0 : config.handleSidebarItemClick) == null ? void 0 : _a.call(config, selectedId);
  };
  const onCloseButtonClick = () => {
    var _a;
    (_a = config == null ? void 0 : config.handleOnCloseButtonClick) == null ? void 0 : _a.call(config);
  };
  useEffect(() => {
    if (allClickableSidebarItems.length > 0 && !(config == null ? void 0 : config.initialSelectionId) && !selectedSidebarItemId) {
      setSelectedSidebarItemId(allClickableSidebarItems[0].id);
    }
  }, [allClickableSidebarItems, config == null ? void 0 : config.initialSelectionId, selectedSidebarItemId]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    PopupLayout,
    {
      className: "ty-body",
      sidebarCategories,
      activeSidebarItemId: selectedSidebarItemId,
      childContainerClassName: "bg-neutral-v2-5 border-b lg:border-l border-neutral-200",
      showBottomBar: !isDesktop,
      onCategoryItemClick: handleCategoryItemClick,
      onCloseButtonClick,
      exploreButtonText: exploreBtnText ?? "",
      isSidebarDefaultOpened: config == null ? void 0 : config.isSidebarDefaultOpened,
      children: [
        !data ? /* @__PURE__ */ jsxRuntimeExports.jsx(AstroBoxSkeleton, {}) : null,
        astroBoxContentSelected && /* @__PURE__ */ jsxRuntimeExports.jsx(AstroBoxContent, { data: astroBoxContentSelected, title: config.detailsPageTitle })
      ]
    }
  );
};
const AstroBoxPopup = ({ isOpen, wrapperClassName, panelClassName, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(PopupModal, { isOpen, wrapperClassName, panelClassName, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AstroBoxLayout, { ...props }) });
function createHeaderId(...elements) {
  return createBemName("acm-header", ...elements);
}
function triggerEvent(event) {
  gtmPush({
    event: event.event || "clickEvent",
    content_type: event.content_type || "ACM Univeral",
    content_list_type: event.content_list_type || "Main View",
    ...event
  });
}
function createNavEvent(name, type = "main") {
  return () => triggerEvent({
    content_category: type === "mega" ? "Mega Menu" : "Header Menu",
    content_title: name
  });
}
function createSearchEvent(keyword, type = "main") {
  return () => triggerEvent({
    content_category: type === "mega" ? "Mega Menu - Search" : "Header Menu - Search",
    content_title: keyword
  });
}
function createSocialEvent(social) {
  return () => triggerEvent({
    content_category: "Mega Menu - Social icons",
    content_title: social
  });
}
function triggerExpandMegaMenuEvent() {
  triggerEvent({
    content_category: "Expand Mega Menu"
  });
}
function useBannerConfig(endpoint, portalRegexMap, wasBannerPreviouslyVisible) {
  const { data, isLoading } = useAsync({
    endpoint,
    formatResponse: (response) => {
      const now = Date.now();
      const banner = response.find(
        (bannerResponse) => now >= new Date(bannerResponse.startTime).getTime() && now < new Date(bannerResponse.endTime).getTime()
      );
      if (!banner) return null;
      const visibleRegexes = banner.visibility.reduce((regexes, portal) => {
        const portalRegexString = portalRegexMap[portal];
        if (portalRegexString) regexes.push(new RegExp(portalRegexString, "i"));
        return regexes;
      }, []);
      const isVisible = Boolean(visibleRegexes.find((regex) => regex.test(window.location.href)));
      if (!isVisible) return null;
      return {
        titleHtml: banner.title,
        descriptionHtml: banner.description,
        logoImageUrl: banner.logoImageURL,
        backgroundImageUrl: banner.backgroundImageURL,
        ...banner
      };
    },
    fetchCondition: () => {
      const hasDismissedBanner = getCookie(BANNER_DISMISSED_COOKIE) === "1";
      return !hasDismissedBanner || Boolean(wasBannerPreviouslyVisible);
    }
  });
  return { data: data ?? null, isLoading };
}
function calculateTimeLeft(endTime, timerUnit, optional = false) {
  const dateNow = (/* @__PURE__ */ new Date()).getTime();
  const distance = new Date(endTime).getTime() - dateNow;
  let timeLeft;
  switch (timerUnit) {
    case "day":
      timeLeft = distance / 864e5;
      break;
    case "hour":
      timeLeft = distance % 864e5 / 36e5;
      break;
    case "minute":
      timeLeft = distance % 36e5 / 6e4;
      break;
    case "second":
      timeLeft = distance % 6e4 / 1e3;
      break;
    default:
      timeLeft = 0;
      break;
  }
  if (timeLeft < 1) {
    if (optional) return null;
    return "00";
  }
  return Math.floor(timeLeft).toString().padStart(2, "0");
}
function useCountdownTimer(endTime) {
  const [day, setDay] = useState(calculateTimeLeft(endTime, "day", true));
  const [hour, setHour] = useState(calculateTimeLeft(endTime, "hour"));
  const [minute, setMinute] = useState(calculateTimeLeft(endTime, "minute"));
  const [second, setSecond] = useState(calculateTimeLeft(endTime, "second"));
  useEffect(() => {
    const interval = window.setInterval(() => {
      const days = calculateTimeLeft(endTime, "day", true);
      const hours = calculateTimeLeft(endTime, "hour");
      const minutes = calculateTimeLeft(endTime, "minute");
      const seconds = calculateTimeLeft(endTime, "second");
      setDay(days);
      setHour(hours);
      setMinute(minutes);
      setSecond(seconds);
    }, 1e3);
    return () => window.clearInterval(interval);
  }, [endTime]);
  return { day, hour, minute, second };
}
const TimerComponent = ({ unit, value }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col items-center", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-[2rem] font-extrabold leading-[2.125rem]", children: value }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "text-xs font-extrabold leading-[0.875rem]", children: unit })
] });
const CountdownTimer = ({ endTime, units }) => {
  const { day, hour, minute, second } = useCountdownTimer(endTime);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      id: createHeaderId("banner", "countdown"),
      className: "mr-8 hidden items-center space-x-4 py-4 lg:ml-auto lg:flex",
      children: [
        day && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(TimerComponent, { value: day, unit: units.day }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: units.separator })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(TimerComponent, { value: hour, unit: units.hour }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: units.separator }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(TimerComponent, { value: minute, unit: units.minute }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: units.separator }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(TimerComponent, { value: second, unit: units.second })
      ]
    }
  );
};
const InlineCountdownTimer = ({ endTime, units, ...props }) => {
  const { day, hour, minute, second } = useCountdownTimer(endTime);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { id: createHeaderId("banner", "inline-countdown"), ...props, children: [
    day && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      day,
      units.day,
      units.separator
    ] }),
    hour,
    units.hour,
    units.separator,
    minute,
    units.minute,
    units.separator,
    second,
    units.second
  ] });
};
const Banner = ({
  dismissDuration,
  bcpV3Endpoint,
  portalRegexMap,
  showMiniBanner,
  timerUnits,
  bannerClassname,
  onBannerLoad
}) => {
  const [isBannerShownThisSession, setIsBannerShownThisSession] = useBoolean();
  const [showBanner, setShowBanner] = useBoolean(false);
  const config = useBannerConfig(bcpV3Endpoint, portalRegexMap, isBannerShownThisSession);
  const { data, isLoading } = config;
  useEffect(() => {
    if (data && !isBannerShownThisSession) {
      setShowBanner.on();
      setIsBannerShownThisSession.on();
    }
    onBannerLoad({ isLoading, data });
  }, [data, isBannerShownThisSession, isLoading, onBannerLoad, setIsBannerShownThisSession, setShowBanner, showBanner]);
  const handleClose = () => {
    setCookie(BANNER_DISMISSED_COOKIE, "1", dismissDuration, false, getCookieDomain(window.location.href));
    setShowBanner.off();
  };
  const handleMiniBannerClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  const handleTextClick = (event) => {
    if (event.target instanceof HTMLAnchorElement) event.stopPropagation();
  };
  useEffect(() => {
    if (!data) {
      setShowBanner.off();
    } else {
      setShowBanner.on();
    }
  }, [data, setShowBanner]);
  if (!data) return null;
  const {
    backgroundImageUrl,
    backgroundColour,
    descriptionHtml,
    endTime,
    logoImageUrl,
    titleHtml,
    showCountdownTimer
  } = data;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Transition,
      {
        as: "aside",
        show: showBanner,
        id: createHeaderId("banner"),
        className: cn("relative grid bg-cover text-white transition-[grid-template-rows]", bannerClassname),
        style: { backgroundImage: `url('${backgroundImageUrl}')`, backgroundColor: backgroundColour },
        enter: "ease-in duration-200",
        enterFrom: "grid-rows-[0fr]",
        enterTo: "grid-rows-[1fr]",
        leave: "ease-out duration-200",
        leaveFrom: "grid-rows-[1fr]",
        leaveTo: "grid-rows-[0fr]",
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-start overflow-hidden px-4 ty-footnote md-v2:container-v2 lg:items-center", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "mr-4 shrink-0 py-2 max-md-v2:mt-1 lg:mr-6", src: logoImageUrl, alt: "", loading: "lazy" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "div",
            {
              id: createHeaderId("banner", "message"),
              className: "mr-4 py-2 lg:mr-8 [&_a]:font-bold [&_a]:text-magenta [&_a]:hover:underline [&_a]:hover:decoration-current",
              children: [
                titleHtml && /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "font-extrabold lg:inline lg:after:inline lg:after:content-['_']", text: titleHtml }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "line-clamp-5 lg:inline", text: descriptionHtml }),
                showCountdownTimer && /* @__PURE__ */ jsxRuntimeExports.jsx(InlineCountdownTimer, { className: "mt-1 lg:hidden", endTime, units: timerUnits.shortForm })
              ]
            }
          ),
          showCountdownTimer && /* @__PURE__ */ jsxRuntimeExports.jsx(CountdownTimer, { endTime, units: timerUnits.fullForm }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              className: cn("ml-auto pt-2 lg:pt-0", showCountdownTimer && "lg:ml-0"),
              variant: "tertiary",
              size: "icon",
              "aria-label": "close banner",
              onClick: handleClose,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(CrossIcon, { className: "flex-none text-white", width: 20, height: 20 })
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Transition,
      {
        as: "aside",
        show: showBanner && showMiniBanner,
        id: createHeaderId("mini-banner"),
        className: "fixed inset-x-0 top-0 z-20 cursor-pointer bg-cover text-base text-white transition",
        style: { backgroundImage: `url('${backgroundImageUrl}')` },
        enter: "ease-out duration-150",
        enterFrom: "-translate-y-full",
        enterTo: "translate-y-0",
        leave: "ease-in duration-100",
        leaveFrom: "translate-y-0",
        leaveTo: "-translate-y-full",
        onClick: handleMiniBannerClick,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "container flex justify-between py-1", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            "p",
            {
              id: createHeaderId("mini-banner", "message"),
              role: "presentation",
              className: "overflow-hidden text-ellipsis whitespace-nowrap [&_a]:font-bold [&_a]:text-magenta [&_a]:hover:underline [&_a]:hover:decoration-current",
              onClick: handleTextClick,
              children: [
                titleHtml && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  HtmlText,
                  {
                    as: "strong",
                    className: "font-extrabold lg:after:inline lg:after:content-['_']",
                    text: titleHtml
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { as: "span", className: "hidden lg:inline", text: descriptionHtml })
              ]
            }
          ),
          showCountdownTimer && /* @__PURE__ */ jsxRuntimeExports.jsx(InlineCountdownTimer, { className: "ml-4 shrink-0", endTime, units: timerUnits.shortForm })
        ] })
      }
    )
  ] });
};
const BurgerMenuIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...props,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M3 6h18M3 12h18M3 18h18" })
  }
);
const MegaMenuToggle = ({ logo, logoSize, onMenuClick, showMegaMenu }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "button",
  {
    type: "button",
    className: "flex h-full w-full cursor-pointer items-center justify-center focus-visible:outline-none",
    onClick: onMenuClick,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          className: cn(
            "visible flex items-center gap-4 p-4 opacity-100 transition-all duration-700",
            showMegaMenu && "hidden opacity-0 [transition:opacity_0.5s_0.5s,display_0.5s_0.3s]"
          ),
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(BurgerMenuIcon, { className: "h-6 w-6 shrink-0" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: logo.src,
                alt: logo.name,
                className: "h-full w-14 shrink-0 md-v2:hidden",
                height: logoSize ? logoSize.mobile.height : 32,
                width: logoSize ? logoSize.mobile.width : 56
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              "img",
              {
                src: logo.src,
                alt: logo.name,
                className: "h-full w-14 shrink-0 max-md-v2:hidden",
                height: logoSize ? logoSize.desktop.height : 32,
                width: logoSize ? logoSize.desktop.width : 56
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: cn(
            "flex items-center justify-center transition-opacity delay-200 duration-300",
            !showMegaMenu && "invisible hidden opacity-0 [transition:opacity_0.3s,display_0.3s_0.2s]"
          ),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(CrossIcon, { className: "h-6 w-6" })
        }
      )
    ]
  }
);
const NavItemText = ({ bold, boldOnHover, className, text, ...props }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "span",
  {
    "data-title": text,
    className: cn(
      "tracking-wide antialiased outline-none before:invisible before:block before:h-0 before:overflow-hidden before:font-bold before:tracking-wide before:content-[attr(data-title)]",
      bold && "font-bold tracking-normal [text-shadow:0px_0px_currentcolor]",
      boldOnHover && "hover:font-bold hover:tracking-normal hover:[text-shadow:0px_0px_currentcolor] focus:font-bold focus:tracking-normal focus:[text-shadow:0px_0px_currentcolor]",
      className
    ),
    ...props,
    children: text
  }
);
const GlobalNavItem = ({ links, name, newTab, url, regex, closeMegaMenu, onLinkClick }) => {
  const [showPopover, setShowPopover] = useBoolean();
  const gtmType = "main";
  const isCurrentPage = !!regex && RegExp(regex, "i").test(window.location.href);
  return links ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Popover$1, { open: showPopover, onOpenChange: setShowPopover.toggle, children: [
    url ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      PopoverTrigger,
      {
        onMouseEnter: setShowPopover.on,
        onMouseLeave: setShowPopover.off,
        onClick: (e) => {
          onLinkClick == null ? void 0 : onLinkClick(e, { links, name, newTab, url, regex }, closeMegaMenu);
          createNavEvent(name, gtmType)();
        },
        className: "focus-visible:outline-none",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link,
          {
            href: url,
            newTab,
            className: "h-full whitespace-nowrap focus-visible:outline-none",
            "data-nav": "link",
            forwardUtm: true,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText, { text: name, bold: isCurrentPage || showPopover, boldOnHover: true })
          }
        )
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
      PopoverTrigger,
      {
        className: "h-full whitespace-nowrap focus-visible:outline-none",
        onMouseEnter: setShowPopover.on,
        onMouseLeave: setShowPopover.off,
        onClick: (e) => {
          onLinkClick == null ? void 0 : onLinkClick(e, { name, url }, closeMegaMenu);
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText, { text: name, bold: isCurrentPage || showPopover, boldOnHover: true })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PopoverContent,
      {
        className: "relative z-20 w-full space-y-4 p-4 data-[state=closed]:slide-out-to-top-1 data-[state=open]:slide-in-from-top-1",
        sideOffset: 0,
        alignOffset: -16,
        onMouseEnter: setShowPopover.on,
        onMouseLeave: setShowPopover.off,
        onCloseAutoFocus: (event) => event.preventDefault(),
        onOpenAutoFocus: (event) => event.preventDefault(),
        asChild: true,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("nav", { children: links.map((nestedItem) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link,
          {
            href: nestedItem.url,
            newTab: nestedItem.newTab,
            onClick: (e) => {
              onLinkClick == null ? void 0 : onLinkClick(e, nestedItem, closeMegaMenu);
              createNavEvent(nestedItem.name, gtmType)();
            },
            forwardUtm: true,
            className: "whitespace-nowrap focus-visible:outline-none",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              NavItemText,
              {
                text: nestedItem.name,
                bold: !!nestedItem.regex && RegExp(nestedItem.regex, "i").test(window.location.href),
                boldOnHover: true
              }
            )
          },
          nestedItem.url
        )) })
      }
    )
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    Link,
    {
      href: url,
      newTab,
      onClick: (e) => {
        onLinkClick == null ? void 0 : onLinkClick(e, { name, url, newTab, regex }, closeMegaMenu);
        createNavEvent(name, gtmType)();
      },
      className: "flex h-full items-center whitespace-nowrap ty-footnote focus-visible:outline-none",
      forwardUtm: true,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText, { text: name, bold: isCurrentPage, boldOnHover: true })
    }
  );
};
const NavContent = ({
  logo,
  logoSize,
  centerMobileLogo,
  items,
  children,
  onMenuClick,
  closeMegaMenu,
  onLinkClick,
  onLogoClick,
  showFullHeader
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "div",
  {
    className: cn(
      "relative flex h-10 items-center px-4 transition-all fade-in-30 fade-out-30 md-v2:container-v2",
      showFullHeader ? "duration-300 ease-in-out fade-in-70" : "hidden opacity-0 ease-in-out fade-out-70 [transition:opacity_0.3s,display_0.3s_0.3s]"
    ),
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", "aria-label": "Menu", className: "mr-5 block md-v2:hidden", onClick: onMenuClick, children: /* @__PURE__ */ jsxRuntimeExports.jsx(BurgerMenuIcon, { className: "h-6 w-6" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "nav",
        {
          className: cn(
            "flex h-full grow items-center space-x-6",
            centerMobileLogo && "justify-evenly md-v2:justify-start"
          ),
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              Link,
              {
                href: logo.url,
                newTab: logo.newTab,
                forwardUtm: true,
                onClick: (e) => {
                  createNavEvent("Astro Logo", "main")();
                  onLogoClick == null ? void 0 : onLogoClick(e);
                },
                className: cn(
                  "shrink-0 focus-visible:outline-none md-v2:mr-4",
                  centerMobileLogo && "absolute left-1/2 -translate-x-1/2 md-v2:static md-v2:left-0 md-v2:translate-x-0"
                ),
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "img",
                    {
                      src: logo.src,
                      alt: logo.name,
                      className: "h-fit w-14 md-v2:hidden",
                      height: logoSize ? logoSize.mobile.height : 32,
                      width: logoSize ? logoSize.mobile.width : 56
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "img",
                    {
                      src: logo.src,
                      alt: logo.name,
                      className: "h-fit w-14 max-md-v2:hidden",
                      height: logoSize ? logoSize.desktop.height : 32,
                      width: logoSize ? logoSize.desktop.width : 56
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "hidden h-full items-center space-x-6 ty-footnote md-v2:flex", children: items.map((item) => /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalNavItem, { ...item, onLinkClick, closeMegaMenu }, item.name)) })
          ]
        }
      ),
      children
    ]
  }
);
const GlobalNav = ({
  centerMobileLogo,
  items,
  logo,
  logoSize,
  onMenuClick,
  closeMegaMenu,
  showFullHeader,
  showMegaMenu,
  onLinkClick,
  onLogoClick,
  enableFloatingMenu = false,
  isInitialLoad,
  children,
  isBannerFullyShown,
  bannerHeight
}) => {
  const isMobile = useBreakpoint("md-v2", "down");
  const showFloatingMenu = enableFloatingMenu && !showFullHeader;
  useEffect(() => {
    const globalNav = document.getElementById(createHeaderId("global-nav"));
    const globalNavTop = (globalNav == null ? void 0 : globalNav.getBoundingClientRect().top) || 0;
    const globalNavPositionIdentifier = document.getElementById(createHeaderId("global-nav-position-identifier"));
    const globalNavPositionIdentifierTop = (globalNavPositionIdentifier == null ? void 0 : globalNavPositionIdentifier.getBoundingClientRect().top) || 0;
    if (globalNav && isBannerFullyShown) {
      if (showFullHeader && showMegaMenu && isMobile) {
        if (globalNav.style.position !== "fixed") {
          globalNav.style.transform = globalNavPositionIdentifierTop === 0 ? "translateY(16px)" : `translateY(-${globalNavPositionIdentifierTop - 16}px)`;
        }
      } else if (globalNavPositionIdentifierTop !== globalNavTop && showFullHeader) {
        globalNav.removeAttribute("style");
      }
    }
  }, [isBannerFullyShown, isMobile, showFullHeader, showMegaMenu, bannerHeight]);
  useEffect(() => {
    const globalNav = document.getElementById(createHeaderId("global-nav"));
    if (globalNav) {
      globalNav.addEventListener("transitionend", () => {
        if (showMegaMenu && !showFloatingMenu) {
          globalNav == null ? void 0 : globalNav.removeAttribute("style");
          globalNav.style.top = isMobile ? "0px" : "32px";
          globalNav.style.position = "fixed";
        } else {
          globalNav == null ? void 0 : globalNav.removeAttribute("style");
        }
      });
      return () => {
        globalNav.removeEventListener("transitionend", () => {
          if (showMegaMenu) {
            globalNav == null ? void 0 : globalNav.removeAttribute("style");
            globalNav.style.top = "0px";
            globalNav.style.position = "fixed";
          } else {
            globalNav == null ? void 0 : globalNav.removeAttribute("style");
          }
        });
      };
    }
  }, [showMegaMenu, isMobile, showFloatingMenu]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: createHeaderId("global-nav-position-identifier") }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        id: createHeaderId("global-nav"),
        className: cn(
          "pointer-events-auto absolute right-0 z-0 h-10 w-full overflow-hidden bg-magenta-v2-60 md-v2:top-8",
          // Adding transition only after isInitialLoad to prevent animation on first render
          !isInitialLoad && (showMegaMenu ? "[transition:top_0.4s,right_0.4s,transform_0.4s,translate_0.4s,border-radius_0.3s,width_0.4s,z-index_0.1s]" : (
            // Adding delay of z-index changes when close mega menu
            "[transition:top_0.4s,right_0.4s,transform_0.4s,translate_0.4s,border-radius_0.4s,width_0.4s,z-index_0.1s_0.6s]"
          )),
          showFloatingMenu && "right-4 w-[120px] translate-y-4 rounded-md shadow-md-v2 md-v2:right-8 md-v2:w-32 md-v2:translate-y-0",
          showMegaMenu && // using z-31 because of mega menu is z-30 and this should show above mega menu as wrapper of close button
          "right-4 z-[31] w-14 rounded-md shadow-md-v2 max-md-v2:translate-y-4 md-v2:right-8 md-v2:w-18",
          showFullHeader && !showMegaMenu && "w-full translate-y-0"
        ),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            NavContent,
            {
              logo,
              logoSize,
              onMenuClick,
              centerMobileLogo,
              items,
              showFullHeader: showFullHeader && !showMegaMenu,
              onLinkClick,
              closeMegaMenu,
              onLogoClick,
              children
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(MegaMenuToggle, { logo, logoSize, onMenuClick, showMegaMenu })
        ]
      }
    )
  ] });
};
var Slot = React.forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  const childrenArray = React.Children.toArray(children);
  const slottable = childrenArray.find(isSlottable);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map((child) => {
      if (child === slottable) {
        if (React.Children.count(newElement) > 1) return React.Children.only(null);
        return React.isValidElement(newElement) ? newElement.props.children : null;
      } else {
        return child;
      }
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SlotClone, { ...slotProps, ref: forwardedRef, children: React.isValidElement(newElement) ? React.cloneElement(newElement, void 0, newChildren) : null });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SlotClone, { ...slotProps, ref: forwardedRef, children });
});
Slot.displayName = "Slot";
var SlotClone = React.forwardRef((props, forwardedRef) => {
  const { children, ...slotProps } = props;
  if (React.isValidElement(children)) {
    const childrenRef = getElementRef(children);
    const props2 = mergeProps(slotProps, children.props);
    if (children.type !== React.Fragment) {
      props2.ref = forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef;
    }
    return React.cloneElement(children, props2);
  }
  return React.Children.count(children) > 1 ? React.Children.only(null) : null;
});
SlotClone.displayName = "SlotClone";
var Slottable = ({ children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children });
};
function isSlottable(child) {
  return React.isValidElement(child) && child.type === Slottable;
}
function mergeProps(slotProps, childProps) {
  const overrideProps = { ...childProps };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          childPropValue(...args);
          slotPropValue(...args);
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = { ...slotPropValue, ...childPropValue };
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return { ...slotProps, ...overrideProps };
}
function getElementRef(element) {
  var _a, _b;
  let getter = (_a = Object.getOwnPropertyDescriptor(element.props, "ref")) == null ? void 0 : _a.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_b = Object.getOwnPropertyDescriptor(element, "ref")) == null ? void 0 : _b.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}
var NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var Primitive = NODES.reduce((primitive, node) => {
  const Node = React.forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? Slot : node;
    if (typeof window !== "undefined") {
      window[Symbol.for("radix-ui")] = true;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Comp, { ...primitiveProps, ref: forwardedRef });
  });
  Node.displayName = `Primitive.${node}`;
  return { ...primitive, [node]: Node };
}, {});
function clamp(value, [min, max]) {
  return Math.min(max, Math.max(min, value));
}
function useStateMachine(initialState, machine) {
  return React.useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState ?? state;
  }, initialState);
}
var SCROLL_AREA_NAME = "ScrollArea";
var [createScrollAreaContext, createScrollAreaScope] = createContextScope(SCROLL_AREA_NAME);
var [ScrollAreaProvider, useScrollAreaContext] = createScrollAreaContext(SCROLL_AREA_NAME);
var ScrollArea$1 = React.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeScrollArea,
      type = "hover",
      dir,
      scrollHideDelay = 600,
      ...scrollAreaProps
    } = props;
    const [scrollArea, setScrollArea] = React.useState(null);
    const [viewport, setViewport] = React.useState(null);
    const [content, setContent] = React.useState(null);
    const [scrollbarX, setScrollbarX] = React.useState(null);
    const [scrollbarY, setScrollbarY] = React.useState(null);
    const [cornerWidth, setCornerWidth] = React.useState(0);
    const [cornerHeight, setCornerHeight] = React.useState(0);
    const [scrollbarXEnabled, setScrollbarXEnabled] = React.useState(false);
    const [scrollbarYEnabled, setScrollbarYEnabled] = React.useState(false);
    const composedRefs = useComposedRefs(forwardedRef, (node) => setScrollArea(node));
    const direction = useDirection(dir);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      ScrollAreaProvider,
      {
        scope: __scopeScrollArea,
        type,
        dir: direction,
        scrollHideDelay,
        scrollArea,
        viewport,
        onViewportChange: setViewport,
        content,
        onContentChange: setContent,
        scrollbarX,
        onScrollbarXChange: setScrollbarX,
        scrollbarXEnabled,
        onScrollbarXEnabledChange: setScrollbarXEnabled,
        scrollbarY,
        onScrollbarYChange: setScrollbarY,
        scrollbarYEnabled,
        onScrollbarYEnabledChange: setScrollbarYEnabled,
        onCornerWidthChange: setCornerWidth,
        onCornerHeightChange: setCornerHeight,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Primitive.div,
          {
            dir: direction,
            ...scrollAreaProps,
            ref: composedRefs,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              ["--radix-scroll-area-corner-width"]: cornerWidth + "px",
              ["--radix-scroll-area-corner-height"]: cornerHeight + "px",
              ...props.style
            }
          }
        )
      }
    );
  }
);
ScrollArea$1.displayName = SCROLL_AREA_NAME;
var VIEWPORT_NAME = "ScrollAreaViewport";
var ScrollAreaViewport = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeScrollArea, children, nonce, ...viewportProps } = props;
    const context = useScrollAreaContext(VIEWPORT_NAME, __scopeScrollArea);
    const ref = React.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref, context.onViewportChange);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: `[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}`
          },
          nonce
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Primitive.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...viewportProps,
          ref: composedRefs,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: context.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: context.scrollbarYEnabled ? "scroll" : "hidden",
            ...props.style
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: context.onContentChange, style: { minWidth: "100%", display: "table" }, children })
        }
      )
    ] });
  }
);
ScrollAreaViewport.displayName = VIEWPORT_NAME;
var SCROLLBAR_NAME = "ScrollAreaScrollbar";
var ScrollAreaScrollbar = React.forwardRef(
  (props, forwardedRef) => {
    const { forceMount, ...scrollbarProps } = props;
    const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
    const { onScrollbarXEnabledChange, onScrollbarYEnabledChange } = context;
    const isHorizontal = props.orientation === "horizontal";
    React.useEffect(() => {
      isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
      return () => {
        isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
      };
    }, [isHorizontal, onScrollbarXEnabledChange, onScrollbarYEnabledChange]);
    return context.type === "hover" ? /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollAreaScrollbarHover, { ...scrollbarProps, ref: forwardedRef, forceMount }) : context.type === "scroll" ? /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollAreaScrollbarScroll, { ...scrollbarProps, ref: forwardedRef, forceMount }) : context.type === "auto" ? /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollAreaScrollbarAuto, { ...scrollbarProps, ref: forwardedRef, forceMount }) : context.type === "always" ? /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollAreaScrollbarVisible, { ...scrollbarProps, ref: forwardedRef }) : null;
  }
);
ScrollAreaScrollbar.displayName = SCROLLBAR_NAME;
var ScrollAreaScrollbarHover = React.forwardRef((props, forwardedRef) => {
  const { forceMount, ...scrollbarProps } = props;
  const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    const scrollArea = context.scrollArea;
    let hideTimer = 0;
    if (scrollArea) {
      const handlePointerEnter = () => {
        window.clearTimeout(hideTimer);
        setVisible(true);
      };
      const handlePointerLeave = () => {
        hideTimer = window.setTimeout(() => setVisible(false), context.scrollHideDelay);
      };
      scrollArea.addEventListener("pointerenter", handlePointerEnter);
      scrollArea.addEventListener("pointerleave", handlePointerLeave);
      return () => {
        window.clearTimeout(hideTimer);
        scrollArea.removeEventListener("pointerenter", handlePointerEnter);
        scrollArea.removeEventListener("pointerleave", handlePointerLeave);
      };
    }
  }, [context.scrollArea, context.scrollHideDelay]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Presence, { present: forceMount || visible, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    ScrollAreaScrollbarAuto,
    {
      "data-state": visible ? "visible" : "hidden",
      ...scrollbarProps,
      ref: forwardedRef
    }
  ) });
});
var ScrollAreaScrollbarScroll = React.forwardRef((props, forwardedRef) => {
  const { forceMount, ...scrollbarProps } = props;
  const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
  const isHorizontal = props.orientation === "horizontal";
  const debounceScrollEnd = useDebounceCallback(() => send("SCROLL_END"), 100);
  const [state, send] = useStateMachine("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  React.useEffect(() => {
    if (state === "idle") {
      const hideTimer = window.setTimeout(() => send("HIDE"), context.scrollHideDelay);
      return () => window.clearTimeout(hideTimer);
    }
  }, [state, context.scrollHideDelay, send]);
  React.useEffect(() => {
    const viewport = context.viewport;
    const scrollDirection = isHorizontal ? "scrollLeft" : "scrollTop";
    if (viewport) {
      let prevScrollPos = viewport[scrollDirection];
      const handleScroll = () => {
        const scrollPos = viewport[scrollDirection];
        const hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
        if (hasScrollInDirectionChanged) {
          send("SCROLL");
          debounceScrollEnd();
        }
        prevScrollPos = scrollPos;
      };
      viewport.addEventListener("scroll", handleScroll);
      return () => viewport.removeEventListener("scroll", handleScroll);
    }
  }, [context.viewport, isHorizontal, send, debounceScrollEnd]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Presence, { present: forceMount || state !== "hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    ScrollAreaScrollbarVisible,
    {
      "data-state": state === "hidden" ? "hidden" : "visible",
      ...scrollbarProps,
      ref: forwardedRef,
      onPointerEnter: composeEventHandlers(props.onPointerEnter, () => send("POINTER_ENTER")),
      onPointerLeave: composeEventHandlers(props.onPointerLeave, () => send("POINTER_LEAVE"))
    }
  ) });
});
var ScrollAreaScrollbarAuto = React.forwardRef((props, forwardedRef) => {
  const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
  const { forceMount, ...scrollbarProps } = props;
  const [visible, setVisible] = React.useState(false);
  const isHorizontal = props.orientation === "horizontal";
  const handleResize = useDebounceCallback(() => {
    if (context.viewport) {
      const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
      const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
      setVisible(isHorizontal ? isOverflowX : isOverflowY);
    }
  }, 10);
  useResizeObserver(context.viewport, handleResize);
  useResizeObserver(context.content, handleResize);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Presence, { present: forceMount || visible, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    ScrollAreaScrollbarVisible,
    {
      "data-state": visible ? "visible" : "hidden",
      ...scrollbarProps,
      ref: forwardedRef
    }
  ) });
});
var ScrollAreaScrollbarVisible = React.forwardRef((props, forwardedRef) => {
  const { orientation = "vertical", ...scrollbarProps } = props;
  const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
  const thumbRef = React.useRef(null);
  const pointerOffsetRef = React.useRef(0);
  const [sizes, setSizes] = React.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  });
  const thumbRatio = getThumbRatio(sizes.viewport, sizes.content);
  const commonProps = {
    ...scrollbarProps,
    sizes,
    onSizesChange: setSizes,
    hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
    onThumbChange: (thumb) => thumbRef.current = thumb,
    onThumbPointerUp: () => pointerOffsetRef.current = 0,
    onThumbPointerDown: (pointerPos) => pointerOffsetRef.current = pointerPos
  };
  function getScrollPosition(pointerPos, dir) {
    return getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, dir);
  }
  if (orientation === "horizontal") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      ScrollAreaScrollbarX,
      {
        ...commonProps,
        ref: forwardedRef,
        onThumbPositionChange: () => {
          if (context.viewport && thumbRef.current) {
            const scrollPos = context.viewport.scrollLeft;
            const offset = getThumbOffsetFromScroll(scrollPos, sizes, context.dir);
            thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
          }
        },
        onWheelScroll: (scrollPos) => {
          if (context.viewport) context.viewport.scrollLeft = scrollPos;
        },
        onDragScroll: (pointerPos) => {
          if (context.viewport) {
            context.viewport.scrollLeft = getScrollPosition(pointerPos, context.dir);
          }
        }
      }
    );
  }
  if (orientation === "vertical") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      ScrollAreaScrollbarY,
      {
        ...commonProps,
        ref: forwardedRef,
        onThumbPositionChange: () => {
          if (context.viewport && thumbRef.current) {
            const scrollPos = context.viewport.scrollTop;
            const offset = getThumbOffsetFromScroll(scrollPos, sizes);
            thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
          }
        },
        onWheelScroll: (scrollPos) => {
          if (context.viewport) context.viewport.scrollTop = scrollPos;
        },
        onDragScroll: (pointerPos) => {
          if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
      }
    );
  }
  return null;
});
var ScrollAreaScrollbarX = React.forwardRef((props, forwardedRef) => {
  const { sizes, onSizesChange, ...scrollbarProps } = props;
  const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
  const [computedStyle, setComputedStyle] = React.useState();
  const ref = React.useRef(null);
  const composeRefs2 = useComposedRefs(forwardedRef, ref, context.onScrollbarXChange);
  React.useEffect(() => {
    if (ref.current) setComputedStyle(getComputedStyle(ref.current));
  }, [ref]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ScrollAreaScrollbarImpl,
    {
      "data-orientation": "horizontal",
      ...scrollbarProps,
      ref: composeRefs2,
      sizes,
      style: {
        bottom: 0,
        left: context.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: context.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        ["--radix-scroll-area-thumb-width"]: getThumbSize(sizes) + "px",
        ...props.style
      },
      onThumbPointerDown: (pointerPos) => props.onThumbPointerDown(pointerPos.x),
      onDragScroll: (pointerPos) => props.onDragScroll(pointerPos.x),
      onWheelScroll: (event, maxScrollPos) => {
        if (context.viewport) {
          const scrollPos = context.viewport.scrollLeft + event.deltaX;
          props.onWheelScroll(scrollPos);
          if (isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) {
            event.preventDefault();
          }
        }
      },
      onResize: () => {
        if (ref.current && context.viewport && computedStyle) {
          onSizesChange({
            content: context.viewport.scrollWidth,
            viewport: context.viewport.offsetWidth,
            scrollbar: {
              size: ref.current.clientWidth,
              paddingStart: toInt(computedStyle.paddingLeft),
              paddingEnd: toInt(computedStyle.paddingRight)
            }
          });
        }
      }
    }
  );
});
var ScrollAreaScrollbarY = React.forwardRef((props, forwardedRef) => {
  const { sizes, onSizesChange, ...scrollbarProps } = props;
  const context = useScrollAreaContext(SCROLLBAR_NAME, props.__scopeScrollArea);
  const [computedStyle, setComputedStyle] = React.useState();
  const ref = React.useRef(null);
  const composeRefs2 = useComposedRefs(forwardedRef, ref, context.onScrollbarYChange);
  React.useEffect(() => {
    if (ref.current) setComputedStyle(getComputedStyle(ref.current));
  }, [ref]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ScrollAreaScrollbarImpl,
    {
      "data-orientation": "vertical",
      ...scrollbarProps,
      ref: composeRefs2,
      sizes,
      style: {
        top: 0,
        right: context.dir === "ltr" ? 0 : void 0,
        left: context.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        ["--radix-scroll-area-thumb-height"]: getThumbSize(sizes) + "px",
        ...props.style
      },
      onThumbPointerDown: (pointerPos) => props.onThumbPointerDown(pointerPos.y),
      onDragScroll: (pointerPos) => props.onDragScroll(pointerPos.y),
      onWheelScroll: (event, maxScrollPos) => {
        if (context.viewport) {
          const scrollPos = context.viewport.scrollTop + event.deltaY;
          props.onWheelScroll(scrollPos);
          if (isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) {
            event.preventDefault();
          }
        }
      },
      onResize: () => {
        if (ref.current && context.viewport && computedStyle) {
          onSizesChange({
            content: context.viewport.scrollHeight,
            viewport: context.viewport.offsetHeight,
            scrollbar: {
              size: ref.current.clientHeight,
              paddingStart: toInt(computedStyle.paddingTop),
              paddingEnd: toInt(computedStyle.paddingBottom)
            }
          });
        }
      }
    }
  );
});
var [ScrollbarProvider, useScrollbarContext] = createScrollAreaContext(SCROLLBAR_NAME);
var ScrollAreaScrollbarImpl = React.forwardRef((props, forwardedRef) => {
  const {
    __scopeScrollArea,
    sizes,
    hasThumb,
    onThumbChange,
    onThumbPointerUp,
    onThumbPointerDown,
    onThumbPositionChange,
    onDragScroll,
    onWheelScroll,
    onResize,
    ...scrollbarProps
  } = props;
  const context = useScrollAreaContext(SCROLLBAR_NAME, __scopeScrollArea);
  const [scrollbar, setScrollbar] = React.useState(null);
  const composeRefs2 = useComposedRefs(forwardedRef, (node) => setScrollbar(node));
  const rectRef = React.useRef(null);
  const prevWebkitUserSelectRef = React.useRef("");
  const viewport = context.viewport;
  const maxScrollPos = sizes.content - sizes.viewport;
  const handleWheelScroll = useCallbackRef(onWheelScroll);
  const handleThumbPositionChange = useCallbackRef(onThumbPositionChange);
  const handleResize = useDebounceCallback(onResize, 10);
  function handleDragScroll(event) {
    if (rectRef.current) {
      const x = event.clientX - rectRef.current.left;
      const y = event.clientY - rectRef.current.top;
      onDragScroll({ x, y });
    }
  }
  React.useEffect(() => {
    const handleWheel = (event) => {
      const element = event.target;
      const isScrollbarWheel = scrollbar == null ? void 0 : scrollbar.contains(element);
      if (isScrollbarWheel) handleWheelScroll(event, maxScrollPos);
    };
    document.addEventListener("wheel", handleWheel, { passive: false });
    return () => document.removeEventListener("wheel", handleWheel, { passive: false });
  }, [viewport, scrollbar, maxScrollPos, handleWheelScroll]);
  React.useEffect(handleThumbPositionChange, [sizes, handleThumbPositionChange]);
  useResizeObserver(scrollbar, handleResize);
  useResizeObserver(context.content, handleResize);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ScrollbarProvider,
    {
      scope: __scopeScrollArea,
      scrollbar,
      hasThumb,
      onThumbChange: useCallbackRef(onThumbChange),
      onThumbPointerUp: useCallbackRef(onThumbPointerUp),
      onThumbPositionChange: handleThumbPositionChange,
      onThumbPointerDown: useCallbackRef(onThumbPointerDown),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Primitive.div,
        {
          ...scrollbarProps,
          ref: composeRefs2,
          style: { position: "absolute", ...scrollbarProps.style },
          onPointerDown: composeEventHandlers(props.onPointerDown, (event) => {
            const mainPointer = 0;
            if (event.button === mainPointer) {
              const element = event.target;
              element.setPointerCapture(event.pointerId);
              rectRef.current = scrollbar.getBoundingClientRect();
              prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
              document.body.style.webkitUserSelect = "none";
              if (context.viewport) context.viewport.style.scrollBehavior = "auto";
              handleDragScroll(event);
            }
          }),
          onPointerMove: composeEventHandlers(props.onPointerMove, handleDragScroll),
          onPointerUp: composeEventHandlers(props.onPointerUp, (event) => {
            const element = event.target;
            if (element.hasPointerCapture(event.pointerId)) {
              element.releasePointerCapture(event.pointerId);
            }
            document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
            if (context.viewport) context.viewport.style.scrollBehavior = "";
            rectRef.current = null;
          })
        }
      )
    }
  );
});
var THUMB_NAME = "ScrollAreaThumb";
var ScrollAreaThumb = React.forwardRef(
  (props, forwardedRef) => {
    const { forceMount, ...thumbProps } = props;
    const scrollbarContext = useScrollbarContext(THUMB_NAME, props.__scopeScrollArea);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Presence, { present: forceMount || scrollbarContext.hasThumb, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollAreaThumbImpl, { ref: forwardedRef, ...thumbProps }) });
  }
);
var ScrollAreaThumbImpl = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeScrollArea, style, ...thumbProps } = props;
    const scrollAreaContext = useScrollAreaContext(THUMB_NAME, __scopeScrollArea);
    const scrollbarContext = useScrollbarContext(THUMB_NAME, __scopeScrollArea);
    const { onThumbPositionChange } = scrollbarContext;
    const composedRef = useComposedRefs(
      forwardedRef,
      (node) => scrollbarContext.onThumbChange(node)
    );
    const removeUnlinkedScrollListenerRef = React.useRef(void 0);
    const debounceScrollEnd = useDebounceCallback(() => {
      if (removeUnlinkedScrollListenerRef.current) {
        removeUnlinkedScrollListenerRef.current();
        removeUnlinkedScrollListenerRef.current = void 0;
      }
    }, 100);
    React.useEffect(() => {
      const viewport = scrollAreaContext.viewport;
      if (viewport) {
        const handleScroll = () => {
          debounceScrollEnd();
          if (!removeUnlinkedScrollListenerRef.current) {
            const listener = addUnlinkedScrollListener(viewport, onThumbPositionChange);
            removeUnlinkedScrollListenerRef.current = listener;
            onThumbPositionChange();
          }
        };
        onThumbPositionChange();
        viewport.addEventListener("scroll", handleScroll);
        return () => viewport.removeEventListener("scroll", handleScroll);
      }
    }, [scrollAreaContext.viewport, debounceScrollEnd, onThumbPositionChange]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Primitive.div,
      {
        "data-state": scrollbarContext.hasThumb ? "visible" : "hidden",
        ...thumbProps,
        ref: composedRef,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...style
        },
        onPointerDownCapture: composeEventHandlers(props.onPointerDownCapture, (event) => {
          const thumb = event.target;
          const thumbRect = thumb.getBoundingClientRect();
          const x = event.clientX - thumbRect.left;
          const y = event.clientY - thumbRect.top;
          scrollbarContext.onThumbPointerDown({ x, y });
        }),
        onPointerUp: composeEventHandlers(props.onPointerUp, scrollbarContext.onThumbPointerUp)
      }
    );
  }
);
ScrollAreaThumb.displayName = THUMB_NAME;
var CORNER_NAME = "ScrollAreaCorner";
var ScrollAreaCorner = React.forwardRef(
  (props, forwardedRef) => {
    const context = useScrollAreaContext(CORNER_NAME, props.__scopeScrollArea);
    const hasBothScrollbarsVisible = Boolean(context.scrollbarX && context.scrollbarY);
    const hasCorner = context.type !== "scroll" && hasBothScrollbarsVisible;
    return hasCorner ? /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollAreaCornerImpl, { ...props, ref: forwardedRef }) : null;
  }
);
ScrollAreaCorner.displayName = CORNER_NAME;
var ScrollAreaCornerImpl = React.forwardRef((props, forwardedRef) => {
  const { __scopeScrollArea, ...cornerProps } = props;
  const context = useScrollAreaContext(CORNER_NAME, __scopeScrollArea);
  const [width, setWidth] = React.useState(0);
  const [height, setHeight] = React.useState(0);
  const hasSize = Boolean(width && height);
  useResizeObserver(context.scrollbarX, () => {
    var _a;
    const height2 = ((_a = context.scrollbarX) == null ? void 0 : _a.offsetHeight) || 0;
    context.onCornerHeightChange(height2);
    setHeight(height2);
  });
  useResizeObserver(context.scrollbarY, () => {
    var _a;
    const width2 = ((_a = context.scrollbarY) == null ? void 0 : _a.offsetWidth) || 0;
    context.onCornerWidthChange(width2);
    setWidth(width2);
  });
  return hasSize ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Primitive.div,
    {
      ...cornerProps,
      ref: forwardedRef,
      style: {
        width,
        height,
        position: "absolute",
        right: context.dir === "ltr" ? 0 : void 0,
        left: context.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...props.style
      }
    }
  ) : null;
});
function toInt(value) {
  return value ? parseInt(value, 10) : 0;
}
function getThumbRatio(viewportSize, contentSize) {
  const ratio = viewportSize / contentSize;
  return isNaN(ratio) ? 0 : ratio;
}
function getThumbSize(sizes) {
  const ratio = getThumbRatio(sizes.viewport, sizes.content);
  const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
  const thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio;
  return Math.max(thumbSize, 18);
}
function getScrollPositionFromPointer(pointerPos, pointerOffset, sizes, dir = "ltr") {
  const thumbSizePx = getThumbSize(sizes);
  const thumbCenter = thumbSizePx / 2;
  const offset = pointerOffset || thumbCenter;
  const thumbOffsetFromEnd = thumbSizePx - offset;
  const minPointerPos = sizes.scrollbar.paddingStart + offset;
  const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
  const maxScrollPos = sizes.content - sizes.viewport;
  const scrollRange = dir === "ltr" ? [0, maxScrollPos] : [maxScrollPos * -1, 0];
  const interpolate2 = linearScale([minPointerPos, maxPointerPos], scrollRange);
  return interpolate2(pointerPos);
}
function getThumbOffsetFromScroll(scrollPos, sizes, dir = "ltr") {
  const thumbSizePx = getThumbSize(sizes);
  const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
  const scrollbar = sizes.scrollbar.size - scrollbarPadding;
  const maxScrollPos = sizes.content - sizes.viewport;
  const maxThumbPos = scrollbar - thumbSizePx;
  const scrollClampRange = dir === "ltr" ? [0, maxScrollPos] : [maxScrollPos * -1, 0];
  const scrollWithoutMomentum = clamp(scrollPos, scrollClampRange);
  const interpolate2 = linearScale([0, maxScrollPos], [0, maxThumbPos]);
  return interpolate2(scrollWithoutMomentum);
}
function linearScale(input, output) {
  return (value) => {
    if (input[0] === input[1] || output[0] === output[1]) return output[0];
    const ratio = (output[1] - output[0]) / (input[1] - input[0]);
    return output[0] + ratio * (value - input[0]);
  };
}
function isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
  return scrollPos > 0 && scrollPos < maxScrollPos;
}
var addUnlinkedScrollListener = (node, handler = () => {
}) => {
  let prevPosition = { left: node.scrollLeft, top: node.scrollTop };
  let rAF = 0;
  (function loop() {
    const position = { left: node.scrollLeft, top: node.scrollTop };
    const isHorizontalScroll = prevPosition.left !== position.left;
    const isVerticalScroll = prevPosition.top !== position.top;
    if (isHorizontalScroll || isVerticalScroll) handler();
    prevPosition = position;
    rAF = window.requestAnimationFrame(loop);
  })();
  return () => window.cancelAnimationFrame(rAF);
};
function useDebounceCallback(callback, delay) {
  const handleCallback = useCallbackRef(callback);
  const debounceTimerRef = React.useRef(0);
  React.useEffect(() => () => window.clearTimeout(debounceTimerRef.current), []);
  return React.useCallback(() => {
    window.clearTimeout(debounceTimerRef.current);
    debounceTimerRef.current = window.setTimeout(handleCallback, delay);
  }, [handleCallback, delay]);
}
function useResizeObserver(element, onResize) {
  const handleResize = useCallbackRef(onResize);
  useLayoutEffect2(() => {
    let rAF = 0;
    if (element) {
      const resizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(rAF);
        rAF = window.requestAnimationFrame(handleResize);
      });
      resizeObserver.observe(element);
      return () => {
        window.cancelAnimationFrame(rAF);
        resizeObserver.unobserve(element);
      };
    }
  }, [element, handleResize]);
}
var Root = ScrollArea$1;
var Viewport = ScrollAreaViewport;
var Corner = ScrollAreaCorner;
const ScrollBar = React.forwardRef(
  ({ className, orientation = "vertical", scrollbarThumbClassName, ...props }, ref) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    ScrollAreaScrollbar,
    {
      ref,
      orientation,
      className: cn(
        "flex touch-none select-none transition-colors",
        orientation === "vertical" && "h-full w-1.5 border-l border-l-transparent p-[1px]",
        orientation === "horizontal" && "h-1.5 flex-col border-t border-t-transparent p-[1px]",
        className
      ),
      ...props,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        ScrollAreaThumb,
        {
          className: cn("bg-border relative flex-1 rounded-full", scrollbarThumbClassName)
        }
      )
    }
  )
);
ScrollBar.displayName = ScrollAreaScrollbar.displayName;
const ScrollArea = React.forwardRef(
  ({ className, children, scrollbarClassName, scrollbarThumbClassName, ...props }, ref) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Root, { ref, className: cn("relative overflow-hidden", className), ...props, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Viewport, { className: "h-full w-full rounded-[inherit]", children }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollBar, { className: scrollbarClassName, scrollbarThumbClassName }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Corner, {})
  ] })
);
ScrollArea.displayName = Root.displayName;
const ResetIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", ...props, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.02 2.314a.5.5 0 0 1 0 .707l-10 10a.5.5 0 0 1-.707-.707l10-10a.5.5 0 0 1 .708 0Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.02 13.02a.5.5 0 0 1-.706 0l-10-10a.5.5 0 1 1 .706-.707l10 10a.5.5 0 0 1 0 .708Z",
      fill: "currentColor"
    }
  )
] });
const SearchBar = ({ className, endpoint, placeholder, queryKey, gtmType }) => {
  const inputRef = useRef(null);
  const [value, setValue] = useState("");
  const resetValue = () => {
    var _a;
    setValue("");
    (_a = inputRef.current) == null ? void 0 : _a.focus();
  };
  const handleSubmit = (event) => {
    const data = new FormData(event.currentTarget);
    const keyword = data.get(queryKey);
    if (typeof keyword === "string" && keyword.trim()) createSearchEvent(keyword, gtmType)();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("form", { id: createHeaderId("search"), className: "relative", action: endpoint, onSubmit: handleSubmit, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    InputWrapper,
    {
      className: cn(
        "flex items-center justify-center border-neutral-v2-10 pr-1 has-[input:hover]:bg-neutral-v2-5",
        className
      ),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Input,
          {
            className: "appearance-none border-0 bg-transparent pr-2 [&::-webkit-search-cancel-button]:appearance-none",
            ref: inputRef,
            name: queryKey,
            type: "search",
            placeholder,
            autoComplete: "off",
            value,
            onChange: (e) => setValue(e.target.value)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mr-2", children: value.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-blue-v2-60", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ResetIcon, { className: "text-neutral-v2-0", onClick: resetValue }) }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { size: "small", type: "submit", className: "w-12 focus-visible:outline-none", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchIcon, { width: 16, height: 16 }) })
      ]
    }
  ) });
};
const LocaleContext = createContext(DEFAULT_LOCALE);
function useLocale() {
  return useContext(LocaleContext);
}
const LocaleProvider = ({ children, locale }) => /* @__PURE__ */ jsxRuntimeExports.jsx(LocaleContext.Provider, { value: locale, children });
function useCrossPromoConfig(endpoint, locale, shouldFetch) {
  const { data, isLoading } = useDfConfig(endpoint, "cross_promotion", {
    fetchCondition: () => Boolean(shouldFetch)
  });
  if (!data)
    return {
      config: {
        title: "Explore websites in Astro",
        logo: { src: "", alt: "" },
        products: []
      },
      isLoading: true
    };
  const localeMapping = {
    en: "en",
    bm: "ms"
  };
  return {
    config: {
      title: data.titleLocales[localeMapping[locale]],
      logo: { src: data.titleLogoUrl, alt: "Astro" },
      products: data.products.map((product) => ({
        image: product.thumbnail,
        name: product.title,
        description: product.description,
        url: product.external_link
      }))
    },
    isLoading
  };
}
const CrossPromo = ({ endpoint, onClose, open, className }) => {
  const locale = useLocale();
  const {
    config: { title, logo, products },
    isLoading
  } = useCrossPromoConfig(endpoint, locale, open);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Modal,
    {
      open,
      id: createHeaderId("brands"),
      panelClassName: "h-full max-w-full overflow-auto rounded-none bg-neutral-50",
      className,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "container flex flex-col py-8", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(CloseButton, { className: "mb-4 self-end", onClick: onClose }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { id: createHeaderId("brands", "header"), className: "mb-8 flex items-center", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "text-[22px] font-bold", children: title }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: logo.src, alt: logo.alt, className: "ml-2 h-6", width: 56, height: 24 })
        ] }),
        isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Loading..." }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: createHeaderId("brands", "grid"), className: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3", children: products.map(({ description, image, name, url }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Link, { href: url, newTab: true, className: "flex rounded-sm bg-white p-2 shadow", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("img", { className: "row-span-3 rounded-xs", src: image, alt: name, width: 120, height: 120, loading: "lazy" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "ml-2 flex flex-col", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: "mb-1 font-extrabold leading-none", children: name }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-[13px]", children: description }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mt-auto text-[13px]", children: url })
          ] })
        ] }, name)) })
      ] })
    }
  );
};
const UniversalNav = ({
  crossPromo,
  sites,
  className,
  gtmType,
  children,
  crossPromoClassname
}) => {
  const [showBrands, setShowBrands] = useBoolean();
  const [boldIndex, setBoldIndex] = useState(0);
  const isMobile = useBreakpoint("md-v2", "down");
  const filteredSites = sites.filter((_, index) => isMobile ? index !== boldIndex : true);
  const handleBrandsClick = () => {
    setShowBrands.on();
    createNavEvent(crossPromo.name, gtmType)();
  };
  useEffect(() => {
    const index = filteredSites.findIndex(({ regex }) => regex && RegExp(regex, "i").test(window.location.href));
    if (index >= 0) setBoldIndex(index);
  }, [filteredSites]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: createHeaderId("universal-nav"), className: cn("h-8 bg-black", className), children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative flex h-full justify-center md-v2:justify-between", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("nav", { className: "flex items-center justify-center space-x-6 text-white ty-caption md-v2:justify-start md-v2:space-x-7", children: [
      filteredSites.map(({ name, newTab, url }, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        Link,
        {
          href: url,
          newTab,
          onClick: createNavEvent(name, gtmType),
          className: "focus-visible:outline-none",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText, { text: name, bold: index === boldIndex && !isMobile, boldOnHover: true })
        },
        name
      )),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        NavItemText,
        {
          className: "cursor-pointer align-baseline",
          text: crossPromo.name,
          bold: showBrands,
          boldOnHover: true,
          onClick: handleBrandsClick
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        CrossPromo,
        {
          endpoint: crossPromo.endpoint,
          open: showBrands,
          onClose: setShowBrands.off,
          className: crossPromoClassname
        }
      )
    ] }),
    children
  ] }) });
};
const AuthContext = createContext({
  authenticated: false,
  isUxfPortal: false,
  loginUrl: "",
  logoutUrl: "",
  profileUrl: "",
  isChatbotConfiguredToBeShown: false,
  isLightspeed: false
});
function useAuth() {
  return useContext(AuthContext);
}
function handleChatbot(fn) {
  const elements = ["chat-button-frame", "chat-prompt-frame"].reduce((acc, id) => {
    const element = document.getElementById(id);
    if (element instanceof HTMLElement) return [...acc, element];
    return acc;
  }, []);
  const stickyElements = document.querySelectorAll("[data-livechat-sticky]");
  const stickyOffset = Array.from(stickyElements).reduce((tallestHeight, element) => {
    if (element instanceof HTMLElement && element.offsetHeight > tallestHeight) return element.offsetHeight;
    return tallestHeight;
  }, 0);
  const verticalTranslation = `translateY(-${stickyOffset}px)`;
  elements.forEach(
    (element) => stickyOffset ? element.style.setProperty("transform", verticalTranslation) : element.style.removeProperty("transform")
  );
  fn == null ? void 0 : fn();
}
function useChatbot(chatbotConfig, onCallback) {
  const { hiddenPortals } = chatbotConfig;
  useEffect(() => {
    const handleMutation = () => handleChatbot(onCallback);
    handleMutation();
    const observer = new MutationObserver(handleMutation);
    observer.observe(document, { subtree: true, childList: true });
    return () => {
      observer.disconnect();
    };
  }, [onCallback]);
  useEffect(() => {
    const match = hiddenPortals.find((regex) => regex && window.location.href.match(new RegExp(regex, "i")));
    if (match) {
      const styleElement = document.createElement("style");
      styleElement.innerHTML = "#chat-button-frame,#chat-prompt-frame,#chat-window-frame{display:none}";
      styleElement.dataset.chatbotOverride = "";
      document.head.appendChild(styleElement);
    } else {
      document.querySelectorAll("[data-chatbot-override]").forEach((element) => {
        element.remove();
      });
    }
  }, [hiddenPortals]);
}
const AuthProvider = ({
  children,
  loginUrlParams,
  onAuth,
  onInit,
  profileUrl: profileUrlConfig,
  session,
  whitelistedUxfDomains,
  chatbotConfig
}) => {
  const sessionId = useConst(nanoid());
  const [hasSession, setHasSession] = useState(false);
  const [authenticating, setAuthenticating] = useState(false);
  const [isUxfPortal, setIsUxfPortal] = useState(false);
  const [loginUrl, setLoginUrl] = useState("");
  const [logoutUrl, setLogoutUrl] = useState("");
  const [profileUrl, setProfileUrl] = useState(profileUrlConfig.default);
  const [username, setUsername] = useState("");
  const [isLightspeed, setIsLightspeed] = useState(false);
  const isChatbotConfiguredToBeShown = Boolean(
    !chatbotConfig.hiddenPortals.find((regex) => regex && window.location.href.match(new RegExp(regex, "i")))
  );
  const initializeChatbotCustomerName = useCallback(() => {
    const hasInitializedChatbotSession = getCookie(CHATBOT_USER_INFO);
    if (hasSession && username && isChatbotConfiguredToBeShown && !hasInitializedChatbotSession) {
      startChatbotSession(username);
    }
  }, [hasSession, isChatbotConfiguredToBeShown, username]);
  useChatbot(chatbotConfig, initializeChatbotCustomerName);
  useEffect(() => {
    const constructedUrl = initLoginUrl(loginUrlParams, sessionId);
    setLoginUrl(constructedUrl);
    const uxfEnabled = whitelistedUxfDomains.includes(window.location.hostname);
    setHasSession(Boolean(uxfEnabled || hasExistingSession()));
    setIsUxfPortal(uxfEnabled);
    setProfileUrl(uxfEnabled ? profileUrlConfig.uxf : profileUrlConfig.default);
    setLogoutUrl(uxfEnabled ? profileUrlConfig.uxf : "");
    if (constructedUrl) onInit == null ? void 0 : onInit({ ulmUrl: constructedUrl, isUxfPortal: uxfEnabled });
    const ulmProfileEventHandler = (e) => {
      const profile = e.detail;
      if (!uxfEnabled) setHasSession(isUlmProfile(profile));
    };
    window.addEventListener(ULM_PROFILE_EVENT, ulmProfileEventHandler);
    return () => {
      window.removeEventListener(ULM_PROFILE_EVENT, ulmProfileEventHandler);
    };
  }, [loginUrlParams, onInit, profileUrlConfig.default, profileUrlConfig.uxf, sessionId, whitelistedUxfDomains]);
  useEffect(() => {
    if (loginUrl && !authenticating) {
      setAuthenticating(true);
      refreshSession(session, isChatbotConfiguredToBeShown, sessionId).then((profile) => {
        setUsername((profile == null ? void 0 : profile.name) || "");
        if (profile == null ? void 0 : profile.is_lightspeed) setIsLightspeed(true);
        onAuth == null ? void 0 : onAuth(profile);
      });
    }
  }, [authenticating, isChatbotConfiguredToBeShown, loginUrl, onAuth, sessionId, session]);
  const context = useMemo(
    () => ({
      authenticated: hasSession,
      isUxfPortal,
      loginUrl,
      logoutUrl,
      profileUrl,
      isChatbotConfiguredToBeShown,
      isLightspeed
    }),
    [hasSession, isUxfPortal, loginUrl, logoutUrl, profileUrl, isChatbotConfiguredToBeShown, isLightspeed]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AuthContext.Provider, { value: context, children });
};
const Account = ({
  button,
  menuLabel,
  onLogin,
  onLogout,
  shouldOverrideLogout,
  shouldShowMenuLabel,
  gtmType,
  popoverContentClassName
}) => {
  const { authenticated, loginUrl, logoutUrl, profileUrl, isChatbotConfiguredToBeShown, isLightspeed } = useAuth();
  const [isOpen, setIsOpen] = useBoolean(false);
  const handleLogout = (closeMenu) => () => {
    if (!shouldOverrideLogout) logout();
    if (isChatbotConfiguredToBeShown) endChatbotSession();
    onLogout == null ? void 0 : onLogout();
    closeMenu == null ? void 0 : closeMenu();
  };
  const handleLogin = () => {
    createNavEvent("Login", gtmType)();
    onLogin == null ? void 0 : onLogin();
    window.location.href = interpolate(loginUrl, { location: encodeURIComponent(window.location.href) });
  };
  if (authenticated) {
    return (
      // isLightspeed behaviour: https://astrogo.atlassian.net/browse/ACM22-4672
      /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "button",
          {
            type: "button",
            onClick: handleLogout(),
            className: cn("hidden h-8 items-center focus-visible:outline-none", isLightspeed && "md-v2:flex"),
            "aria-label": "Login",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(AccountIcon, { className: "h-4 w-4" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                NavItemText,
                {
                  text: menuLabel.logout,
                  className: cn("ml-2 hidden md-v2:block", shouldShowMenuLabel && "block")
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: cn("relative flex h-8 items-center", isLightspeed && "md-v2:hidden"), children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Popover$1, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(PopoverTrigger, { className: "flex focus-visible:outline-none", "aria-label": "Profile", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(AccountIcon, { className: "h-4 w-4" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              NavItemText,
              {
                text: button.profile,
                bold: isOpen,
                className: cn("ml-2 hidden md-v2:block", shouldShowMenuLabel && "block")
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            PopoverContent,
            {
              id: createHeaderId("profile-menu"),
              align: "end",
              sideOffset: 12,
              className: cn(
                "absolute -right-2 top-full z-20 flex flex-col rounded-md bg-neutral-v2-0 text-base text-black shadow-md-v2 outline-none data-[state=closed]:slide-out-to-top-1 data-[state=open]:slide-in-from-top-1 md-v2:mt-1",
                shouldShowMenuLabel && "max-md-v2:-right-8 md-v2:-right-2",
                popoverContentClassName
              ),
              children: [
                !isLightspeed && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Link,
                  {
                    href: profileUrl,
                    onClick: setIsOpen.off,
                    className: "inline-block whitespace-nowrap p-4 focus-visible:outline-none",
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText, { text: menuLabel.manage, boldOnHover: true })
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Link,
                  {
                    href: logoutUrl || void 0,
                    onClick: handleLogout(setIsOpen.off),
                    className: "inline-block cursor-pointer whitespace-nowrap p-4 focus-visible:outline-none",
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText, { text: menuLabel.logout, boldOnHover: true })
                  }
                )
              ]
            }
          )
        ] }) })
      ] })
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "button",
    {
      type: "button",
      onClick: handleLogin,
      className: "flex h-8 items-center focus-visible:outline-none",
      "aria-label": "Login",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(AccountIcon, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText, { text: button.login, className: cn("ml-2 hidden md-v2:block", shouldShowMenuLabel && "block") })
      ]
    }
  );
};
const CartConfigContext = createContext(void 0);
function useCartConfig() {
  const returnContext = useContext(CartConfigContext);
  if (returnContext === void 0) throw Error("CartConfigContext is undefined");
  return returnContext;
}
const CartItem = ({ description, primaryCta, secondaryCta, itemConfig, perMonthText }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col space-y-4 text-wrap", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "ty-footnote max-md-v2:leading-5.5", children: description }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex items-center gap-2", children: [
    itemConfig.itemIcon && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: itemConfig.itemIcon.src, alt: itemConfig.itemIcon.alt, className: "aspect-square w-12 shrink-0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex w-full flex-col gap-1", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "ty-footnote-strong md-v2:leading-5", children: itemConfig.title }),
      itemConfig.subDescriptionWithSingleAddOns && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "flex items-center gap-1 text-neutral-v2-60 ty-caption", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "+ " }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            className: "h-4 w-4 shrink-0 rounded-full border border-neutral-v2-10",
            src: itemConfig.subDescriptionWithSingleAddOns.icon.src,
            alt: itemConfig.subDescriptionWithSingleAddOns.icon.alt
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: itemConfig.subDescriptionWithSingleAddOns.text })
      ] }),
      itemConfig.subDescriptionWithMoreAddOns && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "text-wrap text-neutral-v2-60 ty-caption", children: itemConfig.subDescriptionWithMoreAddOns.text }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-1 flex flex-wrap items-center", children: itemConfig.subDescriptionWithMoreAddOns.icons.map((icon, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          "img",
          {
            className: cn("h-4 w-4 shrink-0 rounded-full border border-neutral-v2-10", index > 0 && "-ml-0.5"),
            src: icon.src,
            alt: icon.alt
          },
          icon.alt
        )) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "mt-1 flex flex-wrap gap-1", children: itemConfig.badge && /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Badge$1,
        {
          className: "flex w-fit shrink-0 gap-1 rounded-sm border border-neutral-v2-10 bg-neutral-v2-100",
          style: { background: itemConfig.badge.bgColor ?? void 0 },
          children: [
            itemConfig.badge.icon && /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: itemConfig.badge.icon.src, alt: itemConfig.badge.icon.alt, className: "h-4 w-4" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              HtmlText,
              {
                className: "text-neutral-v2-10 ty-footnote-strong max-md-v2:leading-5.5",
                text: itemConfig.badge.label
              }
            )
          ]
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mt-1 flex items-center gap-1", children: [
        itemConfig.displayPrice && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "ty-footnote-strong md-v2:leading-5", children: `${itemConfig.displayPrice}${perMonthText}` }),
        itemConfig.originalPrice && /* @__PURE__ */ jsxRuntimeExports.jsx("s", { className: "text-neutral-v2-60 ty-caption", children: `${formatAsPrice(itemConfig.originalPrice)}${perMonthText}` })
      ] })
    ] })
  ] }),
  itemConfig.bannerImage && /* @__PURE__ */ jsxRuntimeExports.jsx(
    "img",
    {
      src: itemConfig.bannerImage.src,
      alt: itemConfig.bannerImage.alt,
      className: "mt-4 aspect-video w-full rounded-sm"
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col space-y-2", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { asChild: true, size: "small", className: "focus-visible:outline-none", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Link,
      {
        href: primaryCta.url,
        forwardUtm: true,
        onClick: () => triggerEvent({
          content_list_type: window.location.pathname,
          content_category: "Expand Cart",
          content_title: "Checkout"
        }),
        children: primaryCta.name
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button$1, { asChild: true, size: "small", variant: "secondary", className: "focus-visible:outline-none", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Link,
      {
        href: secondaryCta.url,
        forwardUtm: true,
        onClick: () => triggerEvent({
          content_list_type: window.location.pathname,
          content_category: "Expand Cart",
          content_title: "Edit Selection"
        }),
        children: secondaryCta.name
      }
    ) })
  ] })
] });
const CartLoading = ({ onCloseButtonClick }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex justify-between", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-4 w-[60px] rounded-sm" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "focus-visible:outline-none", onClick: onCloseButtonClick, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CrossIcon, { className: "h-4 w-4", pathProps: { fill: "black" } }) })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col space-y-4", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "mt-1 h-4 w-[248px] rounded-sm" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "space-y-1", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-4 w-[200px] rounded-sm" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-4 w-[150px] rounded-sm" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-4 w-[120px] rounded-sm" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "aspect-video h-[174px] w-full" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col space-y-2", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-9 w-full rounded-sm" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingSkeleton, { className: "h-9 w-full rounded-sm" })
    ] })
  ] })
] });
const EmptyCart = ({ primaryCta, description }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col justify-center", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(CartIcon, { className: "mx-auto mb-2 h-12 w-12" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mb-4 text-center", children: description }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button$1,
    {
      asChild: true,
      size: "small",
      className: "mx-auto w-fit focus-visible:outline-none",
      onClick: () => {
        triggerEvent({
          content_list_type: window.location.pathname,
          content_category: "Expand Cart",
          content_title: "Explore packs"
        });
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { ...primaryCta, href: primaryCta.url, forwardUtm: true, children: primaryCta.name })
    }
  )
] });
const Cart = ({ shouldShowMenuLabel, popoverContentClassName }) => {
  const [isOpen, setIsOpen] = useBoolean(false);
  const { cartConfig, handleCartClick, selectedItem, isEmptyCart, isLoading, customCart } = useCartConfig();
  useEffect(() => {
    var _a;
    if (isOpen && !isLoading) {
      if (!customCart) {
        triggerEvent({
          event: "popupEvent",
          content_list_type: window.location.pathname,
          content_category: "Expand Cart",
          content_title: isEmptyCart ? "Empty" : "Valid"
        });
      } else {
        (_a = customCart.cartPopupGtmEvent) == null ? void 0 : _a.call(customCart);
      }
    }
  }, [customCart, isEmptyCart, isLoading, isOpen]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "relative flex h-8 items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Popover$1,
    {
      onOpenChange: () => {
        handleCartClick(setIsOpen.toggle);
      },
      open: isOpen,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          PopoverTrigger,
          {
            onClick: () => {
              if (!isOpen) {
                triggerEvent({
                  content_list_type: window.location.pathname,
                  content_category: "Header Menu",
                  content_title: `Saved Cart ${isEmptyCart ? "(empty)" : "(valid)"}`
                });
              }
            },
            className: "flex items-center focus-visible:outline-none",
            "aria-label": "Cart",
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative flex h-5 w-5 items-center justify-center", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(CartIcon, { className: "h-5 w-5" }),
                !isEmptyCart && selectedItem && (selectedItem == null ? void 0 : selectedItem.itemConfig.numberOfItems) !== 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "span",
                  {
                    className: cn(
                      "absolute -right-0.5 -top-0.5 flex h-3 w-3 items-center justify-center rounded-full text-[9px]",
                      shouldShowMenuLabel ? "bg-magenta-v2-60 text-neutral-v2-0" : "bg-neutral-v2-0 text-magenta-v2-60"
                    ),
                    children: selectedItem.itemConfig.numberOfItems
                  }
                )
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                NavItemText,
                {
                  text: cartConfig.label,
                  bold: isOpen,
                  className: cn("ml-2 hidden", shouldShowMenuLabel && "block")
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          PopoverContent,
          {
            id: createHeaderId("abandoned-cart"),
            align: "end",
            sideOffset: 10,
            avoidCollisions: true,
            className: cn(
              "top-full w-[328px] overflow-hidden rounded-md bg-neutral-v2-0 p-4 shadow-md-v2 outline-none transition-all duration-300 data-[state=closed]:slide-out-to-top-1 data-[state=open]:slide-in-from-top-1 max-md-v2:mx-4 md-v2:absolute",
              shouldShowMenuLabel ? "md-v2:-right-32" : "md-v2:-right-10",
              popoverContentClassName || "z-20"
            ),
            children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: customCart ? customCart.cartContent(setIsOpen.off, isOpen) : isLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(CartLoading, { onCloseButtonClick: setIsOpen.off }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex justify-between", children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "ty-heading5", children: [
                  cartConfig.title,
                  selectedItem && (selectedItem == null ? void 0 : selectedItem.itemConfig.numberOfItems) !== 0 && ` (${selectedItem.itemConfig.numberOfItems})`
                ] }),
                /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", className: "focus-visible:outline-none", onClick: setIsOpen.off, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CrossIcon, { className: "h-4 w-4", pathProps: { fill: "black" } }) })
              ] }),
              selectedItem ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                CartItem,
                {
                  ...selectedItem,
                  description: cartConfig.cartItemViewConfig.description,
                  perMonthText: cartConfig.cartItemViewConfig.perMonthText
                }
              ) : /* @__PURE__ */ jsxRuntimeExports.jsx(EmptyCart, { ...cartConfig.emptyCartConfig })
            ] }) })
          }
        )
      ]
    }
  ) });
};
const LanguageSwitcher = ({
  onChange,
  options,
  shouldShowMenuLabel,
  gtmType,
  popoverContentClassName
}) => {
  const locale = useLocale();
  const [isOpen, setIsOpen] = useBoolean(false);
  const selectedOption = options.find((option) => option.locale === locale) ?? {
    locale,
    name: "",
    shortName: locale.toUpperCase()
  };
  const handleChange = (option) => () => {
    const updatedLocale = toggleLocale(option.locale);
    if (updatedLocale !== null) onChange == null ? void 0 : onChange(updatedLocale);
    setIsOpen.off();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "relative flex h-8 items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Popover$1, { onOpenChange: setIsOpen.toggle, open: isOpen, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      PopoverTrigger,
      {
        onClick: () => createNavEvent(isOpen ? "Close Language" : "Language", gtmType)(),
        className: "flex items-center focus-visible:outline-none",
        "aria-label": "Language",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(LanguageIcon, { className: "h-4 w-4" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            NavItemText,
            {
              text: selectedOption.shortName,
              bold: isOpen,
              className: cn("ml-2 hidden", shouldShowMenuLabel && "block")
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PopoverContent,
      {
        id: createHeaderId("language-switcher"),
        align: "end",
        sideOffset: 12,
        avoidCollisions: true,
        className: cn(
          "top-full w-52 overflow-hidden rounded-md bg-neutral-v2-0 shadow-md-v2 outline-none data-[state=closed]:slide-out-to-top-1 data-[state=open]:slide-in-from-top-1 md-v2:absolute",
          shouldShowMenuLabel ? "-right-24" : "absolute -right-10",
          popoverContentClassName || "z-20"
        ),
        children: options.map((option) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "button",
          {
            type: "button",
            className: cn(
              "flex cursor-pointer items-center justify-between p-4 text-neutral-v2-100 hover:font-bold hover:tracking-normal hover:[text-shadow:0px_0px_currentcolor] focus-visible:outline-none",
              selectedOption.locale === option.locale && "bg-neutral-v2-5"
            ),
            onClick: handleChange(option),
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                NavItemText,
                {
                  text: option.name,
                  bold: selectedOption.locale === option.locale,
                  className: cn(
                    "inline-block whitespace-nowrap ty-body",
                    selectedOption.locale === option.locale && "ty-heading5"
                  )
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "div",
                {
                  className: cn(
                    "invisible flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-blue-v2-60",
                    selectedOption.locale === option.locale && "visible"
                  ),
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(TickIcon, { className: "h-4 w-4 text-neutral-v2-0" })
                }
              )
            ]
          },
          option.locale
        ))
      }
    )
  ] }) });
};
const Search = ({ button, form: formProps, gtmType }) => {
  const [isOpen, setIsOpen] = useBoolean(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Popover$1, { onOpenChange: setIsOpen.toggle, open: isOpen, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      PopoverTrigger,
      {
        className: "flex items-center focus-visible:outline-none",
        onClick: createNavEvent(isOpen ? "Close Search" : "Search", gtmType),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(SearchIcon, { className: "h-4 w-4" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(NavItemText, { text: button, bold: isOpen, className: "ml-2 hidden md-v2:block" })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PopoverContent,
      {
        className: "z-20 -ml-18 shadow-lg data-[state=closed]:slide-out-to-top-1 data-[state=open]:slide-in-from-top-1",
        sideOffset: 16,
        align: "start",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchBar, { gtmType, ...formProps, className: "w-[352px]" })
      }
    )
  ] });
};
const UtilityNav = ({
  account,
  className,
  hideLanguageSwitcher: hideLanguageByPortal,
  languageOptions,
  hideLanguageRegex,
  onLocaleChange,
  onLogin,
  onLogout,
  search,
  shouldOverrideLogout,
  hideSearch,
  shouldShowMenuLabel,
  gtmType,
  popoverContentClassName,
  showCart
}) => {
  const [hideLanguageFromDf, setHideLanguageFromDf] = useState(false);
  useEffect(() => {
    if (hideLanguageRegex) {
      setHideLanguageFromDf(hideLanguageRegex.findIndex((regex) => RegExp(regex, "i").test(window.location.href)) >= 0);
    }
  }, [hideLanguageRegex]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "nav",
    {
      id: createHeaderId("utilities"),
      className: cn("flex items-center space-x-6 text-neutral-v2-0 ty-caption", className),
      children: [
        !hideSearch && /* @__PURE__ */ jsxRuntimeExports.jsx(Search, { gtmType, ...search }),
        !hideLanguageByPortal && !hideLanguageFromDf && /* @__PURE__ */ jsxRuntimeExports.jsx(
          LanguageSwitcher,
          {
            options: languageOptions,
            onChange: onLocaleChange,
            shouldShowMenuLabel,
            gtmType,
            popoverContentClassName
          }
        ),
        showCart && /* @__PURE__ */ jsxRuntimeExports.jsx(Cart, { shouldShowMenuLabel, popoverContentClassName }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Account,
          {
            ...account,
            shouldOverrideLogout,
            onLogin,
            onLogout,
            shouldShowMenuLabel,
            gtmType,
            popoverContentClassName
          }
        )
      ]
    }
  );
};
const MegaMenuModal = ({
  universalNavConfig,
  utilityNavProps,
  megaMenuConfig,
  isOpen,
  closeMegaMenu,
  onLinkClick
}) => {
  const isMobile = useBreakpoint("md-v2", "down");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: cn(
        "pointer-events-auto fixed top-0 z-30 h-full w-full bg-neutral-v2-70 p-0 transition-all md-v2:p-5",
        isOpen ? "visible opacity-100 duration-150" : "invisible opacity-0 delay-300 duration-300"
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "relative h-full w-full md-v2:rounded-md", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: cn(
            "absolute right-0 top-0 bg-neutral-v2-0 text-neutral-v2-100 transition-all max-md-v2:w-full md-v2:rounded-md",
            isOpen ? "h-full w-full delay-100 duration-300 ease-in" : "h-0 rounded-bl-md delay-100 duration-300 md-v2:w-0"
          ),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            ScrollArea,
            {
              className: cn(
                "acm_overflow_modal_wrapper overflow-y-auto text-neutral-v2-100 max-md-v2:px-4 max-md-v2:pt-4 md-v2:rounded-md md-v2:p-3 md-v2:pb-0",
                isOpen && "h-full"
              ),
              scrollbarThumbClassName: "bg-neutral-v2-50 -z-10",
              children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                "div",
                {
                  className: cn(
                    isOpen ? "visible opacity-100 [transition:opacity_0.4s_0.4s,visibility_0.4s_0.3s]" : "invisible opacity-0 [transition:opacity_0.4s,visibility_0.4s_0.4s]"
                  ),
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "sticky top-0 z-20 flex w-full shrink-0 gap-2 md-v2:gap-3", children: [
                      isMobile ? (
                        // Mobile Utility Nav
                        /* @__PURE__ */ jsxRuntimeExports.jsx(
                          UtilityNav,
                          {
                            ...utilityNavProps,
                            shouldShowMenuLabel: true,
                            hideSearch: true,
                            gtmType: "mega",
                            popoverContentClassName: isOpen ? "z-40 shadow-xl-v2" : "hidden",
                            className: "flex h-10 flex-grow justify-center rounded-md bg-neutral-v2-100 shadow-md-v2 md-v2:hidden"
                          }
                        )
                      ) : (
                        /* Desktop Universal + Utility Nav  */
                        /* @__PURE__ */ jsxRuntimeExports.jsx(
                          UniversalNav,
                          {
                            className: "h-10 flex-grow rounded-md px-8 shadow-md-v2 max-md-v2:hidden",
                            crossPromoClassname: "z-40",
                            ...universalNavConfig,
                            gtmType: "mega",
                            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                              UtilityNav,
                              {
                                ...utilityNavProps,
                                shouldShowMenuLabel: true,
                                hideSearch: true,
                                gtmType: "mega",
                                popoverContentClassName: isOpen ? "z-40 shadow-xl-v2" : "hidden",
                                className: "flex h-10 flex-grow justify-end rounded-md bg-neutral-v2-100 shadow-md-v2"
                              }
                            )
                          }
                        )
                      ),
                      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "h-10 w-14 md-v2:w-18" })
                    ] }),
                    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "grid grid-cols-4 gap-4 md-v2:container-v2 max-md-v2:px-4 md-v2:my-10 md-v2:grid-cols-12", children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "col-span-4 mb-6 max-md-v2:mt-10 md-v2:col-start-5", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchBar, { gtmType: "mega", ...utilityNavProps.search.form }) }),
                      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "col-span-full grid grid-cols-subgrid gap-y-10 pb-12 md-v2:col-span-8 md-v2:col-start-3 md-v2:pb-3", children: [
                        megaMenuConfig.items.map((item) => {
                          var _a;
                          return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "col-span-full flex flex-col gap-2 md-v2:col-span-2", children: [
                            /* @__PURE__ */ jsxRuntimeExports.jsx(
                              Link,
                              {
                                className: "mb-2 w-fit cursor-pointer ty-heading5 focus-visible:outline-none",
                                newTab: item.newTab,
                                href: item.url,
                                forwardUtm: true,
                                onClick: (e) => {
                                  createNavEvent(item.name, "mega")();
                                  onLinkClick == null ? void 0 : onLinkClick(e, item, closeMegaMenu);
                                },
                                children: /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { text: item.name })
                              }
                            ),
                            (_a = item.links) == null ? void 0 : _a.map((subItem) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                              Link,
                              {
                                href: subItem.url,
                                className: "w-fit cursor-pointer focus-visible:outline-none max-md-v2:ty-footnote",
                                newTab: subItem.newTab,
                                forwardUtm: true,
                                onClick: (e) => {
                                  createNavEvent(subItem.name, "mega")();
                                  onLinkClick == null ? void 0 : onLinkClick(e, subItem, closeMegaMenu);
                                },
                                children: /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { text: subItem.name })
                              },
                              subItem.name
                            ))
                          ] }, item.name);
                        }),
                        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "col-span-full cursor-pointer md-v2:col-span-2", children: [
                          megaMenuConfig.contacts && /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlText, { className: "mb-2 w-fit ty-heading5", text: megaMenuConfig.contacts.headingHtml }),
                          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex w-full gap-4", children: megaMenuConfig.contacts.socials.map((social) => /* @__PURE__ */ jsxRuntimeExports.jsx(
                            Link,
                            {
                              href: social.url,
                              newTab: social.newTab,
                              onClick: () => createSocialEvent(social.name)(),
                              className: "focus-visible:outline-none",
                              children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: social.src, alt: social.name, width: 24, height: 24, className: "h-6 w-6" })
                            },
                            social.name
                          )) })
                        ] })
                      ] }),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        UniversalNav,
                        {
                          className: "absolute bottom-0 left-0 w-full md-v2:hidden",
                          gtmType: "mega",
                          crossPromoClassname: "z-40",
                          ...universalNavConfig
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          )
        }
      ) })
    }
  );
};
function useModalBannerConfig(endpoint, portalRegexMap) {
  const { authenticated } = useAuth();
  const { data } = useAsync({
    endpoint,
    formatResponse: (response) => {
      const now = Date.now();
      const modalBanner = response.find(
        (modalBannerResponse) => now >= new Date(modalBannerResponse.startTime).getTime() && now < new Date(modalBannerResponse.endTime).getTime()
      );
      if (!modalBanner) return null;
      const visibleRegexes = modalBanner.visibility.map((portal) => portalRegexMap[portal]);
      const isVisible = visibleRegexes.some((regex) => window.location.href.match(new RegExp(regex, "i")));
      if (!isVisible) return null;
      if (!modalBanner.userSegment.length) return null;
      const loggedIn = Boolean(modalBanner.userSegment.find((user) => user === "loggedIn"));
      const nonLoggedIn = Boolean(modalBanner.userSegment.find((user) => user === "nonLoggedIn"));
      if (!loggedIn && !nonLoggedIn) return null;
      if (loggedIn && !nonLoggedIn && !authenticated) return null;
      if (!loggedIn && nonLoggedIn && authenticated) return null;
      return {
        dismissDuration: modalBanner.cookiesExpiry,
        mobileImage: {
          name: modalBanner.mobileImage.altText,
          url: modalBanner.url,
          src: modalBanner.mobileImage.image
        },
        desktopImage: {
          name: modalBanner.desktopImage.altText,
          url: modalBanner.url,
          src: modalBanner.desktopImage.image
        }
      };
    },
    fetchCondition: () => {
      const hasDismissedBanner = getCookie(MODAL_BANNER_DISMISSED_COOKIE) === "1";
      return !hasDismissedBanner;
    }
  });
  return data ?? null;
}
const ModalBanner = ({ endpoint, portalRegexMap }) => {
  const config = useModalBannerConfig(endpoint, portalRegexMap);
  const [showModal, setShowModal] = useBoolean();
  useEffect(() => {
    if (config) setShowModal.on();
  }, [config, setShowModal]);
  if (!config) return null;
  const { dismissDuration, desktopImage, mobileImage } = config;
  const handleClose = () => {
    setShowModal.off();
    setCookie(MODAL_BANNER_DISMISSED_COOKIE, "1", dismissDuration, false, getCookieDomain(window.location.href));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Modal,
    {
      open: showModal,
      id: createHeaderId("modal-banner"),
      panelClassName: "h-[480px] max-h-screen w-80 max-w-full overscroll-contain rounded lg:h-[1200px] lg:w-[800px]",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(CloseButton, { className: "absolute right-4 top-4", onClick: handleClose }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: mobileImage.url, id: createHeaderId("modal-banner", "mobile"), className: "block lg:hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: mobileImage.src, alt: mobileImage.name, className: "rounded", loading: "lazy" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: desktopImage.url, id: createHeaderId("modal-banner", "desktop"), className: "hidden lg:block", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: desktopImage.src, alt: desktopImage.name, className: "rounded", loading: "lazy" }) })
      ]
    }
  );
};
const shopServiceApiBaseUrl = {
  production: "https://shop-api.eco.astro.com.my/api",
  staging: "https://shop-api-stg.eco.astro.com.my/api",
  development: "https://shop-api-dev.eco.astro.com.my/api"
};
const cassandraServiceApiBaseUrl = {
  production: "https://cassandra-api.eco.astro.com.my",
  staging: "https://cassandra-api-stg.eco.astro.com.my",
  development: "https://cassandra-api-dev.eco.astro.com.my"
};
const shopDomain = {
  production: "https://shop.astro.com.my",
  staging: "https://shop-cassandra-stg.pink.cat",
  development: "https://shop-cassandra-dev.pink.cat"
};
const presetEndpoints$1 = {
  abandonedLead: {
    production: `${shopServiceApiBaseUrl.production}/v2/fetch-abandoned-lead`,
    staging: `${shopServiceApiBaseUrl.staging}/v2/fetch-abandoned-lead`,
    development: `${shopServiceApiBaseUrl.development}/v2/fetch-abandoned-lead`
  },
  orderSummary: {
    production: `${cassandraServiceApiBaseUrl.production}/cassandra/api/v3/gf/order-summary`,
    staging: `${cassandraServiceApiBaseUrl.staging}/cassandra/api/v3/gf/order-summary`,
    development: `${cassandraServiceApiBaseUrl.development}/cassandra/api/v3/gf/order-summary`
  },
  packConfig: {
    production: `${cassandraServiceApiBaseUrl.production}/cassandra/api/v2/gf/pack/configuration`,
    staging: `${cassandraServiceApiBaseUrl.staging}/cassandra/api/v2/gf/pack/configuration`,
    development: `${cassandraServiceApiBaseUrl.development}/cassandra/api/v2/gf/pack/configuration`
  },
  broadbandConfig: {
    production: `${cassandraServiceApiBaseUrl.production}/cassandra/api/v3/broadband`,
    staging: `${cassandraServiceApiBaseUrl.staging}/cassandra/api/v3/broadband`,
    development: `${cassandraServiceApiBaseUrl.development}/cassandra/api/v3/broadband`
  },
  dynamicFlow: {
    production: `${cassandraServiceApiBaseUrl.production}/cassandra/api/v1/get-dynamic-signup-form`,
    staging: `${cassandraServiceApiBaseUrl.staging}/cassandra/api/v1/get-dynamic-signup-form`,
    development: `${cassandraServiceApiBaseUrl.development}/cassandra/api/v1/get-dynamic-signup-form`
  }
};
const createCartItemConfig = (cartConfig, leadCartSelection, environment, orderSummaryResponse, dynamicSlug, packConfigResponse, broadbandConfigResponse, customCartCtaLabel) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const overallInvoice = orderSummaryResponse.invoice.find((section) => section.id === "overall");
  const montlyFeeInvoice = orderSummaryResponse.invoice.find((section) => section.id === "monthlyFee");
  const monthlyFeePack = (_b = (_a = montlyFeeInvoice == null ? void 0 : montlyFeeInvoice.sections.find((section) => section.id === "tvPack")) == null ? void 0 : _a.items) == null ? void 0 : _b[0];
  const montlyFeeBroadband = (_d = (_c = montlyFeeInvoice == null ? void 0 : montlyFeeInvoice.sections.find((section) => section.id === "broadband")) == null ? void 0 : _c.items) == null ? void 0 : _d[0];
  const totalPriceWithoutTax = (_e = overallInvoice == null ? void 0 : overallInvoice.sections.find(
    (section) => section.id === "totalWithoutTax"
  )) == null ? void 0 : _e.displayPrice;
  const { selectedPackId, items: packItemsList } = orderSummaryResponse.pack;
  const { selectedAddOnId, items: addOnsList } = orderSummaryResponse.addOn;
  const isSelectedPackVisible = packItemsList.find((pack) => pack.id === selectedPackId && pack.visibility);
  const selectedPackConfig = selectedPackId && isSelectedPackVisible ? packConfigResponse == null ? void 0 : packConfigResponse.find((pack) => pack.packId === selectedPackId) : void 0;
  const { mesh, id: selectedBroadbandId } = orderSummaryResponse.broadband;
  const selectedBroadbandConfig = selectedBroadbandId ? broadbandConfigResponse == null ? void 0 : broadbandConfigResponse.broadbandDetails.speedDetails.find((speed) => speed.id === selectedBroadbandId) : void 0;
  const visibleAddOnsIds = new Set(
    addOnsList.filter((addOn) => selectedAddOnId.includes(addOn.id) && !!addOn.visibility).map((addOn) => addOn.id)
  );
  const extractAddOnConfig = ({ iconUrl, name, id }) => ({
    iconUrl,
    name,
    id
  });
  const filterVisibleAddOn = (addOnList) => addOnList.items.filter(
    (item) => {
      var _a2;
      return visibleAddOnsIds.has(item.id) || "plans" in item && ((_a2 = item.plans) == null ? void 0 : _a2.some((plan) => visibleAddOnsIds.has(plan.id)));
    }
  ).map(extractAddOnConfig);
  const visibleAddOnsConfig = selectedPackConfig && [
    ...filterVisibleAddOn(selectedPackConfig == null ? void 0 : selectedPackConfig.gfDetails.addOnSection),
    ...filterVisibleAddOn(selectedPackConfig == null ? void 0 : selectedPackConfig.gfDetails.appSection)
  ];
  const numberOfVisibleAddOns = (visibleAddOnsConfig == null ? void 0 : visibleAddOnsConfig.length) || 0;
  const { isAstroFibre } = leadCartSelection.orderSummaryRequest;
  const isPackOnly = selectedPackId && isSelectedPackVisible && !selectedBroadbandId && numberOfVisibleAddOns === 0;
  const isBroadbandOnly = !selectedPackConfig && selectedBroadbandId && Object.keys(mesh).length === 0;
  const selectedItemTitle = isAstroFibre ? `${selectedBroadbandConfig == null ? void 0 : selectedBroadbandConfig.name}${selectedPackConfig ? ` + ${selectedPackConfig.name}` : ""}` : selectedPackConfig == null ? void 0 : selectedPackConfig.name;
  const badge = isAstroFibre ? (_f = selectedBroadbandConfig == null ? void 0 : selectedBroadbandConfig.badges) == null ? void 0 : _f[0] : (_h = (_g = selectedPackConfig == null ? void 0 : selectedPackConfig.gfDetails) == null ? void 0 : _g.badges) == null ? void 0 : _h[0];
  const badgeConfig = badge && {
    label: badge.text,
    icon: badge.iconUrl ? {
      src: badge.iconUrl,
      alt: ""
    } : void 0,
    bgColor: badge.badgeGradientStartColour && badge.badgeGradientEndColour ? `linear-gradient(140.08deg, ${badge.badgeGradientStartColour} 0%, ${badge.badgeGradientEndColour} 100%)` : void 0
  };
  const fibreItemIcon = isAstroFibre && (selectedBroadbandConfig == null ? void 0 : selectedBroadbandConfig.icon) && {
    src: selectedBroadbandConfig == null ? void 0 : selectedBroadbandConfig.icon,
    alt: ""
  };
  const packBanner = !isAstroFibre && ((_i = selectedPackConfig == null ? void 0 : selectedPackConfig.fallbackImages) == null ? void 0 : _i[0].type) === "image" && {
    src: selectedPackConfig == null ? void 0 : selectedPackConfig.fallbackImages[0].url,
    alt: selectedPackConfig == null ? void 0 : selectedPackConfig.fallbackImages[0].altText
  };
  const numberOfItems = isAstroFibre ? Number(!!selectedBroadbandConfig) + Number(!!selectedPackConfig) : Number(!!selectedPackConfig);
  const subDescriptionWithSingleAddOns = isAstroFibre && mesh.name && broadbandConfigResponse && {
    icon: {
      src: broadbandConfigResponse.meshDetails.icon,
      alt: ""
    },
    text: mesh.name
  };
  const subDescriptionWithMoreAddOns = !isAstroFibre && visibleAddOnsConfig && numberOfVisibleAddOns > 0 && {
    text: interpolate(
      numberOfVisibleAddOns === 1 ? cartConfig.numberOfSingleAddOn : cartConfig.numberOfMultipleAddOns,
      { numberOfVisibleAddOns }
    ),
    icons: visibleAddOnsConfig.map((addOn) => ({
      src: addOn.iconUrl,
      alt: addOn.name
    }))
  };
  const displayPrice = isPackOnly ? monthlyFeePack == null ? void 0 : monthlyFeePack.displayPrice : isBroadbandOnly ? montlyFeeBroadband == null ? void 0 : montlyFeeBroadband.displayPrice : totalPriceWithoutTax;
  const originalPrice = isPackOnly ? monthlyFeePack == null ? void 0 : monthlyFeePack.originalPrice : isBroadbandOnly ? montlyFeeBroadband == null ? void 0 : montlyFeeBroadband.originalPrice : void 0;
  const selectedPackSlug = selectedPackConfig == null ? void 0 : selectedPackConfig.slug;
  const shopUrl = shopDomain[environment];
  const dynamicBaseUrl = dynamicSlug ? (_j = dynamicSlug[isAstroFibre ? "fibre" : "tv"].find((dInfo) => dInfo.packId === selectedPackId)) == null ? void 0 : _j.slug : null;
  const baseUrl = isAstroFibre ? `${shopUrl}/${dynamicBaseUrl || "fibre"}/build` : `${shopUrl}/${dynamicBaseUrl || selectedPackSlug}/build`;
  const selectedItem = {
    itemConfig: {
      title: selectedItemTitle,
      displayPrice,
      originalPrice,
      badge: badgeConfig,
      bannerImage: packBanner || void 0,
      itemIcon: fibreItemIcon || void 0,
      numberOfItems,
      subDescriptionWithSingleAddOns: subDescriptionWithSingleAddOns || void 0,
      subDescriptionWithMoreAddOns: subDescriptionWithMoreAddOns || void 0
    },
    primaryCta: {
      name: (customCartCtaLabel == null ? void 0 : customCartCtaLabel.primaryCta) || cartConfig.primaryCtaLabel,
      url: `${baseUrl}?sign-up=true&cart=true`
    },
    secondaryCta: {
      name: (customCartCtaLabel == null ? void 0 : customCartCtaLabel.secondaryCta) || cartConfig.secondaryCtaLabel,
      url: `${baseUrl}?cart=true`
    }
  };
  return selectedItem;
};
class CustomError extends Error {
  constructor(response) {
    var _a;
    super();
    // Add here as per needed. https://blog.alexanderkaran.com/errors-in-typescript
    __publicField(this, "message");
    __publicField(this, "response");
    __publicField(this, "code");
    __publicField(this, "errorCode");
    Object.setPrototypeOf(this, new.target.prototype);
    this.message = response.responseMessage;
    this.response = getErrorResponse(response);
    this.code = response.responseCode;
    this.errorCode = ((_a = getErrorResponse(response)) == null ? void 0 : _a.errorCode) || "GENERIC_ERROR";
  }
}
function useFetchAbandonedLead(leadInfo, environment = "production", onSuccess, platform = "shop") {
  const { leadId, lastFourDigit } = leadInfo || {};
  const {
    data: leadCartSelection,
    error: cartError,
    isLoading: isCartLoading,
    mutate: refetchAbandonedCart
  } = useSWR(
    leadId && lastFourDigit ? {
      id: leadId,
      lastFourIdValue: lastFourDigit,
      url: `${presetEndpoints$1.abandonedLead[environment]}?platform=${platform}`
    } : void 0,
    ({ id, lastFourIdValue, url }) => fetcher(
      url,
      {
        method: "POST",
        body: JSON.stringify({
          leadId: id,
          lastFourIdValue
        })
      },
      (response) => {
        throw new CustomError(response);
      }
    ).then((res) => {
      onSuccess == null ? void 0 : onSuccess(res);
      return res;
    }),
    {
      errorRetryCount: 3,
      shouldRetryOnError: true,
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true
    }
  );
  return {
    leadCartSelection,
    error: cartError,
    isLoading: isCartLoading,
    refetchAbandonedCart
  };
}
function useFetchBroadbandConfig(language, selectedIsp, environment = "production", platform = "shop") {
  const { data: broadbandConfigResponse, isLoading } = useAsync({
    shouldAutoRevalidate: false,
    endpoint: `${presetEndpoints$1.broadbandConfig[environment]}?platform=${platform}&isp=${selectedIsp}&flow=gf&language=${language}`,
    formatResponse: (response) => response,
    method: "GET",
    fetchCondition: () => !!selectedIsp,
    options: {
      errorRetryCount: 3,
      shouldRetryOnError: true
    }
  });
  return {
    broadbandConfigResponse,
    isLoading
  };
}
function useFetchDynamicFlow(language, environment = "production", campaignId, platform = "shop") {
  const { data: dynamicFlowData, isLoading } = useAsync({
    shouldAutoRevalidate: false,
    endpoint: `${presetEndpoints$1.dynamicFlow[environment]}?platform=${platform}&language=${language}`,
    fetchCondition: () => Boolean(campaignId),
    formatResponse: (response) => response,
    method: "GET",
    options: {
      errorRetryCount: 3,
      shouldRetryOnError: true
    }
  });
  return {
    dynamicFlowData,
    isLoading
  };
}
function useFetchOrderSummary(orderSummaryRequest, type, environment = "production", platform = "shop") {
  const { data: orderSummaryResponse, isLoading } = useSWR(
    type && orderSummaryRequest ? {
      leadType: type,
      order: orderSummaryRequest,
      url: `${presetEndpoints$1.orderSummary[environment]}?platform=${platform}`
    } : void 0,
    ({ leadType, order, url }) => fetcher(url, {
      method: "POST",
      body: JSON.stringify({
        type: leadType,
        order
      })
    }),
    {
      errorRetryCount: 3,
      shouldRetryOnError: true,
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true
    }
  );
  return {
    orderSummaryResponse,
    isLoading
  };
}
function useFetchPackConfig(language, environment = "production", selectedPackId, platform = "shop") {
  const { data: packConfigResponse, isLoading } = useAsync({
    shouldAutoRevalidate: false,
    endpoint: `${presetEndpoints$1.packConfig[environment]}?platform=${platform}&language=${language}`,
    formatResponse: (response) => response,
    method: "GET",
    fetchCondition: () => !!selectedPackId,
    options: {
      errorRetryCount: 3,
      shouldRetryOnError: true
    }
  });
  return {
    packConfigResponse,
    isLoading
  };
}
function CartConfigContextProvider({
  children,
  environment,
  cartConfig,
  onCartLoaded,
  onCartClick,
  apiPlatform,
  customCartCtaLabel,
  closeMegaMenuFn,
  customCart,
  showCart = false
}) {
  var _a, _b, _c, _d;
  const [leadInfo, setLeadInfo] = useState(null);
  const locale = useLocale();
  const handleCartClick = useCallback(
    (toggleOpen) => {
      if (onCartClick) return onCartClick(toggleOpen, closeMegaMenuFn);
      toggleOpen();
    },
    [onCartClick, closeMegaMenuFn]
  );
  const formatValidOrderSummaryResponse = (orderSummaryRequest) => {
    if (!orderSummaryRequest.isAstroFibre && orderSummaryRequest.broadband && Object.keys(orderSummaryRequest.broadband).length > 0) {
      return {
        ...orderSummaryRequest,
        broadband: {}
      };
    }
    if (orderSummaryRequest && orderSummaryRequest.isAstroFibre && orderSummaryRequest.addOnId.length > 0) {
      return {
        ...orderSummaryRequest,
        addOnId: []
      };
    }
    return orderSummaryRequest;
  };
  const onAbandedCartSuccess = (res) => {
    const formatedOrderSummaryRequest = formatValidOrderSummaryResponse(res.orderSummaryRequest);
    const formatedResponse = {
      ...res,
      orderSummaryRequest: formatedOrderSummaryRequest
    };
    onCartLoaded == null ? void 0 : onCartLoaded(formatedResponse);
  };
  const {
    leadCartSelection,
    isLoading: isCartLoading,
    refetchAbandonedCart,
    error: cartError
  } = useFetchAbandonedLead(showCart ? leadInfo : null, environment, onAbandedCartSuccess, apiPlatform);
  const { orderSummaryResponse, isLoading: isOrderSummaryLoading } = useFetchOrderSummary(
    (leadCartSelection == null ? void 0 : leadCartSelection.orderSummaryRequest) && formatValidOrderSummaryResponse(leadCartSelection.orderSummaryRequest),
    leadCartSelection == null ? void 0 : leadCartSelection.type,
    environment,
    apiPlatform
  );
  const { broadbandConfigResponse, isLoading: isBroadbandConfigLoading } = useFetchBroadbandConfig(
    convertLocale$1(locale),
    (_b = (_a = leadCartSelection == null ? void 0 : leadCartSelection.orderSummaryRequest) == null ? void 0 : _a.broadband) == null ? void 0 : _b.isp,
    environment,
    apiPlatform
  );
  const { packConfigResponse, isLoading: isPackConfigLoading } = useFetchPackConfig(
    convertLocale$1(locale),
    environment,
    (_c = leadCartSelection == null ? void 0 : leadCartSelection.orderSummaryRequest) == null ? void 0 : _c.packId,
    apiPlatform
  );
  const campaignId = leadCartSelection == null ? void 0 : leadCartSelection.orderSummaryRequest.campaign;
  const { dynamicFlowData, isLoading: isLoadingDynamicSlug } = useFetchDynamicFlow(
    convertLocale$1(locale),
    environment,
    campaignId
  );
  const dynamicSlug = (_d = dynamicFlowData == null ? void 0 : dynamicFlowData.find((res) => res.formId === campaignId)) == null ? void 0 : _d.applicableFlows;
  useEffect(() => {
    if (cartError == null ? void 0 : cartError.errorCode) {
      resetCart();
    }
  }, [cartError]);
  useEffect(() => {
    const handleUpdateCart = (event) => {
      var _a2;
      const cartCookie = getCookie(ABANDONED_CART_COOKIE);
      const customEvent = event;
      if (cartCookie) {
        const { lastFourDigit, leadId } = JSON.parse(cartCookie);
        setLeadInfo({ lastFourDigit, leadId });
        if ((_a2 = customEvent == null ? void 0 : customEvent.detail) == null ? void 0 : _a2.shouldRefetchAbandonedCart) {
          refetchAbandonedCart();
        }
      } else {
        setLeadInfo(null);
      }
    };
    handleUpdateCart();
    window.addEventListener(UPDATE_CART_EVENT, handleUpdateCart);
    window.addEventListener("focus", handleUpdateCart);
    return () => {
      window.removeEventListener(UPDATE_CART_EVENT, handleUpdateCart);
      window.removeEventListener("focus", handleUpdateCart);
    };
  }, []);
  const selectedItem = leadCartSelection && orderSummaryResponse && createCartItemConfig(
    cartConfig.cartItemViewConfig,
    leadCartSelection,
    environment,
    orderSummaryResponse,
    dynamicSlug,
    packConfigResponse,
    broadbandConfigResponse,
    customCartCtaLabel
  );
  const isLoading = isCartLoading || isBroadbandConfigLoading || isPackConfigLoading || isOrderSummaryLoading || isLoadingDynamicSlug;
  const providerValue = useMemo(
    () => ({
      selectedItem,
      isLoading,
      cartConfig,
      handleCartClick,
      isEmptyCart: !leadCartSelection,
      customCart
    }),
    [selectedItem, isLoading, cartConfig, handleCartClick, leadCartSelection, customCart]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CartConfigContext.Provider, { value: providerValue, children });
}
const Header = ({
  centerMobileLogo,
  config,
  environment = "production",
  hideLanguageSwitcher,
  locale = DEFAULT_LOCALE,
  onAuth,
  onInit,
  onLocaleChange,
  onLogin,
  onLogout,
  onLinkClick,
  onLogoClick,
  shouldOverrideLogout,
  stickyOnScroll = false,
  bannerClassname,
  onBannerLoad,
  // This is for GA event Tracking (Current usecase: ACM Homepage)
  onMegaMenuExpand,
  apiPlatform = "shop",
  // Hide cart by default
  showCart = false,
  customCart,
  onCartLoaded,
  onCartClick,
  customCartCtaLabel
}) => {
  const utilityNavProps = {
    ...config.utility,
    hideLanguageSwitcher,
    shouldOverrideLogout,
    showCart,
    onLogin,
    onLogout,
    onLocaleChange
  };
  const isMobile = useBreakpoint("md-v2", "down");
  const [showMegaMenu, setShowMegaMenu] = useBoolean();
  const [showFullHeader, setShowFullHeader] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isBannerFullyShown, setIsBannerFullyShown] = useState(false);
  const [bannerConfigStatus, setBannerConfigStatus] = useState(null);
  const [bannerHeight, setBannerHeight] = useState(0);
  const { ref: headerRef, inView: isHeaderInView } = useInView({ rootMargin: "-1px 0px 0px 0px" });
  const handleBannerLoad = useCallback(
    (params) => {
      setBannerConfigStatus(params);
      onBannerLoad == null ? void 0 : onBannerLoad(params);
    },
    [onBannerLoad]
  );
  useEffect(() => {
    if ((bannerConfigStatus == null ? void 0 : bannerConfigStatus.data) && isBannerFullyShown) {
      const bannerEl = document.getElementById("acm-header__banner");
      setBannerHeight((bannerEl == null ? void 0 : bannerEl.clientHeight) || 0);
    }
  }, [bannerConfigStatus == null ? void 0 : bannerConfigStatus.data, isBannerFullyShown]);
  useEffect(() => {
    if (showMegaMenu) {
      const originalOverflow = document.body.style.overflow;
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      const bannerEl = document.getElementById("acm-header__banner");
      if (bannerEl) {
        bannerEl.style.paddingRight = `${scrollbarWidth}px`;
      }
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalOverflow;
        if (bannerEl) {
          bannerEl.style.paddingRight = "0px";
        }
      };
    }
    return void 0;
  }, [showMegaMenu]);
  useEffect(() => {
    setIsInitialLoad(false);
  }, []);
  useEffect(() => {
    if (bannerConfigStatus == null ? void 0 : bannerConfigStatus.isLoading) {
      setIsBannerFullyShown(false);
    }
  }, [bannerConfigStatus == null ? void 0 : bannerConfigStatus.isLoading]);
  useEffect(() => {
    if (bannerConfigStatus && bannerConfigStatus.data) {
      const bannerEl = document.getElementById("acm-header__banner");
      const minimumBannerHeight = 20;
      if (bannerEl) {
        bannerEl == null ? void 0 : bannerEl.addEventListener("transitionend", () => {
          setIsBannerFullyShown(true);
        });
        if (bannerEl.clientHeight > minimumBannerHeight) {
          setIsBannerFullyShown(true);
        }
        return () => {
          bannerEl == null ? void 0 : bannerEl.removeEventListener("transitionend", () => {
            setIsBannerFullyShown(true);
          });
        };
      }
    }
  }, [bannerConfigStatus]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AuthProvider, { ...config.auth, chatbotConfig: config.chatbot, onInit, onAuth, children: /* @__PURE__ */ jsxRuntimeExports.jsx(LocaleProvider, { locale, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    CartConfigContextProvider,
    {
      cartConfig: config.utility.cart,
      environment,
      onCartLoaded,
      onCartClick,
      apiPlatform,
      customCartCtaLabel,
      closeMegaMenuFn: setShowMegaMenu.off,
      customCart,
      showCart,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Banner,
          {
            ...config.banner,
            showMiniBanner: !isHeaderInView && !stickyOnScroll,
            bannerClassname,
            onBannerLoad: handleBannerLoad
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          StickyTrigger,
          {
            onSticky: (isSticky) => setShowFullHeader(!isSticky && stickyOnScroll),
            rootMargin: isMobile ? "20px 0px 0px 0px" : "30px 0px 0px 0px"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "header",
          {
            ref: headerRef,
            id: createHeaderId(),
            className: cn(
              stickyOnScroll ? "pointer-events-none sticky top-0 z-20" : "relative",
              showMegaMenu ? "z-30" : "[transition:top_0.4s,right_0.4s,transform_0.4s,translate_0.4s,border-radius_0.4s,width_0.4s,z-index_0.1s_0.6s]"
            ),
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "div",
              {
                className: cn(
                  "h-10 w-full text-white md-v2:h-18",
                  stickyOnScroll ? "absolute top-0 z-20" : "relative pb-10"
                ),
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "div",
                    {
                      className: cn(
                        "duration-500",
                        stickyOnScroll && "sticky",
                        stickyOnScroll && !isInitialLoad && (showFullHeader ? "translate-y-0 transition-all duration-200" : "sticky -translate-y-10 transition-all")
                      ),
                      children: !isMobile && /* @__PURE__ */ jsxRuntimeExports.jsx(
                        UniversalNav,
                        {
                          ...config.universal,
                          className: "pointer-events-auto *:first:container-v2 max-md-v2:hidden",
                          gtmType: "main",
                          children: /* @__PURE__ */ jsxRuntimeExports.jsx(UtilityNav, { gtmType: "main", ...utilityNavProps, shouldShowMenuLabel: true })
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    GlobalNav,
                    {
                      ...config.global,
                      centerMobileLogo,
                      onMenuClick: () => {
                        if (!showMegaMenu) {
                          onMegaMenuExpand ? onMegaMenuExpand() : triggerExpandMegaMenuEvent();
                        }
                        setShowMegaMenu.toggle();
                      },
                      onLinkClick,
                      onLogoClick: (e) => {
                        createNavEvent("Astro Logo", "main")();
                        onLogoClick == null ? void 0 : onLogoClick(e);
                      },
                      showFullHeader: showFullHeader || !stickyOnScroll,
                      showMegaMenu: showMegaMenu && (isMobile || stickyOnScroll),
                      isBannerFullyShown,
                      enableFloatingMenu: stickyOnScroll,
                      isInitialLoad,
                      closeMegaMenu: () => {
                        setShowMegaMenu.off();
                      },
                      bannerHeight,
                      children: isMobile && /* @__PURE__ */ jsxRuntimeExports.jsx(UtilityNav, { gtmType: "main", ...utilityNavProps, hideSearch: true })
                    }
                  ),
                  (isMobile || stickyOnScroll) && /* @__PURE__ */ jsxRuntimeExports.jsx(
                    MegaMenuModal,
                    {
                      utilityNavProps,
                      universalNavConfig: { ...config.universal },
                      megaMenuConfig: config.megaMenu,
                      isOpen: showMegaMenu,
                      onLinkClick,
                      closeMegaMenu: () => {
                        setShowMegaMenu.off();
                      }
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBanner, { endpoint: config.banner.modal.bcpV3Endpoint, portalRegexMap: config.banner.portalRegexMap })
      ]
    }
  ) }) });
};
const presetEndpoints = {
  acm: {
    production: "https://digital-fortress-assets.eco.astro.com.my/prod/config/K5OjDOxv2Z/config.json",
    staging: "https://digital-fortress-dev.eco.astro.com.my/dev/config/dpMB5pNylZ/config.json",
    development: "https://digital-fortress-dev.eco.astro.com.my/dev/config/dpMB5pNylZ/config.json"
  },
  myastro: {
    production: "https://digital-fortress-assets.eco.astro.com.my/prod/config/ZKpywDPB3M/config.json",
    staging: "https://digital-fortress-dev.eco.astro.com.my/dev/config/VZYyoAzvN5/config.json",
    development: "https://digital-fortress-dev.eco.astro.com.my/dev/config/VZYyoAzvN5/config.json"
  },
  store: {
    production: "https://digital-fortress-assets.eco.astro.com.my/prod/config/K5OjDOxv2Z/config.json",
    staging: "https://digital-fortress-dev.eco.astro.com.my/dev/config/dpMB5pNylZ/config.json",
    development: "https://digital-fortress-dev.eco.astro.com.my/dev/config/dpMB5pNylZ/config.json"
  }
};
const fallbackData = (portal) => ({
  header: {
    universal: {
      sites: [
        { name: "Consumer", url: "" },
        { name: "Business", url: "" },
        { name: "Corporate", url: "" },
        { name: "Advertising", url: "" }
      ],
      crossPromo: {
        endpoint: "",
        name: "Our Brands"
      }
    },
    global: {
      logo: portal === "acm" ? {
        src: "https://dj7fdt04hl8tv.cloudfront.net/acm/media/homepage-2024/logo_white.svg",
        name: "Astro",
        url: ""
      } : {
        src: "https://acm-assets.eco.astro.com.my/images/myastro/logo_transparent_bg_15082022.svg",
        name: "MyAstro",
        url: ""
      },
      items: portal === "acm" ? [
        { name: "Astro TV Packs", url: "" },
        { name: "Astro Fibre", url: "" },
        { name: "Products & Services", url: "" },
        { name: "Content Guide", url: "" },
        { name: "Promotions", url: "" },
        { name: "My Account", url: "" },
        { name: "Support", url: "" }
      ] : [
        { name: "Account", url: "" },
        { name: "Astro Store", url: "" },
        { name: "Content", url: "" },
        { name: "Rewards", url: "" },
        { name: "Support", url: "" }
      ]
    },
    megaMenu: {
      items: [
        {
          url: "",
          name: "Astro TV Packs"
        },
        {
          url: "",
          name: "Astro Fibre",
          links: [
            {
              name: "Astro Fibre Plans",
              url: ""
            },
            {
              name: "Astro Fibre App",
              url: ""
            },
            {
              name: "Mesh WiFi",
              url: ""
            }
          ]
        },
        {
          url: "",
          name: "Products & Services",
          links: [
            {
              name: "Connected Boxes",
              url: ""
            },
            {
              name: "Multiroom",
              url: ""
            },
            {
              name: "Astro GO",
              url: ""
            },
            {
              name: "Apps",
              url: ""
            }
          ]
        },
        {
          url: "",
          name: "Content Guide",
          regex: "",
          links: [
            {
              name: "All Content",
              url: ""
            },
            {
              name: "Channels",
              url: ""
            },
            {
              name: "Sports",
              url: ""
            },
            {
              name: "Movies",
              url: ""
            },
            {
              name: "TV Shows",
              url: ""
            },
            {
              name: "Kids",
              url: ""
            },
            {
              name: "Astro First",
              url: ""
            }
          ]
        },
        {
          name: "Promotions",
          url: "",
          newTab: false
        },
        {
          url: "",
          name: "My Account",
          links: [
            {
              name: "Manage Account",
              url: ""
            },
            {
              name: "Pay Bill",
              url: ""
            },
            {
              name: "Astro Rewards",
              url: ""
            },
            {
              name: "Astro Store",
              url: ""
            }
          ]
        },
        {
          name: "Support",
          url: ""
        }
      ],
      contacts: {
        headingHtml: "Social",
        socials: [
          {
            name: "WhatsApp",
            url: "https://api.whatsapp.com/send?phone=60395433838&text=Hi",
            src: "https://d3riyfoij6hyxp.cloudfront.net/acm/media/homepage-banners/new_homepage_mega_menu_whatsapp.svg",
            width: 16
          },
          {
            name: "Facebook",
            url: "https://www.facebook.com/Astro",
            src: "https://d3riyfoij6hyxp.cloudfront.net/acm/media/homepage-banners/new_homepage_mega_menu_facebook.svg",
            width: 9
          },
          {
            name: "X",
            url: "https://twitter.com/astroonline",
            src: "https://d3riyfoij6hyxp.cloudfront.net/acm/media/homepage-banners/new_homepage_mega_menu_x.svg",
            width: 20
          }
        ]
      }
    },
    utility: {
      languageOptions: [],
      account: {
        button: {
          login: "Login",
          profile: "Profile"
        },
        menuLabel: {
          manage: "",
          logout: ""
        }
      },
      search: {
        button: "Search",
        form: {
          endpoint: "",
          queryKey: "",
          placeholder: ""
        }
      },
      hideLanguageRegex: [],
      cart: {
        label: "Cart",
        title: "",
        emptyCartConfig: {
          description: "",
          primaryCta: {
            name: "",
            url: "",
            newTab: false
          }
        },
        cartItemViewConfig: {
          description: "",
          primaryCtaLabel: "",
          secondaryCtaLabel: "",
          numberOfMultipleAddOns: "",
          numberOfSingleAddOn: "",
          perMonthText: ""
        }
      }
    },
    auth: {
      loginUrlParams: {
        endpoint: "",
        queryParams: {}
      },
      profileUrl: {
        default: "",
        uxf: ""
      },
      session: {
        endpoints: {
          refresh: "",
          getUser: ""
        },
        client: "",
        payload: "",
        startSessionExpiry: 1440,
        refreshSessionExpiry: 10080
      },
      whitelistedUxfDomains: []
    },
    banner: {
      endpoint: "",
      bcpV3Endpoint: "",
      portalRegexMap: {
        homepage: "astro\\.com\\.my\\/?(bm)?(\\?.*?)?$",
        fibre: "astro\\.com\\.my\\/fibre",
        shop: "shop\\.astro\\.com\\.my",
        product: "products?\\.astro\\.com\\.my",
        support: "support\\.astro\\.com\\.my",
        promotions: "promotions\\.astro\\.com\\.my",
        uxf: "",
        contentGuide: "content\\.com\\.my",
        legacy: "astro\\.com\\.my\\/(?!fibre|bm)."
      },
      enabledPortals: [],
      dismissDuration: 1440,
      timerUnits: {
        fullForm: { day: "", hour: "", minute: "", second: "", separator: "" },
        shortForm: { day: "", hour: "", minute: "", second: "", separator: "" }
      },
      modal: {
        endpoint: "",
        bcpV3Endpoint: "https://contenthub-api.eco.astro.com.my/bcp/v3/entry-modal-en.json"
      }
    },
    chatbot: {
      hiddenPortals: []
    }
  },
  footer: {
    groups: [],
    complaint: { name: "", url: "", src: "" },
    contacts: {
      headingHtml: "",
      socials: []
    },
    mobileApps: {
      heading: "",
      apps: []
    },
    documentLinks: [],
    copyrightHtml: ""
  },
  liveChat: {
    chatEndpoint: "",
    chatCodes: [],
    scrollHeightToShowBubble: 400,
    idleSecondsToShowBubble: 30,
    icon: { src: "", alt: "" },
    helpText: "",
    bubbleTitle: "",
    bubbleDescription: ""
  }
});
function useNavConfig({
  endpoint,
  environment = "production",
  locale = DEFAULT_LOCALE,
  portal = "acm"
}) {
  var _a;
  const { data: df } = useDfConfig(endpoint || ((_a = presetEndpoints[portal]) == null ? void 0 : _a[environment]), [
    "header_v2",
    "footer",
    "live_chat"
  ]);
  if (df) {
    const { locales: headerLocales = {}, ...rawHeaderDf } = df[0];
    const headerDf = mergeLocale(rawHeaderDf, headerLocales[locale]);
    const headerConfig = { ...headerDf };
    headerConfig.utility.languageOptions = headerDf.utility.languageOptions.reduce((acc, { locale: optionLocale, ...option }) => {
      if (isSupportedLocale(optionLocale)) acc.push({ locale: optionLocale, ...option });
      return acc;
    }, []);
    const { locales: footerLocales = {}, ...rawFooterDf } = df[1];
    const footerConfig = mergeLocale(rawFooterDf, footerLocales[locale]);
    const { locales: liveChatLocales = {}, ...rawLiveChatDf } = df[2];
    const liveChatDf = mergeLocale(rawLiveChatDf, liveChatLocales[locale]);
    const liveChatConfig = { ...liveChatDf };
    liveChatConfig.chatCodes = liveChatDf.chatCodes.map(({ code, regex }) => ({
      code: code ?? liveChatDf.defaultChatCode,
      regex
    }));
    return {
      header: headerConfig,
      footer: footerConfig,
      liveChat: liveChatConfig
    };
  }
  return fallbackData(portal);
}
const NavProvider = ({ children, dfEndpoint, environment, onLocaleChange, portal }) => {
  const [locale, setLocale] = useState(DEFAULT_LOCALE);
  const config = useNavConfig({ portal, environment, endpoint: dfEndpoint, locale });
  useEffect(() => {
    const localeEventHandler = (e) => {
      const updatedLocale = e.detail;
      if (updatedLocale && isSupportedLocale(updatedLocale)) {
        setLocale(updatedLocale);
        onLocaleChange == null ? void 0 : onLocaleChange(updatedLocale);
      }
    };
    window.addEventListener(LOCALE_EVENT, localeEventHandler);
    return () => {
      window.removeEventListener(LOCALE_EVENT, localeEventHandler);
    };
  }, [onLocaleChange]);
  useEffect(() => {
    let preferredLocale = getCookie(LOCALE_COOKIE);
    if (!preferredLocale) {
      const [localeUrlSegment] = window.location.pathname.split("/").slice(1);
      preferredLocale = localeUrlSegment;
    }
    toggleLocale(preferredLocale);
  }, []);
  return typeof children === "function" ? children({ config, locale, environment }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children });
};
export {
  ABANDONED_CART_COOKIE,
  ACCESS_TOKEN_COOKIE,
  AccountIcon,
  AddOnPopup,
  ArrowIcon,
  AstroBoxPopup,
  BANNER_DISMISSED_COOKIE,
  Badge,
  BroadbandCard,
  BurgerMenuIcon$1 as BurgerMenuIcon,
  Button,
  CHATBOT_USER_INFO,
  Callout,
  Checkbox,
  CloseButton,
  CloseIcon,
  Collapse,
  DEFAULT_LOCALE,
  ExploreIcon,
  Footer,
  Header$1 as Header,
  Header as HeaderV2,
  HtmlText,
  IconButton,
  LOCALE_COOKIE,
  LOCALE_EVENT,
  LOGIN_URL_EVENT,
  LanguageIcon,
  Link,
  LiveChat,
  MODAL_BANNER_DISMISSED_COOKIE,
  Modal,
  NAV_TAG,
  NavProvider$1 as NavProvider,
  NavProvider as NavProviderV2,
  Normalizer,
  PackCard,
  PlusIcon,
  ProductCard,
  ProductPopup,
  REFRESH_TOKEN_COOKIE,
  RadioGroup,
  SUPPORTED_LOCALES,
  SearchIcon,
  Status,
  Switch,
  TickIcon,
  ULM_EPUID_COOKIE,
  ULM_HANDLER_TRIGGERED_COOKIE,
  ULM_PAYLOAD_COOKIE,
  ULM_PROFILE_EVENT,
  ULM_UUID_COOKIE,
  UPDATE_CART_EVENT,
  cn,
  convertLocale$1 as convertLocale,
  createBemName,
  dispatchUlmProfileEvent,
  endChatbotSession,
  extractConfig,
  fetcher,
  getCookie,
  getCookieDomain,
  getErrorResponse,
  gtmPush,
  hasExistingSession,
  initLoginUrl,
  interpolate,
  isApiResponse,
  isErrorResponse,
  isSupportedLocale,
  isUlmProfile,
  logger,
  logout,
  mergeLocale,
  normalizeElementsHeight,
  refreshSession,
  removeCookie,
  removeCookies,
  resetCart,
  resizeImage,
  satayCase,
  setCookie,
  startChatbotSession,
  toggleLocale,
  updateCart,
  useAsync,
  useBoolean,
  useBreakpoint,
  useConst,
  useDfConfig,
  useNavConfig$1 as useNavConfig,
  useNavConfig as useNavConfigV2,
  useOrientation,
  useUrlWithUtmQuery
};
